window.object_name = "ThirdLove",
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                jwplayer: ".jwplayer",
                hero_video: ".hero-video",
                open_hero_video: ".open-hero-video",
                close_hero_video: ".close-hero-video"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                vendors: {
                    _jwplayer_load: function(t) {
                        var o = {
                            element: "",
                            ID: "",
                            file: "",
                            image: "",
                            width: "100%",
                            controls: !1,
                            autostart: !0,
                            mute: !0,
                            stretching: "fill",
                            wmode: "transparent",
                            repeat: !1
                        };
                        t = e.extend(!0, o, t), t.element.length && t.ID.length && (t.file = t.file.length ? t.file : t.element.data("media-url"), t.image = t.image.length ? t.image : t.element.data("poster-url"), window.jwplayer.key = "gZBSQZ/ZCDkqojMRzzLopbyg3kC7bw/OKn9HgQ==", window.jwplayer(t.ID).setup(t))
                    },
                    _jwplayer_control: function(e, t) {
                        var o = window.jwplayer(t);
                        switch (e) {
                            case "play":
                                o.play();
                                break;
                            case "pause":
                                o.pause();
                                break;
                            case "stop":
                                o.stop()
                        }
                    },
                    _jwplayer_setup: function() {
                        var t = e(".jwplayer").last();
                        if (t.length) {
                            if (o.methods.mobile._is_browser_mobile()) return void t.remove();
                            e("video").remove(), t.each(function() {
                                var t = e(this);
                                o.methods.vendors._jwplayer_load({
                                    element: t,
                                    ID: t.attr("id"),
                                    repeat: !0,
                                    autostart: !0
                                })
                            })
                        }
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click._open_hero_video": {
                    element: t.elements.open_hero_video,
                    action: t.methods.vendors._open_hero_video
                }
            })
        }), t.on(window.object_name + "._jwplayer_load", function() {
            var e = window[window.object_name];
            e.methods.vendors._jwplayer_setup()
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = {
                REGULAR: ".json",
                EXTENDED: "?view=json"
            };
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                window: window,
                document: document,
                html: "html",
                body: "body",
                header: "header",
                footer: "footer",
                back_to_top: ".back-to-top",
                stop_propagation: ".stop-propagation"
            })
        }), t.on(window.object_name + ".add_methods", function(t, i) {
            i.methods._add("methods", {
                productInfoType: o,
                _scroll_to: function(e, t) {
                    i.elements.body.add(i.elements.html).animate({
                        scrollTop: e
                    }, {
                        duration: t,
                        easing: "easeOutQuint"
                    })
                },
                _back_to_top: function(e) {
                    e.preventDefault(), i.methods._scroll_to(0, 750)
                },
                _keydown_events: function(e) {
                    var t = e.keyCode;
                    switch (t) {
                        case 27:
                            i.elements.body.trigger(window.object_name + "._html_esc")
                    }
                },
                _html_click_events: function() {
                    i.elements.window.trigger(window.object_name + "._html_click", i)
                },
                _stop_propagation: function(e) {
                    e.stopPropagation()
                },
                _get_query_params: function() {
                    return document.location.search.replace("?", "").split("&").reduce(function(e, t) {
                        if (!t) return e;
                        var o = t.split("="),
                            i = o[0],
                            n = decodeURIComponent(o[1]);
                        return e[i] ? Array.isArray(e[i]) ? e[i].push(n) : e[i] = [e[i], n] : e[i] = n, e
                    }, {})
                },
                _get_product: function(t, i) {
                    return i = i || o.EXTENDED, e.get("/products/" + t + i).done(function(e) {
                        return e
                    }).fail(function(e) {
                        return e
                    })
                },
                _get_products: function(t, n, a) {
                    a = a || o.EXTENDED;
                    var s = [],
                        r = [];
                    e.each(t, function(t, n) {
                        var d = new e.Deferred;
                        s.push(d), i.methods._get_product(n, a).complete(function(e, t) {
                            "success" === t && (a === o.EXTENDED ? r.push(JSON.parse(e.responseText)) : r.push(e.responseJSON.product)), d.resolve()
                        })
                    }), e.when.apply(e, s).done(function() {
                        n(r)
                    })
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click._back_to_top": {
                    element: t.elements.back_to_top,
                    action: t.methods._back_to_top
                },
                "keydown._keydown_events": {
                    element: t.elements.html,
                    action: t.methods._keydown_events
                },
                "click._html_click_events": {
                    element: t.elements.html,
                    action: t.methods._html_click_events
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.elements.body.delegate(".stop-propagation", "click._stop_propagation", t.methods._stop_propagation)
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                foo: "body"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                mobile: {
                    _is_browser_mobile: function() {
                        var e = !1;
                        return function(t) {
                            (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0)
                        }(navigator.userAgent || navigator.vendor || window.opera), e
                    },
                    _set_mobile: function() {
                        var t = o.methods.mobile._is_browser_mobile();
                        t ? e("body").addClass("mobile") : e("body").removeClass("mobile")
                    },
                    _is_mobile: function(t) {
                        if (!t) {
                            var i = "object" != typeof o.elements.body ? e("body") : o.elements.body;
                            if (i.hasClass("mobile")) return !0
                        }
                        return t = t ? t : 320, window.innerWidth <= t
                    },
                    _is_width: function(e, t) {
                        switch (e = e ? e : 991, t = t ? t : "smaller", e) {
                            case "screen-lg":
                                e = 1200;
                                break;
                            case "screen-md":
                                e = 992;
                                break;
                            case "screen-sm":
                                e = 768;
                                break;
                            case "screen-xs":
                                e = 480;
                                break;
                            default:
                                e = 480
                        }
                        switch (t) {
                            case "larger":
                                if (window.innerWidth >= e) return !0;
                                break;
                            case "smaller":
                                if (window.innerWidth < e) return !0;
                                break;
                            default:
                                if (window.innerWidth < e) return !0
                        }
                        return !1
                    },
                    is_ipad: function() {
                        var e = navigator.userAgent || navigator.vendor || window.opera;
                        return /iPad/i.test(e)
                    }
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.methods.mobile._set_mobile()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                master_col: ".master-col",
                slave_col: ".slave-col",
                img_col: ".img-col",
                balance: '[data-layout="balance"]'
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                align_cols: function() {
                    var t = 1024 / 919,
                        i = e(o.elements.img_col).width();
                    e(o.elements.img_col).hasClass("product-images") && (i *= t), o.elements.slave_col.each(function() {
                        var t, o = e(this),
                            n = o.parents(".row").find(".master-col");
                        n.length && (t = i > n.outerHeight() ? i : n.outerHeight(), o.css("min-height", t), o.filter(".set-height").removeAttr("style").css("height", t).css("min-height", t))
                    })
                },
                balance_cols: function() {
                    o.elements.balance.each(function() {
                        var t = e(this),
                            i = t.children('[data-layout="col"]');
                        i.css("height", ""), t.hasClass("no-mobile-adjust") && o.methods.mobile._is_mobile(992) || i.css("height", parseInt(t.innerHeight(), 10) - parseInt(t.css("paddingTop"), 10))
                    })
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                align_cols: {
                    element: t.elements.window,
                    action: t.methods.align_cols
                },
                "resize.lineup_discover_cols": {
                    element: t.elements.window,
                    action: t.methods.align_cols
                },
                "resize.balance_cols": {
                    element: t.elements.window,
                    action: t.methods.balance_cols
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.methods.align_cols(), t.methods.balance_cols()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                smooth_scroll: "a[href*=#]"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            window[window.object_name].properties.smooth_scroll = null, window[window.object_name].properties.smooth_scroll_timeout = null, o.methods._add("methods", {
                smooth_scroll: function(t) {
                    var i = e(this),
                        n = i.attr("href");
                    if (0 === n.indexOf("#")) {
                        t.preventDefault();
                        var a = e(n),
                            s = 0;
                        if (window.innerHeight <= 992 && (s = 50), a.length) {
                            var r = 30,
                                d = a.offset().top + s - o.elements.nav_header.outerHeight() - r,
                                l = o.elements.sticky_sub_nav;
                            l.length > 0 && (d = d - s - l.height() + r, l.find(".tab-list").children().first().is(i.parent()) && window.scrollY > d && (d += l.height()), l.addClass("page-subnav--scrolling"), e(".tab-list__tab").removeClass("tab-list__tab--active"), i.parent().addClass("tab-list__tab--active")), e("html, body").animate({
                                scrollTop: d
                            }, 750), window[window.object_name].properties.smooth_scroll = !0, window[window.object_name].properties.smooth_scroll_timeout = setTimeout(function() {
                                window[window.object_name].properties.smooth_scroll = !0, l.length > 0 && l.removeClass("page-subnav--scrolling")
                            }, 750)
                        }
                    }
                },
                stop_smooth_scroll: function(t) {
                    window[window.object_name].properties.smooth_scroll && (t.which > 0 || "mousedown" === t.type || "mousewheel" === t.type) && (e("html, body").stop(), window[window.object_name].properties.smooth_scroll = !1, window[window.object_name].properties.smooth_scroll_timeout && clearTimeout(window[window.object_name].properties.smooth_scroll_timeout))
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click.smooth_scroll": {
                    element: t.elements.smooth_scroll,
                    action: t.methods.smooth_scroll
                },
                stop_smooth_scroll: {
                    event: "scroll mousedown DOMMouseScroll mousewheel keyup",
                    element: t.elements.window,
                    action: t.methods.stop_smooth_scroll
                }
            })
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                _align_elements: function() {
                    e('[data-layout="align-heights"]').each(function() {
                        var t = e(this),
                            i = t.find('[data-ah="main-element"]'),
                            n = t.find('[data-ah="height-1"]'),
                            a = t.find('[data-ah="height-2"]');
                        if (i.css("height", ""), n.css("height", ""), a.css("height", ""), !t.hasClass("no-mobile-adjust") || !o.methods.mobile._is_mobile(991)) {
                            var s = o.methods._calc_element_h(n),
                                r = o.methods._calc_element_h(a),
                                d = parseInt(a.css("marginTop"), 10);
                            d = d ? d : 0, i.css("height", s + r + d), a.css("height", r - d)
                        }
                    })
                },
                _calc_element_h: function(t) {
                    var o = 0;
                    return t.each(function() {
                        var t = e(this),
                            i = parseInt(t.outerHeight(!0), 10);
                        i > o && (o = i)
                    }), o
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "resize._align_elements": {
                    element: t.elements.window,
                    action: t.methods._align_elements
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.methods._align_elements()
        })
    }(jQuery),
    function(e) {
        function t(e) {
            if (e) {
                var t = e.split("(");
                t.length > 0 && (e = t[0].trim())
            } {
                if (!k) return e;
                if (window.tlProductsSizes.cups.indexOf(e) !== -1) return e
            }
        }

        function o(e) {
            return Cookies.get(e)
        }

        function i(e) {
            var i = o(e);
            return t(i)
        }

        function n(e) {
            var t = o(e);
            return "XXL" === t && (t = t.replace("XXL", "1X")), t
        }

        function a(e) {
            return Cookies.getJSON(e)
        }

        function s(e, t, o) {
            Cookies.set(e, t, {
                expires: o || b
            })
        }
        var r = e(window),
            d = "_tl_persona_band_size",
            l = "_tl_persona_cup_size",
            c = "_tl_persona_underwear_size",
            _ = "_tl_persona_true_size_loaded",
            u = "_tl_persona_true_size_band_size",
            m = "_tl_persona_true_size_cup_size",
            p = "_tl_persona_true_size_underwear_size",
            h = "_tl_ff_my_fit",
            f = "_tl_persona_true_size_id",
            v = "_tl_device_auth_token",
            w = "2",
            g = 1,
            b = 365,
            y = e.Deferred(),
            z = e.Deferred(),
            C = e.Deferred(),
            k = !(!window.tlProductsSizes || !window.tlProductsSizes.cups);
        r.on(window.object_name + ".add_methods", function(r, b) {
            b.methods._add("methods", {
                persona: {
                    loaded: function() {
                        return C.promise()
                    },
                    getBand: function() {
                        return o(d)
                    },
                    getCup: function() {
                        return i(l)
                    },
                    getBraSize: function() {
                        var e = this.getBand(),
                            t = this.getCup();
                        return e && t ? e + t : void 0
                    },
                    getTrueSizeBand: function() {
                        return o(u)
                    },
                    getTrueSizeCup: function() {
                        return i(m)
                    },
                    getTrueSizeBraSize: function() {
                        var e = this.getTrueSizeBand(),
                            t = this.getTrueSizeCup();
                        return e && t ? e + t : void 0
                    },
                    getUnderwearSize: function() {
                        return n(c)
                    },
                    getTrueSizeUnderwearSize: function() {
                        return n(p)
                    },
                    getFFResults: function() {
                        return y.then(function() {
                            return b.methods.persona._getFFResults()
                        })
                    },
                    _getFFResults: function() {
                        var t = o(h);
                        if (!t) return e.Deferred().reject();
                        var i = new e.Deferred;
                        return window.Parse.Cloud.run("getFitFinderData", {
                            objectId: t
                        }).then(i.resolve).fail(i.reject), i.promise()
                    },
                    storeCup: function(e) {
                        s(l, e)
                    },
                    storeBand: function(e) {
                        s(d, e)
                    },
                    storeUnderwearSize: function(e) {
                        s(c, e)
                    },
                    getTrueSizeId: function() {
                        return o(f)
                    },
                    storeTrueSizeId: function(e) {
                        s(f, e)
                    },
                    storeFFResultsId: function(e) {
                        s(h, e, 120)
                    },
                    getFFResultsId: function() {
                        return o(h)
                    },
                    getDeviceToken: function() {
                        return a(v)
                    },
                    restoreCookies: function(e) {
                        var t = !1;
                        e.braBand && e.braBand !== b.methods.persona.getTrueSizeBand() && (t = !0, b.methods.persona.storeBand(e.braBand), b.methods.persona._storeTrueSizeBand(e.braBand)), e.braCup && e.braCup !== b.methods.persona.getTrueSizeCup() && (t = !0, b.methods.persona.storeCup(e.braCup), b.methods.persona._storeTrueSizeCup(e.braCup)), e.underwearSize && e.underwearSize !== b.methods.persona.getTrueSizeUnderwearSize() && (t = !0, b.methods.persona.storeUnderwearSize(e.underwearSize), b.methods.persona._storeTrueSizeUnderwearSize(e.underwearSize)), e.ffResultId && e.ffResultId !== b.methods.persona.getFFResultsId() && (t = !0, b.methods.persona.storeFFResultsId(e.ffResultId)), e.trueSizeId && e.trueSizeId !== b.methods.persona.getTrueSizeId() && (t = !0, b.methods.persona.storeTrueSizeId(e.trueSizeId)), t && window.location.reload()
                    },
                    isTrueSizeLoaded: function() {
                        return Cookies.get(_) === w
                    },
                    loadTrueSize: function(t) {
                        return e.when(y, z).then(function() {
                            var o = e.Deferred(),
                                i = {};
                            if (t) i.objectId = t;
                            else if (heap.identity) {
                                var n = b.methods.persona.getDeviceToken();
                                e.isEmptyObject(n) || (i = e.extend(i, n), i.email = heap.identity)
                            }
                            return Object.keys(i).length > 0 ? window.Parse.Cloud.run("getTrueSize", i).then(function(e) {
                                var t = {};
                                e && e.data && (e.data.trueSizeId = e.data.objectId, b.methods.persona.restoreCookies(e.data), t = e.data), o.resolve(t)
                            }).fail(o.resolve) : o.resolve(), o.promise()
                        }).fail(function() {
                            return e.Deferred().resolve()
                        }).always(function() {
                            s(_, w, g)
                        })
                    },
                    updateTrueSize: function(o) {
                        if (o = o || {}, 0 === Object.keys(o).length) return e.Deferred.resolve();
                        if (o.braBand && this._storeTrueSizeBand(o.braBand), o.braCup) {
                            var i = t(o.braCup);
                            i && this._storeTrueSizeCup(i)
                        }
                        return o.underwearSize && this._storeTrueSizeUnderwearSize(o.underwearSize), this.saveTrueSize()
                    },
                    saveTrueSize: function() {
                        return y.then(function() {
                            return z
                        }).then(function() {
                            var t = e.Deferred(),
                                i = window.heap.identity;
                            if (i) {
                                var n = {
                                    email: i,
                                    braBand: b.methods.persona.getTrueSizeBand(),
                                    braCup: b.methods.persona.getTrueSizeCup(),
                                    underwearSize: b.methods.persona.getTrueSizeUnderwearSize(),
                                    ffResultId: o(h)
                                };
                                window.Parse.Cloud.run("saveTrueSize", n).always(t.resolve)
                            } else t.resolve();
                            return t.promise()
                        })
                    },
                    loadFFData: function(t) {
                        return y.then(function() {
                            var o = e.Deferred();
                            return window.Parse.Cloud.run("getFitFinderData", {
                                objectId: t
                            }).then(function(e) {
                                var t = {};
                                e && e.data && (b.methods.persona.restoreCookies({
                                    braBand: e.data.result_size.slice(0, 2),
                                    braCup: e.data.result_size.slice(2),
                                    underwearSize: e.data.underwear_size,
                                    ffResultId: e.data.objectId
                                }), t = e.data), o.resolve(t)
                            }).fail(o.reject), o.promise()
                        })
                    },
                    _storeTrueSizeCup: function(e) {
                        s(m, e)
                    },
                    _storeTrueSizeBand: function(e) {
                        s(u, e)
                    },
                    _storeTrueSizeUnderwearSize: function(e) {
                        s(p, e)
                    }
                }
            })
        }), r.on(window.object_name + "._document_ready", function(t, o) {
            window.onPropertyAvailablePromise(window, "ParseInitialized", {
                deferred: y
            }), window.onPropertyAvailablePromise(window, "heap.identity", {
                deferred: z
            });
            var i = o.methods._get_query_params() || {},
                n = i.emarsys_uid,
                a = i.true_size_id,
                s = e.Deferred().resolve();
            a ? s = o.methods.persona.loadTrueSize(i.true_size_id) : n ? s = o.methods.persona.loadFFData(i.emarsys_uid) : o.methods.persona.isTrueSizeLoaded() || (s = o.methods.persona.loadTrueSize()), (n || a) && s.then(function(e) {
                e && e.email && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                    event: "crossSession",
                    email: e.email
                }))
            }), s.always(C.resolve)
        })
    }(jQuery),
    function(e) {
        function t(e) {
            return function(t) {
                var o = t.SC,
                    i = t.render;
                if (!o || !o.page || !o.page.products || 0 === o.page.products.length) throw new Error("No recommended products were returned");
                "function" == typeof e.preRenderHook && e.preRenderHook(o), e.renderResults && i(o)
            }
        }

        function o(e) {
            window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                emarsysRecommendCommandOpts: void 0
            }), window.dataLayer.push({
                event: "getRecommendation",
                emarsysRecommendCommandOpts: e
            })
        }

        function i(i) {
            i = i || {}, i.renderResults = "boolean" != typeof i.renderResults || i.renderResults, i.success = "function" == typeof i.success ? i.success : t(i);
            var n = e.Deferred(),
                l = i.containerId || "",
                c = "callback" + (l ? "-" + l : ""),
                _ = {
                    logic: i.logic || a,
                    limit: i.limit || s,
                    containerId: l,
                    templateId: i.templateId || "",
                    templateStr: i.templateStr || "",
                    callback: c,
                    filters: Array.isArray(i.filters) ? i.filters : []
                };
            window.Emarsys = window.Emarsys || {}, window.Emarsys.callbacks = window.Emarsys.callbacks || {};
            var u = i.timeout || r,
                m = setTimeout(function() {
                    n.reject("Timeout waiting for Emarsys response")
                }, u);
            return window.Emarsys.callbacks[c] = function(e, t) {
                if (clearTimeout(m), e) throw new Error("Error from Emarsys: " + JSON.stringify(e));
                try {
                    i.success.call(null, t), n.resolve(t)
                } catch (o) {
                    n.reject(o)
                }
                delete window.Emarsys.callbacks[c]
            }, d.then(function() {
                return o(_), n.promise()
            })
        }
        var n = {
                PERSONAL: "PERSONAL",
                CART: "CART",
                HOME: "HOME"
            },
            a = n.PERSONAL,
            s = 3,
            r = 5e3,
            d = e.Deferred(),
            l = e(window);
        l.on(window.object_name + ".add_methods", function(e, t) {
            t.methods._add("methods", {
                emarsys: {
                    getRecommendations: i,
                    logicTypes: n
                }
            })
        }), l.on(window.object_name + "._document_ready", function() {
            window.onPropertyAvailablePromise(window, "ScarabQueue", {
                deferred: d
            })
        })
    }(jQuery),
    function() {
        function e(e) {
            this._sizesByStyle = e.sizesByStyle, this._stylesBySize = {}, this._setupStylesBySizes(e)
        }

        function t(t) {
            return new e(t)
        }
        e.prototype._setupStylesBySizes = function(e) {
            var t = e.sizesByStyle,
                o = {};
            if (!t) return console.log("[recommendations] Missing sizes by style configuration");
            var i = Object.keys(t);
            i.forEach(function(e) {
                var i = t[e];
                i.forEach(function(t) {
                    o[t] || (o[t] = []), o[t].push(e)
                })
            }), this._stylesBySize = o
        }, e.prototype.getStylesByBraSize = function(e) {
            return this._stylesBySize[e]
        }, $(window).on(window.object_name + ".add_methods", function(e, o) {
            o.methods._add("methods", {
                recommendations: {
                    create: t
                }
            })
        })
    }(),
    function(e) {
        function t(e) {
            for (var t = !0, o = 0; o < e.length; o++)
                if ("undefined" == typeof Cookies.get(e[o])) {
                    t = !1;
                    break
                } return t
        }

        function o() {
            var o = e(".parent-of-submenu.my-shop"),
                i = e(".parent-of-submenu.find-my-fit"),
                n = e(".parent-of-submenu.my-fit"),
                a = e(".my-shop-AB"),
                s = e(window.ffClass),
                r = e(window.myClass);
            Cookies.get(z) ? window.showMyShopInsteadOfMyFit ? (a.show(), o.hide(), s.hide(), i.hide(), r.hide(), n.show()) : (a.hide(), o.show(), s.hide(), i.hide(), r.show()) : (a.hide(), s.show(), i.show(), r.hide(), n.hide(), t(C) ? o.show() : o.hide())
        }

        function i(e) {
            var t = e.data("product");
            return t ? t.replace("+", "\\+") : ""
        }

        function n(t) {
            t.preventDefault();
            var o = e(t.target).parent(".menu-link");
            if (o = o.length ? o : e(t.target)) {
                var n = i(o);
                if (n.length > 0) {
                    var a = e(w + n);
                    return a.length ? a : void 0
                }
            }
        }

        function a() {
            var t = e(".style-image-container.default"),
                o = e(".menu-link.active");
            if (o.length) {
                var n = i(o);
                if (n.length > 0) {
                    var a = e(w + n);
                    if (a.length) return a
                }
            }
            return t.length ? t : void 0
        }

        function s(t, o) {
            var i = n(t);
            if (i) {
                var s = a();
                if (s && i.selector === s.selector) return;
                e(v).hide(), s && s.toggle(!o), i.toggle(o)
            }
        }

        function r() {
            window.innerWidth >= g && e(".column:has(div.menu-blog-articles)").addClass("reel")
        }

        function d() {
            e(".sub-nav-item .menu-link").hover(function(e) {
                s(e, !0)
            }, function(e) {
                s(e, !1)
            });
            var t = a();
            t && t.show()
        }

        function l() {
            var e = window.tlMenuSettings || {},
                t = window.isMobile && window.isMobile();
            if (!t && e.enableTbbBtnDesktop) {
                var o = document.querySelector("nav.header .nav--fit-container");
                o.style.visibility = "visible"
            }
        }

        function c() {
            var e = window.tlMenuSettings || {},
                t = function(t) {
                    (t || e.showTbbBtnOnDesktop || e.showTbbBtnOnMobile) && l()
                };
            window.onCountryInfoAvailable(function(e, o) {
                return e ? console.error("Unable to update footer. Reason: ", e) : void t(o.isFromUS)
            })
        }

        function _() {
            var e = window.tlMenuSettings || {};
            e.showTbbButton && (e.enableTbbBtnDesktop && e.verifyLocationTbbBtnDesktop || e.enableTbbBtnMobile && e.verifyLocationTbbBtnMobile ? c() : (e.enableTbbBtnDesktop || e.enableTbbBtnMobile) && l())
        }

        function u() {
            window.location.hash.includes("#/results") && m([z], o, o)
        }

        function m(e, o, i) {
            var n = !1,
                a = setInterval(function() {
                    t(e) && (o(), clearInterval(a), n = !0)
                }, b);
            setTimeout(function() {
                n || (clearInterval(a), i())
            }, y)
        }

        function p() {
            window.HashChangeEvent && window.addEventListener("hashchange", u)
        }

        function h() {
            m(C, o, o)
        }
        var f = e(window),
            v = ".menu-type-desktop .style-item",
            w = v + ".",
            g = 1024,
            b = 100,
            y = 1e4,
            z = "_tl_ff_my_fit",
            C = ["_tl_persona_true_size_band_size", "_tl_persona_true_size_cup_size"];
        f.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                html: "html",
                sidecar_toggle: '[data-action="sidecar-toggle"]',
                hamburger: "nav .hamburger",
                search_open: '[data-action="search-open"]',
                search_close: '[data-action="search-close"]',
                search_field: 'nav.header .search input[type="text"]',
                nav_holder: ".nav-holder",
                nav_header: "nav.header",
                dropdown_menu: ".parent-of-submenu > a",
                downArrow: ".parent-of-submenu .sub-menu-arrow-down",
                upArrow: ".parent-of-submenu .sub-menu-arrow-up",
                my_fit_button: ".my-fit-button",
                hero_above_sub_nav: ".page-hero",
                sticky_sub_nav: ".page-subnav"
            })
        }), f.on(window.object_name + ".add_methods", function(t, i) {
            i.methods._add("methods", {
                _sidecar_toggle: function() {
                    o(), i.elements.body.toggleClass("sidecar-open"), i.elements.hamburger.toggleClass("close"), i.elements.html.toggleClass("overflow-y")
                },
                _sidecar_close: function() {
                    i.elements.body.removeClass("sidecar-open"), i.elements.hamburger.removeClass("close"), i.elements.html.removeClass("overflow-y")
                },
                _search_open: function() {
                    i.elements.body.addClass("search-open"), i.elements.search_field.focus()
                },
                _search_close: function() {
                    i.elements.body.removeClass("search-open"), i.elements.search_field.val("")
                },
                _nav_positioning: function() {
                    var t = i.elements.nav_holder.offset().top,
                        o = window.scrollY;
                    if (o > t ? (i.elements.nav_header.addClass("fixed"), i.elements.body.addClass("nav-fixed")) : (i.elements.nav_header.removeClass("fixed"), i.elements.body.removeClass("nav-fixed")), i.elements.sticky_sub_nav.length > 0) {
                        var n = i.elements.nav_header.height(),
                            a = i.elements.sticky_sub_nav.height(),
                            s = i.elements.hero_above_sub_nav.offset().top + i.elements.hero_above_sub_nav.height(),
                            r = {},
                            d = "";
                        i.elements.sticky_sub_nav.find(".tab-list-content").each(function() {
                            var t = e(this).attr("href");
                            r[t] || (r[t] = e(t).offset().top)
                        }), o >= s - n ? (i.elements.sticky_sub_nav.addClass("page-subnav--fixed"), i.elements.nav_header.addClass("fixed--subnav")) : (i.elements.sticky_sub_nav.removeClass("page-subnav--fixed"), i.elements.nav_header.removeClass("fixed--subnav"));
                        for (target in r) r.hasOwnProperty(target) && o >= r[target] - n - a - 1 && (d = target);
                        i.elements.sticky_sub_nav.hasClass("page-subnav--scrolling") || i.elements.sticky_sub_nav.find(".tab-list-content").each(function() {
                            var t = e(this);
                            t.parent().toggleClass("tab-list__tab--active", t.attr("href") === d)
                        })
                    }
                },
                _toggle_dropdown_menu: function(t) {
                    var o = e(this),
                        i = o.parent();
                    i.hasClass("menu-prevent-toggle") || (i.toggleClass("menu-expanded"), o.siblings("ul:last-child").slideToggle("slow"))
                },
                _show_my_fit: function(t) {
                    t.preventDefault();
                    var o = e("#fit-finder");
                    o.length || (window.location.href = this.href)
                }
            })
        }), f.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click._sidecar_toggle": {
                    element: t.elements.sidecar_toggle,
                    action: t.methods._sidecar_toggle
                },
                sidecar_close_html: {
                    event: window.object_name + "._html_click",
                    element: t.elements.window,
                    action: t.methods._sidecar_close
                },
                sidecar_close_esc: {
                    event: window.object_name + "._html_esc",
                    element: t.elements.window,
                    action: t.methods._sidecar_close
                },
                "click._search_open": {
                    element: t.elements.search_open,
                    action: t.methods._search_open
                },
                "click._search_close": {
                    element: t.elements.search_close,
                    action: t.methods._search_close
                },
                search_close_esc: {
                    event: window.object_name + "._html_esc",
                    element: t.elements.window,
                    action: t.methods._search_close
                },
                scroll_nav_positioning: {
                    event: "scroll._nav_positioning",
                    element: t.elements.window,
                    action: t.methods._nav_positioning
                },
                resize_nav_positioning: {
                    event: "resize._nav_positioning",
                    element: t.elements.window,
                    action: t.methods._nav_positioning
                },
                "click._toggle_dropdown_menu": {
                    element: t.elements.dropdown_menu,
                    action: t.methods._toggle_dropdown_menu
                },
                "click._show_my_fit": {
                    event: "click._show_my_fit",
                    element: t.elements.my_fit_button,
                    action: t.methods._show_my_fit
                }
            })
        }), f.on(window.object_name + "._document_ready", function(e, t) {
            t.methods._nav_positioning(), o(), _(), d(), r(), p(), h()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                tab_nav: ".tab-nav > li"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            window[window.object_name].properties.tab_animating = !1, o.methods._add("methods", {
                switch_tabs: function() {
                    if (!window[window.object_name].properties.tab_animating) {
                        var t = e(this),
                            o = t.parents("ul.tab-nav").first(),
                            i = o.find("> li"),
                            n = o.next(".tabs-contain"),
                            a = n.find(".tab"),
                            s = a.filter(".active"),
                            r = i.index(i.filter(".active")),
                            d = i.index(t),
                            l = a.eq(d);
                        if (l.length && !l.hasClass("active")) {
                            window[window.object_name].properties.tab_animating = !0, i.removeClass("active"), t.addClass("active");
                            var c = null;
                            switch (c = r < d ? "slide-left" : "slide-right", s.removeClass("slide-left slide-right").addClass(c), c) {
                                case "slide-left":
                                    c = "slide-right";
                                    break;
                                case "slide-right":
                                    c = "slide-left"
                            }
                            l.removeClass("slide-left slide-right").addClass(c), s.css({
                                position: "absolute",
                                opacity: 0
                            }), l.css({
                                display: "block",
                                position: "relative"
                            }), n.css({
                                height: "auto"
                            }), setTimeout(function() {
                                l.removeClass("slide-left slide-right").addClass("active")
                            }, 10), setTimeout(function() {
                                a.not(l).removeClass("active").attr("style", ""), window[window.object_name].properties.tab_animating = !1
                            }, 350)
                        }
                    }
                },
                set_tabs_contain_height: function() {
                    var t = e(".tabs-contain").filter(":visible");
                    t.each(function() {
                        var t = e(this);
                        !t.parents(".tabs").hasClass("mobile") && o.methods.mobile._is_mobile(992) || t.css({
                            height: "auto"
                        })
                    })
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click.switch_tabs": {
                    element: t.elements.tab_nav,
                    action: t.methods.switch_tabs
                },
                "resize.set_tab_content_height": {
                    element: t.elements.window,
                    action: t.methods.set_tabs_contain_height
                },
                "load.set_tab_content_height": {
                    element: t.elements.window,
                    action: t.methods.set_tabs_contain_height
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.methods.set_tabs_contain_height()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                my_bag_open: '[data-action="my-bag-open"]',
                my_bag_close: '[data-action="my-bag-close"]',
                my_bag_cart_form: ".bag-actions",
                my_bag_contents: ".my-bag .bag-contents"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                my_bag: {
                    open: function() {
                        var t = o.elements.my_bag_cart_form.css("height");
                        o.elements.body.addClass("my-bag-open"), o.elements.html.addClass("overflow-y"), o.elements.my_bag_contents.css("bottom", t), e(document).trigger("my-bag-opened")
                    },
                    close: function() {
                        o.elements.body.removeClass("my-bag-open"), o.elements.html.removeClass("overflow-y")
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click.my_bag.open": {
                    element: t.elements.my_bag_open,
                    action: t.methods.my_bag.open
                },
                "click.my_bag.close": {
                    element: t.elements.my_bag_close,
                    action: t.methods.my_bag.close
                },
                "esc_my_bag.close": {
                    event: window.object_name + "._html_esc",
                    element: t.elements.window,
                    action: t.methods.my_bag.close
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            var o = t.methods._get_query_params();
            o && "1" === o.show_cart && t.methods.my_bag.open()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", t.methods.modal_elements())
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                open_modal: function(t, i) {
                    if (t && t.preventDefault && t.preventDefault(), "undefined" == typeof i) {
                        var n = e(this),
                            a = n.data("modal");
                        if (!a) return;
                        i = o.elements.modal.filter("#" + a)
                    }
                    if (i.length) {
                        var s = o.elements.modal.filter(".open").length;
                        s ? (o.methods.close_modal(), setTimeout(function() {
                            o.methods.animate_open(i)
                        }, 510)) : o.methods.animate_open(i)
                    }
                },
                transition_modal: function(t, i) {
                    if (t.preventDefault(), "undefined" == typeof i || !i.length) {
                        var n = e(this),
                            a = n.data("modal");
                        if (!a) return;
                        i = o.elements.modal.filter("#" + a)
                    }
                    o.methods.transition_open(i)
                },
                transition_open: function(e) {
                    o.elements.modals.find(".open").removeClass("open", 300), e.hide().addClass("open").fadeIn(250)
                },
                animate_open: function(t) {
                    e("html").addClass("overflow-y"), e(t).parent().css("display", "block"), setTimeout(function() {
                        o.elements.body.addClass("modal-open"), e(t).parent().addClass("modal-open"), t.addClass("open")
                    }, 50)
                },
                close_modal: function() {
                    e("html").removeClass("overflow-y"), o.elements.body.removeClass("modal-open"), e(".modals").removeClass("modal-open"), setTimeout(function() {
                        o.elements.modals.css("display", "none"), o.elements.modal.removeClass("open")
                    }, 300), o.methods.unset_modal_for_ipad()
                },
                unset_modal_for_ipad: function() {
                    o.elements.modals.removeClass("ipad-nursing"), document.ontouchmove = function() {
                        return !0
                    }
                },
                modal_elements: function() {
                    return {
                        modals: ".modals",
                        modal: ".modals .modal",
                        modal_open: '[data-action="modal-open"]',
                        modal_transition: '[data-action="modal-transition"]',
                        modal_close: '[data-action="modal-close"]'
                    }
                },
                modal_events: function() {
                    return {
                        "click.open_modal": {
                            element: o.elements.modal_open,
                            action: o.methods.open_modal
                        },
                        "click.transition_modal": {
                            element: o.elements.modal_transition,
                            action: o.methods.transition_modal
                        },
                        "click.close_modal": {
                            element: o.elements.modal_close,
                            action: o.methods.close_modal
                        },
                        esc_close_modal: {
                            event: window.object_name + "._html_esc",
                            element: o.elements.body,
                            action: o.methods.close_modal
                        }
                    }
                },
                cache_modal_elements: function() {
                    o.methods._remove_events(o.events), o.methods._add("elements", o.methods.modal_elements()), o.methods._cache_elements(o.elements), o.methods._add("events", o.methods.modal_events()), o.methods._setup_events(o.events)
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", t.methods.modal_events())
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = function() {
                function e(e) {
                    return e ? e.toString().replace(".5", s) : e
                }

                function t(e) {
                    return e.toString().replace(s, ".5")
                }

                function o(t) {
                    return t ? r[d.indexOf(t)].reduce(function(e, t, o) {
                        return null !== t && e.push(l[o]), e
                    }, []).map(e) : l.map(e)
                }

                function i() {
                    return d
                }

                function n(t) {
                    return {
                        hasMatch: t.length > 0,
                        results: t.map(e)
                    }
                }

                function a(e, o) {
                    var i = t(o),
                        a = d.indexOf(e),
                        s = l.indexOf(i);
                    if (s < 0 || a < 0) return n(null, null);
                    var c = r[a][s];
                    return n(c)
                }
                var s = "½",
                    r = [
                        [null, null, null, ["32C"], null, ["32C", "32C.5", "32D"], null, ["32D", "32D.5", "32E"], null, ["32E", "32F"],
                            ["32F"], null
                        ],
                        [null, ["34B"], null, ["34B", "34C"],
                            ["34B.5", "34C.5"],
                            ["34C", "34D"],
                            ["34C.5", "34D"],
                            ["34D", "34E"],
                            ["34D", "34E"],
                            ["34E", "34F"],
                            ["34F", "34G"],
                            ["34G"]
                        ],
                        [
                            ["36A"],
                            ["36A", "36B"],
                            ["36A.5", "36B.5"],
                            ["36B", "36C"],
                            ["36B.5", "36C"],
                            ["36C", "36D"],
                            ["36C", "36D"],
                            ["36D", "36E"], null, ["36E", "36F"],
                            ["36F"], null
                        ],
                        [null, ["36B", "38B"],
                            ["36B.5", "38B"],
                            ["38B", "38C"],
                            ["38B", "38C"],
                            ["38C", "38D"], null, ["38D", "38E"], null, ["38E"], null, null
                        ],
                        [null, ["38B", "38C"], null, ["38C", "40C"], null, ["40C"], null, ["38E"], null, null, null, null],
                        [null, null, null, ["40C", "42C"], null, ["42C"], null, null, null, null, null, null]
                    ],
                    d = ["30", "32", "34", "36", "38", "40"],
                    l = ["AA", "A", "A.5", "B", "B.5", "C", "C.5", "D", "D.5", "E", "F", "G"];
                return {
                    findSize: a,
                    getCupOptions: o,
                    getBandOptions: i
                }
            }();
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                calculate_now: "#calculate_now",
                nursing_results: "#nursing-results",
                nursing_resultSizes: "#nursing-results-sizes",
                nursing_selectCup: "#nursing-select-cup",
                nursing_selectBand: "#nursing-select-band",
                nursing_variousResults: "#nursing-various-results",
                nursing_resultsNumber: "#nursing-results-number",
                nursing_resultsBigger: "#nursing-results-biggest"
            })
        }), t.on(window.object_name + ".add_methods", function(t, i) {
            i.methods._add("methods", {
                nursing: {
                    set_modal_for_ipad: function() {
                        e(".modals").addClass("ipad-nursing"), e("html, body").animate({
                            scrollTop: 0
                        }, 100), document.ontouchmove = function(e) {
                            e.preventDefault()
                        }
                    },
                    init_band_options: function() {
                        i.methods.nursing.set_options(i.elements.nursing_selectBand, o.getBandOptions())
                    },
                    init_cup_options: function() {
                        i.methods.nursing.set_options(i.elements.nursing_selectCup, o.getCupOptions())
                    },
                    set_options: function(t, o, i) {
                        t.find("option:gt(0)").remove(), e.each(o, function(o, n) {
                            var a = n == i ? 'selected="selected"' : "";
                            t.append(e("<option " + a + "></option>").attr("value", n).text(n))
                        })
                    },
                    hide_results: function() {
                        i.elements.nursing_results.hide()
                    },
                    display_results: function(e) {
                        var t, o = e.results.map(function(e) {
                            return '<strong class="nursing-sizer__highlight">' + e + "</strong>"
                        });
                        o.length > 1 ? (3 === o.length ? (i.elements.nursing_resultsBigger.html("largest"), i.elements.nursing_resultsNumber.html("a few"), t = o.slice(0, -1).join(", ") + " or " + o.pop()) : (i.elements.nursing_resultsBigger.html("larger"), i.elements.nursing_resultsNumber.html("two"), t = o.join(" or ")), i.elements.nursing_variousResults.show()) : (i.elements.nursing_variousResults.hide(), t = o.pop()), i.elements.nursing_resultSizes.html(t), i.elements.nursing_results.show()
                    },
                    cup_change: function() {
                        var e = i.elements.nursing_selectBand,
                            t = this.value,
                            n = e.val();
                        t && n ? i.methods.nursing.display_results(o.findSize(n, t)) : i.methods.nursing.hide_results()
                    },
                    band_change: function() {
                        var e = i.elements.nursing_selectCup,
                            t = this.value,
                            n = e.val();
                        i.methods.nursing.set_options(e, o.getCupOptions(t), n), n = e.val(), n && t ? i.methods.nursing.display_results(o.findSize(t, n)) : i.methods.nursing.hide_results()
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            var o = {
                "change.dropdown_cup": {
                    element: t.elements.nursing_selectCup,
                    action: t.methods.nursing.cup_change
                },
                "change.dropdown_band": {
                    element: t.elements.nursing_selectBand,
                    action: t.methods.nursing.band_change
                }
            };
            t.methods.mobile.is_ipad() && (o.click = {
                element: t.elements.calculate_now,
                action: t.methods.nursing.set_modal_for_ipad
            }), t.methods._add("events", o)
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.elements.nursing_selectBand && t.methods.nursing.init_band_options(), t.elements.nursing_selectBand && t.methods.nursing.init_cup_options()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                sliders: ".slider",
                product_sliders: ".product-images .slider",
                desktop_product_slider: "#desktop-images",
                desktop_product_sliders: ".desktop .product-images .slider",
                mobile_product_sliders: ".mobile.product-images .slider",
                mobile_product_slider: "#mobile-images",
                large_sliders: ".largeslider",
                slider_vertical: ".slideshow.vertical",
                slider_vertical_slides: ".slideshow.vertical .slide",
                autoSliders: ".autoSlider",
                fit_finder_slider: ".fit-finder-slider",
                quote_slider: ".quote-carousel-module__carousel-container",
                all_sliders: ".slider, .largeslider, .autoSlider, .fit-finder-slider, .quote-carousel-module__carousel-container"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                vendors: {
                    _image_select: function() {
                        var t = e(this);
                        o.methods.vendors._showSelectedImage(t)
                    },
                    _showSelectedImage: function(t) {
                        o.methods.product_page_videos.pauseAllVideosOnPDP();
                        var i = t.data("video-container"),
                            n = !!i;
                        if (n && !o.methods.product_page_videos.isMobileVersion()) {
                            var a = !0,
                                s = !0;
                            o.methods.product_page_videos._playVideo(i, a, s)
                        }
                        var r = t.data("image-select"),
                            d = e(".images.slider").data("owl.carousel");
                        d.to(r), t.parent().find(".slide").removeClass("slide--selected"), t.addClass("slide--selected")
                    },
                    _image_zoom: function(t) {
                        var i = t ? e(t) : o.elements.product_images;
                        if (i.length)
                            if (o.methods.mobile._is_browser_mobile()) {
                                var n = e(".product-images.mobile"),
                                    a = e(".zoom-product-trigger"),
                                    s = e(".zoom-product").not(".view-360"),
                                    r = e(".zoom-product.view-360"),
                                    d = s.find(".zoom-product__img"),
                                    l = r.find(".zoom-product__img"),
                                    c = e(".zoom-product__close"),
                                    _ = e(".zoom-button"),
                                    u = this;
                                this._restoreImageOnOrientationChange(d);
                                var m = n.find(".owl-item.active");
                                this._hideZoomIconIfSelectedSlideIsNotProductImage(m), this._showVideoOverlayIfSelectedSlideIsCustomerVideo(m), n.on("change.owl.carousel", function(t) {
                                    var i = e(t.target),
                                        n = t.item.index,
                                        a = i.find(".owl-item").eq(n),
                                        s = a.find(".has-play"),
                                        r = !!s.length;
                                    if (r) {
                                        var d = s.children().attr("id");
                                        o.methods.product_page_videos._pauseVideo(d)
                                    }
                                }), n.on("changed.owl.carousel", function(t) {
                                    var i = e(t.target),
                                        n = t.item.index,
                                        a = i.find(".owl-item").eq(n);
                                    o.methods.vendors._hideZoomIconIfSelectedSlideIsNotProductImage(a), o.methods.vendors._showVideoOverlayIfSelectedSlideIsCustomerVideo(a)
                                }), _.on("click", function(t) {
                                    var o = e(t.currentTarget).parent(),
                                        i = o.find(".owl-item.active a.zoom-product-trigger"),
                                        n = i.attr("href");
                                    this._hideShopifyOverlayOnThemePreview(), i.hasClass("view-360") ? (l[0].src !== n && (l[0].src = n), r.css("display", "block")) : (d[0].src = n, this._addPanGestureToImage(d), s.css("display", "block"))
                                }.bind(this)), a.on("click", function(t) {
                                    t.preventDefault(), u._hideShopifyOverlayOnThemePreview();
                                    var o = e(this).attr("href");
                                    e(this).hasClass("view-360") ? (l[0].src !== o && (l[0].src = o), r.css("display", "block")) : (d[0].src = o, u._addPanGestureToImage(d), s.css("display", "block"))
                                }), c.on("click", function() {
                                    s.css("display", "none"), r.css("display", "none")
                                }.bind(this))
                            } else if (i && i.length > 1) {
                            var p = i[1],
                                h = e(p),
                                f = h.data("zoom");
                            if (!f) return;
                            h.zoom({
                                url: f,
                                magnify: 1
                            })
                        }
                    },
                    _hideZoomIconIfSelectedSlideIsNotProductImage: function(t) {
                        var o = e(".zoom-button"),
                            i = ".has-play, .view-360";
                        t.find(i).length ? o.hide() : o.show()
                    },
                    _showVideoOverlayIfSelectedSlideIsCustomerVideo: function(e) {
                        var t = o.methods.product_page_videos.isMobileVersion(),
                            i = t ? "div-mobile-customer-video" : "div-desktop-customer-video",
                            n = o.methods.product_page_videos._getVideoOverlay();
                        e.find("#" + i).length ? n.show() : n.hide()
                    },
                    _restoreImageOnOrientationChange: function(e) {
                        var t = this;
                        window.addEventListener("orientationchange", function() {
                            t._addPanGestureToImage(e)
                        })
                    },
                    _addPanGestureToImage: function(t) {
                        var i = t[0],
                            n = "undefined" != typeof window.orientation ? window.orientation : screen.orientation.angle,
                            a = 0 === n;
                        this._scaleAndPositionImage(t);
                        var s = new Hammer(i, {});
                        s.get("pan").set({
                            direction: Hammer.DIRECTION_ALL
                        });
                        var r = 0,
                            d = 0,
                            l = 2,
                            c = -50,
                            _ = 0,
                            u = 0,
                            m = 0;
                        s.on("pan panend", function(t) {
                            r = c + t.deltaX, d = _ + t.deltaY, u = Math.ceil((l - 1) * i.clientWidth / 2), m = Math.ceil((l - 1) * i.clientHeight / 2), r > u && (r = u), a ? o.methods.mobile._is_width("screen-sm", "larger") ? r < -u - Math.ceil(u / 4) && (r = -u - Math.ceil(u / 4)) : r < -u - Math.ceil(u / 2) && (r = -u - Math.ceil(u / 2)) : r < -u && (r = -u), d > m && (d = m), a ? d < -m && (d = -m) : d < -m - Math.ceil(m / 2) && (d = -m - Math.ceil(m / 2)), "panend" == t.type && (c = r < u ? r : u, _ = d < m ? d : m), e.Velocity.hook(i, "translateX", r + "px"), e.Velocity.hook(i, "translateY", d + "px"), e.Velocity.hook(i, "scale", 2)
                        })
                    },
                    _scaleAndPositionImage: function(t) {
                        e.Velocity.hook(t, "translateX", "-50px"), e.Velocity.hook(t, "translateY", "0"), e.Velocity.hook(t, "scale", 2)
                    },
                    _hideShopifyOverlayOnThemePreview: function() {
                        setTimeout(function() {
                            e("#preview-bar-iframe").hide()
                        }, 1e3)
                    },
                    _slider: function(e, t) {
                        var i = {
                            items: 1,
                            navText: ["R", "r"],
                            mouseDrag: !1,
                            smartSpeed: 300,
                            rewind: !1,
                            startPosition: 1,
                            responsiveRefreshRate: 1,
                            autoplay: !1,
                            loop: !1,
                            loadedClass: "owl-carousel owl-theme owl-loaded",
                            stageOuterClass: "owl-stage-outer",
                            stageClass: "owl-stage",
                            lazyLoad: !0,
                            responsive: {
                                0: {
                                    nav: !1
                                },
                                768: {
                                    nav: !0
                                }
                            }
                        };
                        if (t)
                            for (var n in t)
                                if (t.hasOwnProperty(n)) {
                                    var a = t[n];
                                    i[n] = a
                                } var s = ".autoSlider, .vertical, .largeslider, #desktop-images, #mobile-images";
                        e = e || o.elements.sliders.not(s), e.length > 0 && e.owlCarousel(i)
                    },
                    _large_slider: function() {
                        o.elements.large_sliders.length && o.elements.large_sliders.owlCarousel({
                            items: 7,
                            nav: !0,
                            navText: ["R", "r"],
                            mouseDrag: !1,
                            smartSpeed: 300,
                            rewind: !1,
                            responsiveRefreshRate: 1,
                            loop: !1,
                            center: !0,
                            loadedClass: "owl-carousel owl-theme owl-loaded",
                            stageOuterClass: "owl-stage-outer",
                            stageClass: "owl-stage",
                            lazyLoad: !0,
                            navigation: !0
                        })
                    },
                    _slider_vertical: function() {
                        if (o.elements.slider_vertical.length) {
                            o.methods.vendors._set_vertical_slide_h();
                            var t = e(o.elements.slider_vertical);
                            t.on("cycle-post-initialize", function() {
                                o.methods.vendors._vertical_slide_position(), o.methods.vendors.setSecondThumbAsSelected()
                            }), t.cycle({
                                slides: "> .slide",
                                next: "#next3",
                                prev: "#prev3",
                                pager: "#pager3"
                            }), o.methods.vendors.adjustVerticalCarouselBasedOnCustomerVideo()
                        }
                    },
                    _vertical_slide_position: function() {
                        setTimeout(function() {
                            e(".cycle-carousel-wrap").css("top", ".5px")
                        }, 0)
                    },
                    _set_vertical_slide_h: function() {
                        o.elements.slider_vertical_slides.each(function() {
                            var t = e(this);
                            t.css({
                                height: "auto"
                            })
                        })
                    },
                    _autoSlider: function() {
                        o.elements.autoSliders.length > 0 && this._slider(o.elements.autoSliders, {
                            autoplay: !0
                        })
                    },
                    _mobile_product_sliders: function() {
                        var t = o.elements.mobile_product_sliders;
                        t.length > 0 && (this._slider(t, {
                            startPosition: 1
                        }), e(".product-images .slider .slide").css({
                            visibility: "visible"
                        }))
                    },
                    _desktop_product_sliders: function() {
                        var e = o.elements.desktop_product_sliders;
                        e.length > 0 && (this._slider(e, {
                            startPosition: 1
                        }), o.methods.vendors.setSecondThumbAsSelected())
                    },
                    _quote_slider: function() {
                        var e = {
                                loop: !0,
                                dots: !0,
                                responsive: {
                                    0: {
                                        nav: !1
                                    },
                                    500: {
                                        nav: !0
                                    }
                                }
                            },
                            t = o.elements.quote_slider;
                        t.length > 0 && this._slider(t, e)
                    },
                    _fit_finder_slider: function() {
                        var e = {
                                nav: !0,
                                items: 7,
                                responsive: {
                                    0: {
                                        items: 1,
                                        stagePadding: 75,
                                        nav: !1,
                                        mouseDrag: !1,
                                        loop: !1
                                    },
                                    350: {
                                        items: 1,
                                        stagePadding: 90,
                                        nav: !1,
                                        mouseDrag: !1,
                                        loop: !1
                                    },
                                    400: {
                                        items: 1,
                                        stagePadding: 100,
                                        nav: !1,
                                        mouseDrag: !1,
                                        loop: !1
                                    },
                                    500: {
                                        items: 3
                                    },
                                    700: {
                                        items: 4
                                    },
                                    992: {
                                        items: 5
                                    },
                                    1100: {
                                        items: 7
                                    }
                                },
                                navText: ["R", "r"],
                                mouseDrag: !1,
                                smartSpeed: 300,
                                rewind: !1,
                                responsiveRefreshRate: 1,
                                loop: !1,
                                autoplay: !1,
                                loadedClass: "owl-carousel owl-theme owl-loaded",
                                stageOuterClass: "owl-stage-outer",
                                stageClass: "owl-stage"
                            },
                            t = o.elements.fit_finder_slider;
                        t.length > 0 && t.owlCarousel(e)
                    },
                    _center_clicked_slide: function() {
                        e(o.elements.all_sliders).on("click", ".owl-item", function() {
                            var t = e(this).parents(".owl-carousel"),
                                o = e(t).data("owl.carousel"),
                                i = o.relative(e(this).index()),
                                n = e(this).hasClass("active"),
                                a = e(t).find(".owl-item.active").length;
                            if (!(a > 1)) return n || o.to(i), !0
                        })
                    },
                    _destroy_carousels: function(t) {
                        var o = e(".slider").not(".vertical, .largeslider, .breast-shapes-slider, .autoSlider, .illustration-selection"),
                            i = e("#desktop-images .owl-stage, #mobile-images .owl-stage");
                        try {
                            e(".slideshow.vertical").cycle("destroy")
                        } catch (n) {
                            console.log("vertical carrousel destroyed:", n)
                        }
                        o.each(function(t, o) {
                            var i = e(o).data("owl.carousel");
                            i && i.destroy()
                        }), i && i.remove(), t && t.length > 0 && t.empty()
                    },
                    _initialize_carousels: function() {
                        var t, i = e(".slideshow.vertical"),
                            n = i.find(".slide").length,
                            a = e("#desktop-images, #mobile-images"),
                            s = e("#customer-video-thumb").children().length > 0;
                        t = n > 4 && s ? 4 : n > 4 ? 5 : n;
                        var r = {
                                fx: "carousel",
                                timeout: 0,
                                next: "#next3",
                                prev: "#prev3",
                                pager: "#pager3",
                                carouselVertical: t,
                                carouselVisible: t,
                                slides: "> .slide",
                                log: !1,
                                allowWrap: !1
                            },
                            d = {
                                items: 1,
                                navText: ["R", "r"],
                                mouseDrag: !1,
                                smartSpeed: 300,
                                rewind: !1,
                                responsiveRefreshRate: 1,
                                startPosition: 1,
                                loop: !1,
                                loadedClass: "owl-carousel owl-theme owl-loaded",
                                stageOuterClass: "owl-stage-outer",
                                stageClass: "owl-stage",
                                lazyLoad: !0,
                                nav: !1,
                                responsive: {
                                    0: {
                                        nav: !1
                                    },
                                    768: {
                                        nav: !0
                                    }
                                }
                            };
                        o.methods.product_page_videos.isMobileVersion() || (i.cycle(r), i.on("cycle-post-initialize", function() {
                            o.methods.vendors._vertical_slide_position(), o.methods.vendors.setSecondThumbAsSelected()
                        })), e(".product-images .slider .slide").css({
                            visibility: "visible"
                        }), a.owlCarousel(d), e(".product-images.mobile .owl-carousel .owl-item").each(function() {
                            var t = e(this);
                            t.height(t.width())
                        }), e("body").trigger("dynamicImagesUpdated", e(".product-images .slide")), o.methods.vendors.adjustVerticalCarouselBasedOnCustomerVideo()
                    },
                    setSecondThumbAsSelected: function() {
                        var t = 1,
                            i = e(".slide.cycle-slide"),
                            n = i.eq(t);
                        n.addClass("slide--selected"), setTimeout(function() {
                            o.methods.vendors.autoplayIfSelectedThumbIsProductVideo(n)
                        }, 0)
                    },
                    adjustVerticalCarouselBasedOnCustomerVideo: function() {
                        var t, o, i, n = 4,
                            a = e(".slideshow.vertical"),
                            s = "image-selector--has-customer-video--arrows",
                            r = "image-selector--has-customer-video--no-arrows",
                            d = e("#next3"),
                            l = "image-selector-arrows__nav--has-customer-video--arrows",
                            c = "image-selector-arrows__nav--has-customer-video--no-arrows",
                            _ = e("#customer-video-thumb"),
                            u = "video-slot--has-customer-video--arrows",
                            m = "video-slot--has-customer-video--no-arrows";
                        a.removeClass([s, r].join(" ")), d.removeClass([l, c].join(" ")), _.removeClass([u, m].join(" "));
                        var p = e("#customer-video-thumb").children().length > 0;
                        if (p) {
                            var h = a.find(".cycle-carousel-wrap").children().length;
                            h > n ? (t = s, o = l, i = u) : (t = r, o = c, i = m), a.addClass(t), d.addClass(o), _.addClass(i)
                        }
                    },
                    autoplayIfSelectedThumbIsProductVideo: function(e) {
                        e.data("video-container") && e.click()
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "resize._set_vertical_slide_h": {
                    element: t.elements.window,
                    action: t.methods.vendors._slider_vertical
                }
            })
        }), t.on(window.object_name + "._document_ready", function(t, o) {
            o.elements.all_sliders && o.elements.all_sliders.length > 0 && (o.methods.vendors._autoSlider(), o.methods.vendors._fit_finder_slider(), o.methods.vendors._center_clicked_slide(), o.methods.vendors._quote_slider(), o.methods.mobile._is_mobile() && window.innerWidth < 1024 ? (window.setTimeout(function() {
                o.methods.vendors._mobile_product_sliders()
            }.bind(o), 40), window.setTimeout(function() {
                o.methods.product_page._mobile_image_resize()
            }, 60)) : (window.setTimeout(function() {
                o.methods.vendors._desktop_product_sliders(), o.methods.vendors._large_slider()
            }.bind(o), 40), window.setTimeout(function() {
                o.methods.vendors._slider_vertical()
            }.bind(o), 100)), window.setTimeout(function() {
                o.methods.vendors._slider()
            }.bind(o), 140), o.elements.desktop_product_sliders.on("changed.owl.carousel", function() {
                window.setTimeout(function() {
                    var t = e(".desktop .product-images .owl-item.active .slide:not(.has-play)");
                    t.zoom({
                        url: t.attr("data-zoom")
                    })
                }, 100)
            }))
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                cookies_container: "#cookies-recommendations-container",
                cookies_slot: "#cookies-recommendations-slot",
                metafields_container: "#metafields-recommendations-container",
                metafields_slot: "#metafields-recommendations-slot",
                recommendation_slots: ".recommendation-wrapper",
                more_to_see: ".more-to-see",
                product_detail: ".pdp-more-datail-control",
                exchanges_free_label: ".soft-banner--spaced"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                slidersRecommendations: {
                    positionateRecommendationsSlotsBasedOnDevice: function() {
                        var e = 1024,
                            t = window.innerWidth < e;
                        t ? o.elements.recommendation_slots.detach().insertBefore(o.elements.more_to_see) : o.elements.recommendation_slots.detach().insertAfter(o.elements.exchanges_free_label)
                    },
                    fetchRecommendations: function() {
                        o.methods.slidersRecommendations.fetchMetafieldsRecommendations(), o.methods.slidersRecommendations.toogleRecommendationsVisibility(!0), o.methods.slidersRecommendations.fetchRecentlyViewedRecommendations()
                    },
                    fetchMetafieldsRecommendations: function() {
                        o.methods.slidersRecommendations.toogleRecommendationsVisibility(!1), o.methods.slidersRecommendations.fetchShopifyProducts().then(function(e) {
                            try {
                                const t = JSON.parse(e);
                                var i = o.methods.slidersRecommendations.formatDataBeforeRendering(t, !1);
                                o.methods.slidersRecommendations.renderRecommendations(i, !1)
                            } catch (n) {
                                console.error("Error fetching complete the look products: ", n), o.methods.slidersRecommendations.hideRecommendationSlot(o.elements.metafields_slot)
                            }
                        })
                    },
                    fetchRecentlyViewedRecommendations: function() {
                        var e = Cookies.get("_tl_recent_products");
                        e && e.length > 0 && (e = JSON.parse(e), e = e.filter(function(e, t, o) {
                            return e !== window.activeProductHandle && o.indexOf(e) == t
                        }), o.methods.slidersRecommendations.fetchShopifyProducts(e).then(function(e) {
                            try {
                                const t = JSON.parse(e);
                                var i = o.methods.slidersRecommendations.formatDataBeforeRendering(t, !0);
                                o.methods.slidersRecommendations.renderRecommendations(i, !0)
                            } catch (n) {
                                console.error("Error fetching recently viewed products: ", n), o.methods.slidersRecommendations.hideRecommendationSlot(o.elements.cookies_slot)
                            }
                        }))
                    },
                    fetchShopifyProducts: function(t) {
                        var o = window.activeProductHandle,
                            i = "/products/" + o + "?view=recommendations-json";
                        return t && (i += "&cache=false&handlers=" + t), e.get(i).done(function(e) {
                            return e
                        })
                    },
                    toogleRecommendationsVisibility: function(e) {
                        var t = "recommendation--hidden",
                            i = e ? o.elements.cookies_slot : o.elements.metafields_slot;
                        i.hasClass(t) ? (i.removeClass(t), e && o.elements.product_detail.addClass("pdp-more-datail-control--match-recommendations")) : i.addClass(t)
                    },
                    renderRecommendations: function(e, t) {
                        if (e && e.length > 0) {
                            var i = e.map(function(e) {
                                    return o.methods.slidersRecommendations.getRecomendationTemplate(e, t)
                                }),
                                n = i.join(""),
                                a = t ? o.elements.cookies_container : o.elements.metafields_container;
                            a.html(n), window.quickViewBootstrap && window.quickViewBootstrap.reInitialize(), o.methods.slidersRecommendations.showImagesInCarousel(a), setTimeout(function() {
                                o.methods.slidersRecommendations.toogleRecommendationsVisibility(t)
                            }, 100)
                        } else {
                            var s = t ? o.elements.cookies_slot : o.elements.metafields_slot;
                            o.methods.slidersRecommendations.hideRecommendationSlot(s)
                        }
                    },
                    getRecomendationTemplate: function(e, t) {
                        var i = window.shop.template,
                            n = o.elements.cookies_container.data("show-prices"),
                            a = t ? "Slot 2" : "Slot 1",
                            s = '            <div class="slide recommendation__item" data-item="' + e.id + '">              <div class="recommendation__item__wrapper">                 <a class="recommendation__link"                   href="/products/' + e.handle + '"                   data-category="' + i + '"                   data-track="nft"                   data-label="' + e.title + '">                   <img class="recommendation__image lazyload"                     src="' + e.image.src_100 + '"                     data-src="' + e.image.src_300 + '"                     data-srcset="' + e.image.src_300 + " 1x, " + e.image.src_600 + ' 2x "                    alt="' + e.title + '" />                   <div class="recommendation__item__overlay">                     <p class="recommendation__item__name">' + e.title + '</p>                     <p class="recommendation__item__price"> ';
                        return n && (s += e.compare_at_price > e.price ? '                       <span class="recommendation__item__price--strike">$' + e.compare_at_price + '</span>                       <span class="recommendation__item__price--sale">$' + e.price + "</span>" : "                       <span>$" + e.price + "</span>"), s += '                      </p>                     <div class="recommendation__arrow"></div>                   </div>                 </a>                 <span class="tl-quick-view recommendation__quick-view"                   data-category="' + i + '"                   data-track="nft"                   data-label="Quick View' + e.title + " - Recommendations " + a + '"                  data-product-id="' + e.id + '"                   data-product-handle="' + e.handle + '">                 </span>               </div>               <div class="recommendation__details">                 <p class="recommendation__details__title" data-category="' + i + '" data-track="nft" data-label="Product Panel ' + e.title + '">' + e.title + "</p>", n && (s += e.compare_at_price > e.price ? '                   <p class="recommendation__details__price" data-category="' + i + '" data-track="nft" data-label="Product Panel ' + e.price + '">                     <span class="recommendation__details__price--strike">$' + e.compare_at_price + '</span>                     <span class="recommendation__details__price--sale">$' + e.price + "</span>                   </p>" : '                   <p class="recommendation__details__price" data-category="' + i + '" data-track="nft" data-label="Product Panel ' + e.price + '">                     <span>$' + e.price + "</span>                   </p>"), s += "               </div>             </div> "
                    },
                    formatDataBeforeRendering: function(e, t) {
                        var i = o.methods.slidersRecommendations.filterProducts(e, t),
                            n = e.productTypeForHandle,
                            a = i.map(function(i) {
                                var a, s, r, d, l, c, _;
                                if (_ = "bra" === n[i] ? o.methods.slidersRecommendations.fetchPersonaBraSizeForEndpoint() : o.methods.slidersRecommendations.fetchPersonaUnderwearSizeForEndpoint(), t && _) {
                                    var u = i + "-" + _;
                                    a = e.variantsForHandleAndSize[u]
                                } else {
                                    var m = e.variantsForHandleAndSize;
                                    for (var u in m)
                                        if (m.hasOwnProperty(u) && u.indexOf(i) > -1 && (a = m[u], a.inventory_available)) break
                                }
                                return s = a.id, r = a.product_title, l = a.price, c = a.compare_at_price, d = e.images[i][0], {
                                    id: s,
                                    handle: i,
                                    title: r,
                                    image: d,
                                    price: l,
                                    compare_at_price: c
                                }
                            });
                        return a
                    },
                    filterProducts: function(e, t) {
                        var i, n = e.handles,
                            a = e.variantsForHandleAndSize,
                            s = e.productTypeForHandle;
                        return n.filter(function(e) {
                            var n;
                            if (n = "bra" === s[e] ? o.methods.slidersRecommendations.fetchPersonaBraSizeForEndpoint() : o.methods.slidersRecommendations.fetchPersonaUnderwearSizeForEndpoint(), !t || !n) {
                                var r = !1;
                                for (var d in a)
                                    if (a.hasOwnProperty(d) && d.indexOf(e) > -1 && (i = a[d], i.inventory_available)) {
                                        r = !0;
                                        break
                                    } return r
                            }
                            var d = e + "-" + n;
                            if (i = a[d]) return !!i.inventory_available
                        })
                    },
                    showImagesInCarousel: function(e) {
                        var t = e.data("owl.carousel");
                        t && t.destroy();
                        var o = {
                            items: 2,
                            navText: ["R", "r"],
                            mouseDrag: !1,
                            smartSpeed: 300,
                            rewind: !1,
                            startPosition: 0,
                            responsiveRefreshRate: 1,
                            autoplay: !1,
                            loop: !1,
                            loadedClass: "owl-carousel owl-theme owl-loaded",
                            stageOuterClass: "owl-stage-outer",
                            stageClass: "owl-stage",
                            lazyLoad: !0,
                            margin: 12,
                            responsive: {
                                0: {
                                    nav: !1,
                                    dots: !0
                                },
                                768: {
                                    nav: !0,
                                    dots: !1
                                }
                            }
                        };
                        e.length > 0 && e.owlCarousel(o)
                    },
                    hideRecommendationSlot: function(e) {
                        e.addClass("recommendation--hidden")
                    },
                    fetchPersonaBraSizeForEndpoint: function() {
                        var e = o.methods.persona.getBraSize();
                        return e && e.length > 0 ? e.replace("½", ".5") : e
                    },
                    fetchPersonaUnderwearSizeForEndpoint: function() {
                        return o.methods.persona.getUnderwearSize()
                    }
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.methods.slidersRecommendations.positionateRecommendationsSlotsBasedOnDevice(), t.methods.slidersRecommendations.showImagesInCarousel(t.elements.metafields_container), t.methods.slidersRecommendations.toogleRecommendationsVisibility(!1), window.activeProductHandle && window.setTimeout(t.methods.slidersRecommendations.fetchRecentlyViewedRecommendations, 200), window.addEventListener("orientationchange", function() {
                t.methods.slidersRecommendations.positionateRecommendationsSlotsBasedOnDevice()
            }, !1)
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                side_nav_holder: ".side-nav-holder",
                side_nav: ".side-nav"
            })
        }), t.on(window.object_name + ".add_methods", function(e, t) {
            t.methods._add("methods", {
                _side_nav_scroll: function() {
                    if (t.elements.side_nav.length) {
                        var e = t.elements.side_nav_holder.offset().top,
                            o = t.elements.nav_header.outerHeight(),
                            i = 30;
                        window.scrollY >= t.elements.side_nav_holder.offset().top - o - i ? t.elements.side_nav.css("top", window.scrollY - e + o + i) : t.elements.side_nav.removeAttr("style")
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                scroll_side_nav: {
                    event: "scroll._side_nav_scroll",
                    element: t.elements.window,
                    action: t.methods._side_nav_scroll
                },
                resize_side_nav: {
                    event: "resize._side_nav_scroll",
                    element: t.elements.window,
                    action: t.methods._side_nav_scroll
                }
            })
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                accordion_container: ".pdp-more-detail",
                accordion_header: ".pdp-more-detail__header",
                accordion_details: ".js-accordion-details",
                accordion_reviews: ".js-accordion-reviews",
                accordion_read_more_button: ".js-read-more",
                tab_container: "#pdp-tab-content"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            var i, n = "pdp-more-detail__item--active",
                a = ".pdp-more-detail__item",
                s = {
                    details: ".js-accordion-details",
                    fitGuarantee: ".js-accordion-fit-guarantee",
                    reviews: ".js-accordion-reviews"
                },
                r = 1024,
                d = ".pdp-more-detail__icon",
                l = "pdp-more-detail__icon--expanded",
                c = "pdp-more-detail__tab--active",
                _ = "pdp-more-detail__content--active";
            o.methods._add("methods", {
                accordionPanel: {
                    initializeAccordion: function() {
                        var t = window.outerWidth || e(window).width();
                        t < r ? (!i || i >= r) && (o.methods.accordionPanel._hideListItem(), o.methods.accordionPanel._moveContainerToAccordion()) : (!i || i < r) && o.methods.accordionPanel._moveContainerToTabs(), i = t
                    },
                    _moveContainerToTabs: function() {
                        var t = o.elements.accordion_container.find(".pdp-more-detail__content").not(".js-content-reviews");
                        o.elements.tab_container.append(t), e(".pdp-more-detail__header--fit-guarantee").show(), o.elements.accordion_container.addClass("js-tabs")
                    },
                    _moveContainerToAccordion: function() {
                        var t = o.elements.tab_container.find(".pdp-more-detail__content");
                        0 !== t.length && (e(".js-accordion-details").append(t.closest("#details-panel")), e(".js-accordion-fit-guarantee").append(t.closest("#fit-guarantee-panel")), o.elements.accordion_container.removeClass("js-tabs"))
                    },
                    togglePanel: function(t) {
                        t.preventDefault();
                        var i = e(t.currentTarget).parent(),
                            a = i.hasClass(n);
                        if (a) o.methods.accordionPanel._togglePanel(!1);
                        else {
                            o.methods.accordionPanel._togglePanel(!0, i);
                            var s = o.elements.accordion_container.offset().top - 50;
                            e("html, body").animate({
                                scrollTop: s
                            }, 750)
                        }
                    },
                    expandPanel: function(t) {
                        var i = e(t),
                            n = o.elements.accordion_container.offset().top;
                        i.hasClass("pdp-more-detail__item--active") || (this.collapsePanels(), this._expandPanel(i)), e("html, body").animate({
                            scrollTop: n
                        }, 750)
                    },
                    scrollAndExpandPanel: function(e) {
                        var t = s[e];
                        t && this.expandPanel(t)
                    },
                    collapsePanels: function() {
                        var t = "." + n,
                            o = e(a + t);
                        o.removeClass(n).find(d).removeClass(l)
                    },
                    _onHeaderPanelClicked: function(e) {
                        o.elements.accordion_container.hasClass("js-tabs") ? o.methods.accordionPanel.toggleTab(e) : o.methods.accordionPanel.togglePanel(e)
                    },
                    toggleTab: function(t) {
                        var i = e(t.currentTarget).find("a"),
                            n = "#" + i.attr("href");
                        t.preventDefault(), i.hasClass("tab-pane--active") || (o.elements.accordion_container.find("." + c).removeClass(c), i.addClass(c), o.elements.tab_container.find("." + _).removeClass(_), e(n).addClass(_))
                    },
                    _togglePanel: function(e, t) {
                        o.methods.accordionPanel.collapsePanels(), e && o.methods.accordionPanel._expandPanel(t)
                    },
                    _expandPanel: function(e) {
                        setTimeout(function() {
                            e.addClass(n).find(d).addClass(l)
                        }, 0)
                    },
                    _hideListItem: function() {
                        var t = 5,
                            i = o.elements.accordion_details.find(".pdp-more-detail__list-item"),
                            n = "pdp-more-detail__list-item--hidden";
                        i.slice(t).addClass(n), o.elements.accordion_read_more_button.one("click", function() {
                            i.removeClass(n), e(this).hide()
                        })
                    },
                    _hideFreeExchangesTab: function() {
                        e(s.fitGuarantee).addClass("pdp-more-detail__item--hidden")
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click.togglePanel": {
                    element: t.elements.accordion_header,
                    action: t.methods.accordionPanel._onHeaderPanelClicked
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.methods.accordionPanel.initializeAccordion(), window.addEventListener("resize", function() {
                setTimeout(t.methods.accordionPanel.initializeAccordion, 0)
            })
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                dropdown: ".dropdown",
                dropdown_toggle: '[data-action="dropdown-toggle"]'
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                _dropdown_toggle: function() {
                    var t = e(this),
                        i = t.parents(".dropdown"),
                        n = i.hasClass("open");
                    o.methods._drowndowns_close(), n || i.addClass("open")
                },
                _drowndowns_close: function() {
                    o.elements.dropdown.removeClass("open")
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "click.dropdown._toggle": {
                    element: t.elements.dropdown_toggle,
                    action: t.methods._dropdown_toggle
                },
                "esc.dropdown._toggle": {
                    event: window.object_name + "._html_esc",
                    element: t.elements.window,
                    action: t.methods._drowndowns_close
                },
                "html_click.dropdown._toggle": {
                    event: window.object_name + "._html_click",
                    element: t.elements.window,
                    action: t.methods._drowndowns_close
                }
            })
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                mobileContainer: ".product-variants",
                colorContainer: ".product-variants .swatch-selector__color-container",
                sizeContainer: ".product-variants .swatch-selector__size-container",
                colorSwatch: "#colorSwatch",
                sizeSwatch: "#sizeSwatch",
                addToBagContainer: ".js-add-to-bag-container"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            var i = {
                    color: {
                        open: !1,
                        name: "",
                        expandedClass: "swatch-selector__color-container--expanded",
                        collapsedClass: "swatch-selector__color-container--collapsed"
                    },
                    size: {
                        open: !1,
                        expandedClass: "swatch-selector__size-container--expanded",
                        collapsedClass: "swatch-selector__size-container--collapsed"
                    },
                    oosClass: "swatch-selector--oos",
                    oosLightClass: "swatch-selector--oos-light",
                    showButtonAction: !1
                },
                n = {
                    bra: "Add Size",
                    panties: "Add Size",
                    "panty pack": "Add Size",
                    sleepwear: "Add Size",
                    camisoles: "Add Size",
                    giftcard: "Add Price"
                };
            o.methods._add("methods", {
                pickers: {
                    _initialize: function() {
                        this._attachListeners(), this._hideActionButton(), i.color.name = e(".color-selection .filter-option__input:checked").val()
                    },
                    _attachListeners: function() {
                        o.elements.sizeContainer.on("change._variant_selection", function() {
                            var e = this._getSizeInfo();
                            this._updateSizeLabel(e), this._resetSwatchStyles(e), i.color.open || i.size.open ? this._checkActionButton(e) : this._hideActionButton()
                        }.bind(this)), o.elements.mobileContainer.on("pdp_out_of_stock", function(e, t) {
                            var n, a = i.oosClass,
                                s = window.PDPLightColorArray,
                                r = window.pdp.variant,
                                d = this._getSizeInfo();
                            i.color.name = window.pdp.selection.colorName, t ? (r ? (n = this._getOosColorClass(s, i.color.name), o.elements.colorSwatch.find(".swatch-selector__color").removeClass(i.oosLightClass).addClass(n), o.elements.sizeSwatch.find(".swatch-selector__size").addClass(a)) : this._removeOOSClass(), this._updateSizeLabel(d)) : this._removeOOSClass()
                        }.bind(this)), o.elements.mobileContainer.on("pdp_add_to_cart", this._collapseAllSwatches.bind(this)), o.elements.mobileContainer.on("pdp_on_color_change", this._updateColorSwatch.bind(this)), e("#colorSwatch").on("click", function() {
                            i.size.open && this.collapseContainer(o.elements.sizeContainer, i.size.collapsedClass, i.size.expandedClass, "size"), this.toggleContainer(o.elements.colorContainer, i.color.collapsedClass, i.color.expandedClass, "color"), this._actionButton(i.color.open)
                        }.bind(this)), e("#sizeSwatch").on("click", function() {
                            i.color.open && this.collapseContainer(o.elements.colorContainer, i.color.collapsedClass, i.color.expandedClass, "color"), this.toggleContainer(o.elements.sizeContainer, "swatch-selector__size-container--collapsed", "swatch-selector__size-container--expanded", "size"), this._actionButton(i.size.open)
                        }.bind(this))
                    },
                    _getOosColorClass: function(e, t) {
                        var o = i.oosClass + " ";
                        return o += e.indexOf(t) > -1 ? i.oosLightClass : ""
                    },
                    _actionButton: function(e) {
                        e ? this._checkActionButton() : this._hideActionButton()
                    },
                    _checkActionButton: function() {
                        var e = this._getSizeInfo(),
                            t = this._isSelectionCompleted(e),
                            o = ["gift card"],
                            i = e.type,
                            n = o.indexOf(i) > -1;
                        t && !n ? this._showActionButton() : this._hideActionButton()
                    },
                    _showActionButton: function() {
                        i.showButtonAction = !0, o.elements.sizeContainer.removeClass("swatch-selector__size-container--no-button"), o.elements.colorContainer.removeClass("swatch-selector__size-container--no-button"), o.elements.addToBagContainer.show().delay(300).removeClass("product-actions--hide")
                    },
                    _hideActionButton: function() {
                        i.showButtonAction = !1, o.elements.sizeContainer.addClass("swatch-selector__size-container--no-button"), o.elements.colorContainer.addClass("swatch-selector__size-container--no-button"), o.elements.addToBagContainer.addClass("product-actions--hide").delay(300).hide(0)
                    },
                    _collapseAllSwatches: function() {
                        this.collapseContainer(o.elements.colorContainer, i.color.collapsedClass, i.color.expandedClass, "color"), this.collapseContainer(o.elements.sizeContainer, i.size.collapsedClass, i.size.expandedClass, "size"), this._actionButton(!1)
                    },
                    _getSizeInfo: function() {
                        var e = this._getProductType(),
                            t = {
                                type: e
                            };
                        return "bra" === e ? (t.band = window.pdp.selection.bandSize, t.cup = window.pdp.selection.cupSize) : t.size = window.pdp.selection.size, t
                    },
                    _getProductType: function() {
                        return window.pdp.product_type && window.pdp.product_type.toLowerCase()
                    },
                    _resetSwatchStyles: function(e) {
                        var t = this._isSelectionCompleted(e);
                        t || this._removeOOSClass()
                    },
                    _isSelectionCompleted: function(e) {
                        return e.band && e.cup ? e.band + "" + e.cup : e.size
                    },
                    _removeOOSClass: function() {
                        var e = i.oosClass + " " + i.oosLightClass;
                        o.elements.colorSwatch.find(".swatch-selector__color").removeClass(e), o.elements.sizeSwatch.find(".swatch-selector__size").removeClass(e);
                    },
                    toggleContainer: function(e, t, o, n) {
                        e.hasClass(t) ? (this.expandContainer(e, t, o, n, n), i[n].open = !0) : (this.collapseContainer(e, t, o, n, n), i[n].open = !1)
                    },
                    expandContainer: function(e, t, i, n) {
                        var a = n + "Swatch",
                            s = o.elements[a],
                            r = "swatch-selector__arrow--expanded";
                        e.removeClass(t).addClass(i), s.find(".swatch-selector__arrow").addClass(r), s.attr("aria-expanded", "true")
                    },
                    collapseContainer: function(e, t, i, n) {
                        var a = n + "Swatch",
                            s = o.elements[a],
                            r = "swatch-selector__arrow--expanded";
                        e.removeClass(i).addClass(t), s.find(".swatch-selector__arrow").removeClass(r), s.attr("aria-expanded", "false")
                    },
                    _updateSizeLabel: function(t) {
                        var o = t.band && t.cup ? t.band + "" + t.cup : t.size;
                        o = this._normalizeLabel(o);
                        var i = e(".js-selector-size"),
                            n = i.find(".swatch-selector__label "),
                            a = "swatch-selector--filled",
                            s = window.pdp.variant,
                            r = this._getProductType();
                        ("gift card" !== r || o) && o && s ? i.addClass(a) : (o = this._getDefaultLabel(r), i.removeClass(a)), n.text(o)
                    },
                    _normalizeLabel: function(e) {
                        return e && e.replace(".5", "½")
                    },
                    _getDefaultLabel: function(e) {
                        var t = e && e.replace(" ", "");
                        return n[t]
                    },
                    _updateColorSwatch: function(e, t) {
                        var i = t.colorHex;
                        o.elements.colorSwatch.find(".js-selector-color").css("background", i)
                    }
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.elements.sizeContainer.length > 0 && t.methods.pickers._initialize()
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = !1,
            i = 5e3,
            n = 1e3,
            a = 1024;
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                ff_banner: "#fit-finder",
                ff_disruptor: '[data-element-name="fit-finder-banner"]',
                ff_disruptor_close_icon: '[data-action="close-ff-banner"]',
                homepage_ff_teaser_section: "#ff-teaser-section"
            })
        }), t.on(window.object_name + ".add_methods", function(t, i) {
            var n;
            i.methods._add("methods", {
                fit_finder: {
                    _show_ff_banner: function() {
                        i.elements.ff_banner.css("max-height", "40px")
                    },
                    _close_ff_disruptor: function() {
                        null !== Cookies && "undefined" != typeof Cookies && (Cookies.set("_tl_ff_ban_closed", !0), n = !1), i.elements.ff_disruptor.addClass("fit-banner__container--closed"), i.elements.body.removeClass("ff-banner-open")
                    },
                    _show_ff_disruptor: function() {
                        var t = i.elements.ff_disruptor,
                            o = e(t).data("gtm-element-name");
                        e(t).removeClass("fit-banner__container--closed"), n = !0, i.elements.body.addClass("ff-banner-open"), window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                            event: "FF View Disruptor",
                            gtmElementName: o
                        })
                    },
                    _disruptor_is_showing: function() {
                        return n
                    },
                    _has_completed: function() {
                        return Cookies.get("_tl_ff_my_fit") || !1
                    },
                    _has_user_already_completed: function() {
                        return o
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "fit_finder._close_ff_disruptor": {
                    event: "click._fit_finder._ff_disruptor_close_icon",
                    element: t.elements.ff_disruptor_close_icon,
                    action: t.methods.fit_finder._close_ff_disruptor
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            o = ThirdLove.methods.fit_finder._has_completed(), userClosedDisruptor = null != Cookies && Cookies.get("_tl_ff_ban_closed");
            var s = 0 === t.elements.homepage_ff_teaser_section.length || "none" === t.elements.homepage_ff_teaser_section.css("display"),
                r = !userClosedDisruptor && window.innerWidth >= a && t.elements.ff_disruptor.length > 0 && !o && s,
                d = !r && window.innerWidth < a && !o;
            r ? window.setTimeout(t.methods.fit_finder._show_ff_disruptor, i) : d && window.setTimeout(t.methods.fit_finder._show_ff_banner, n)
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                bra_features: ".bra-feature",
                bra_features_illustration: ".bra-features-illustration"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                bra_features_illustration: {
                    initialize: function() {
                        o.elements.bra_features.click(function(t) {
                            var i = e(this).children(".bra-feature-content"),
                                n = !e(this).hasClass("bra-feature--visible");
                            window.innerWidth >= 1024 || i && (n ? (o.methods.bra_features_illustration.hide_all_features(), i.css("width", window.innerWidth - 60), window.innerWidth <= 380 ? (i.css("left", (e(this).offset().left - 30) * -1), i.css("right", "auto")) : window.innerWidth >= 680 ? (i.css("left", e(this).width() / 2 - 160), i.css("right", "auto")) : e(this).hasClass("bra-feature--left") ? i.css("left", (e(this).offset().left - 30) * -1) : e(this).hasClass("bra-feature--right") && (i.css("left", "auto"), i.css("right", (window.innerWidth - (e(this).offset().left + e(this).width()) - 30) * -1)), e(this).addClass("bra-feature--visible"), i.removeClass("bra-feature-content--hidden")) : e(t.target).is(".bra-feature-content") || e(t.target).is(".bra-feature-content__description") || e(t.target).is(".bra-feature-content__image") || o.methods.bra_features_illustration.hide_all_features())
                        }), o.elements.bra_features_illustration.click(function(t) {
                            e(t.target).is(".bra-features-illustration") && o.methods.bra_features_illustration.hide_all_features()
                        }), e(window).resize(function() {
                            if (window.innerWidth < 600) {
                                var t = e(".bra-feature--visible .bra-feature-content");
                                t.length > 0 && (t.css("width", window.innerWidth - 60), t.css("left", (t.parent().offset().left - 30) * -1))
                            } else if (window.innerWidth >= 1024) {
                                var o = e(".bra-feature-content");
                                o.css("left", "auto"), o.css("right", "auto"), o.css("width", "auto")
                            }
                        })
                    },
                    hide_all_features: function() {
                        e(".bra-feature").removeClass("bra-feature--visible"), e(".bra-feature-content").addClass("bra-feature-content--hidden")
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {})
        }), t.on(window.object_name + "._document_ready", function(t, o) {
            e(o.elements.bra_features_illustration) && o.methods.bra_features_illustration.initialize()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                product_filters_mobile: '[data-action="filter-products-mobile"]',
                product_filters_desktop: '[data-action="filter-products-desktop"]',
                product_grids: ".proudct-girds",
                filter_grid: ".filter-grid",
                filter_products: ".filter-grid .row > div",
                filter_clear: '[data-action="clear-filters"]',
                no_filter_results_msg: ".no-filter-results-msg"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                _product_filters_mobile: function() {
                    var t = "",
                        i = ["O/S", "O-S", "OS", "XS", "SM", "MD", "LG", "XL"],
                        n = this;
                    n && n.value && ("all" !== n.value ? e(n).parent().addClass("hide-filter-arrow") : e(n).parent().removeClass("hide-filter-arrow")), o.elements.product_filters_mobile.each(function() {
                        var o = e(this),
                            n = o.val(),
                            a = o.data("filter");
                        if ("all" !== n)
                            if ("size" === a)
                                if (i.indexOf(n) >= 0) t += ".underwear-" + a + "-" + n;
                                else {
                                    var s = {
                                        "band-size": null,
                                        "cup-size": null
                                    };
                                    s["band-size"] = n.substr(0, 2), s["cup-size"] = n.substr(2, n.length), e.each(s, function(e, o) {
                                        t += "." + e + "-" + o
                                    })
                                }
                        else t += "." + a + "-" + n
                    }), o.methods._show_filters(t)
                },
                _product_filters_desktop: function() {
                    var t = "";
                    o.elements.product_filters_desktop.each(function() {
                        var o = e(this),
                            i = o.val(),
                            n = o.data("filter");
                        o.is(":checked") && ("size" === n && (n = "underwear-size"), t += "." + n + "-" + i)
                    }), o.methods._show_filters(t)
                },
                _show_filters: function(t) {
                    if (t) {
                        var i, n, a = o.methods._get_filter_values(t),
                            s = o.elements.filter_products;
                        o.elements.product_grids.slideUp(), o.elements.filter_grid.slideDown(), s.hide(), i = s.filter(a.braFilters), n = s.filter(a.underwearFilters), a.colorFilters && (i = s.filter(a.colorFilters), n = s.filter(a.colorFilters));
                        for (var r = this._get_filters_query_string(a.braFilters, a.underwearFilters), d = 0; d < s.length; d++) {
                            var l = e(s[d]).find("a").attr("href").split("?")[0];
                            e(s[d]).find("a").attr("href", l + r)
                        }
                        i.show(), n.show(), this._show_empty_filter_msg(a.braFilters)
                    } else o.elements.product_grids.slideDown(), o.elements.filter_grid.slideUp()
                },
                _get_filters_query_string: function(e, t) {
                    var o, i;
                    if (e) {
                        var n = e.split("-");
                        o = n[n.length - 1]
                    }
                    t && (i = t.split("-")[1]);
                    var a = "";
                    if (i) a = "?size=" + i;
                    else if (o) {
                        var s = "bra_size";
                        e.indexOf("band-size") != -1 ? s = "band" : e.indexOf("cup-size") != -1 && (s = "cup"), a = "?" + s + "=" + o
                    }
                    return a
                },
                _show_empty_filter_msg: function(t) {
                    if (t) {
                        var i = ["28AA", "28A", "28B", "28C", "28E", "28F", "28G", "28H", "28I", "30AA", "30A", "30G", "30H", "30I", "32AA", "32H", "32I", "34H", "34I", "36AA", "36G", "36H", "36I", "38AA", "38F", "38G", "38H", "38I", "40AA", "40A", "40E", "40F", "40G", "40H", "40I", "42AA", "42A", "42B", "42D", "42E", "42F", "42G", "42H", "42I", "44AA", "44A", "44B", "44C", "44D", "44E", "44F", "44G", "44H", "44I", "46AA", "46A", "46B", "46C", "46D", "46E", "46F", "46G", "46H", "46I"];
                        window.collectionFilters && "" != window.collectionFilters.notCarried && (i = window.collectionFilters.notCarried.split(","));
                        var n = t.slice(t.indexOf("-") + 1);
                        if (i.indexOf(n) > -1) {
                            var a = "We don't currently carry this size. Contact us <a href='https://help.thirdlove.com/hc/en-us' target='_blank'>through our help center</a> to be notified when your size is available.";
                            o.elements.no_filter_results_msg.children("p").html(a)
                        }
                    }
                    if (o.elements.no_filter_results_msg && o.elements.no_filter_results_msg.hide(), o.elements.filter_products) {
                        for (var s = !0, r = 0; r < o.elements.filter_products.length; r++) {
                            var d = o.elements.filter_products[r];
                            if ("none" !== e(d).css("display")) return
                        }
                        s = !1, o.elements.no_filter_results_msg.show()
                    }
                },
                _clear_filters: function() {
                    o.elements.no_filter_results_msg && o.elements.no_filter_results_msg.hide();
                    var t = e(this),
                        i = t.parents(".dropdown"),
                        n = i.find("input");
                    n.removeAttr("checked"), o.methods._show_filters(), o.methods._drowndowns_close()
                },
                _load_filters_from_url: function() {
                    var t = e(window).width() <= 768,
                        i = document.location.search.replace("?", "").split("&").map(function(e) {
                            return e = e.split("="), this[e[0]] = e[1], this
                        }.bind({}))[0];
                    if (t) i.bra_size && (e('.filters .mobile.bra-dropdown-filter select option[value="' + i.bra_size + '"]').prop("selected", !0), o.elements.product_filters_mobile.trigger("change._product_filters_mobile")), i.underwear_size && (e('.filters .mobile.underwear-size.underwear-dropdown-filter select option[value="' + i.underwear_size + '"]').prop("selected", !0), o.elements.product_filters_mobile.trigger("change._product_filters_mobile")), i.color && (e('.filters .mobile.color-dropdown-filter select option[value="' + i.color + '"]').prop("selected", !0), o.elements.product_filters_mobile.trigger("change._product_filters_mobile"));
                    else {
                        if (i.bra_size) {
                            var n = i.bra_size.slice(0, 2),
                                a = i.bra_size.slice(2, i.bra_size.length);
                            e('.filters .desktop .variant-band-size input[value="' + n + '"]').prop("checked", !0), e('.filters .desktop .variant-cup-size input[value="' + a + '"]').prop("checked", !0), o.elements.product_filters_desktop.trigger("change._product_filters_desktop")
                        }
                        i.underwear_size && (e('.filters .desktop .underwear-size input[value="' + i.underwear_size + '"]').prop("checked", !0), o.elements.product_filters_desktop.trigger("change._product_filters_desktop")), i.color && (e('.filters .desktop .color-selection input[value="' + i.color + '"]').prop("checked", !0), o.elements.product_filters_desktop.trigger("change._product_filters_desktop"))
                    }
                },
                _get_filter_values: function(t) {
                    var o = {};
                    if (t) {
                        var i, n, a, s, r, d = t.split(".").splice(1);
                        e.each(d, function(e, t) {
                            t.indexOf("color") >= 0 && (r = "." + t), t.indexOf("band-size") >= 0 && (i = "." + t), t.indexOf("cup-size") >= 0 && (t = t.split(" ")[0], n = "." + t), t.indexOf("underwear-size") >= 0 && (s = t.replace("underwear-", "."))
                        }), n && i ? a = ".variant-" + i.replace(".band-size-", "") + n.replace(".cup-size-", "") : (i || n) && (a = i || n), o.braFilters = a, o.underwearFilters = s, o.colorFilters = r
                    }
                    return o
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "product.filters_mobile": {
                    event: "change._product_filters_mobile",
                    element: t.elements.product_filters_mobile,
                    action: t.methods._product_filters_mobile
                },
                "product.filters_desktop": {
                    event: "change._product_filters_desktop",
                    element: t.elements.product_filters_desktop,
                    action: t.methods._product_filters_desktop
                },
                "product.filters_clear": {
                    event: "click._clear_filters",
                    element: t.elements.filter_clear,
                    action: t.methods._clear_filters
                }
            })
        }), t.on(window.object_name + "._document_ready", function(t, o) {
            o.methods._load_filters_from_url();
            var i = ["XL", "LG", "M-L", "M/L", "MD", "S-M", "S/M", "SM", "XS", "O-S", "O/S", "OS", "all"],
                n = e('.filters-container .underwear-size select[data-action="filter-products-mobile"]'),
                a = e(".filters-container .underwear-size ul");
            i.forEach(function(t) {
                e('.filters-container .underwear-size option[value="' + t + '"]').prependTo(n), e('.filters-container .underwear-size li[data-list="' + t + '"]').prependTo(a)
            })
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = 768,
            i = "band",
            n = "cup",
            a = "size",
            s = "color",
            r = 4,
            d = t.width() <= o,
            l = "collection.dynamic" === window.TLTemplateName;
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                desktop_color_filters: ".product-filters__desktop-colors-filter > .filter-options--colors",
                desktop_bra_size_filters: ".product-filters__desktop-bra-sizes-filter > .filter-options--bra-sizes",
                desktop_size_filters: ".product-filters__desktop-sizes-filter > .filter-options--sizes",
                mobile_color_filters: ".mobile-filter__tab.filter-options--colors",
                mobile_size_filters: ".mobile-filter__tab.filter-options--sizes",
                mobile_bra_size_filters: ".mobile-filter__tab.filter-options--bra-sizes",
                desktop_filter: ".product-filters--desktop",
                mobile_filter: ".mobile_filter",
                filtered_area: "#js-filtered-products",
                recommended_area: "#js-other-sizes",
                collection_titles: ".product-family__title",
                collection_area: "#js-collections",
                filtered_products: ".collection-grid--filtered-products",
                size_filters: ".product-filters--filters",
                all_bras: "#all-bras",
                other_styles_in_size: "#other-sizes-products",
                bras: "#bras",
                notify_me_container: "#notify-me-container "
            })
        }), t.on(window.object_name + ".add_methods", function(c, _) {
            _.methods._add("methods", {
                json_filters: {
                    splitBraSize: function(e) {
                        return {
                            band: e.slice(0, 2),
                            cup: e.slice(2)
                        }
                    },
                    capColorsUnfiltered: function() {
                        var t = _.elements.collection_area.find(".collection-grid__container");
                        t.each(function() {
                            var t = e(this),
                                o = t.find(".collection-grid__item:not(.collection-grid__item--button)");
                            if (o.length > 5) {
                                if (d) t.find(".collection-grid__item--button").show();
                                else {
                                    var i = t.find(".collection-grid__item").eq(4);
                                    i.find(".collection-grid__item-tag--more-colors").show(), i.find(".quick-view--attached").hide()
                                }
                                o.each(function(t) {
                                    t > 4 && !d || t > 5 ? e(this).hide() : e(this).show()
                                })
                            } else o.show()
                        })
                    },
                    renderDesktopFilters: function(t, o, a) {
                        function r(e, t) {
                            var o = 0,
                                a = "",
                                s = "",
                                r = t === i ? g : b,
                                d = r && r.indexOf(e.toString()) > -1 ? "checked" : "";
                            if (t === n && e >= "E") {
                                o = e.charCodeAt() - "D".charCodeAt() + 1;
                                for (var l = 0; l < o; l++) a += "D";
                                s = '<br><span class="filter-option__d-notation">' + a + "</span>"
                            }
                            var c = '<div class="filter-option">  <input class="filter-option__input" data-bra-size-type=' + t + ' data-filter-type="size" id="desktop-filter-' + t + "-size-" + e + '" name="' + t + '" type="checkbox" value="' + e + '"' + d + '>  <label class="filter-option__label filter-option__label--size' + (o > 0 ? " filter-option__label--has-d-notation" : "") + '" for="desktop-filter-' + t + "-size-" + e + '">' + e + s + "</label></div>";
                            return c
                        }
                        0 === colorFilters.length && 0 === sizeFilters.length && 0 !== _.elements.all_bras.length && (_.methods.json_filters.capColorsUnfiltered(), _.elements.collection_area.find(".collection-grid__item--button").hide());
                        var d = e(".product-filters__desktop-colors-filter > .filter-options--colors"),
                            c = e(".product-filters__desktop-sizes-filter"),
                            u = "",
                            m = _.methods.json_filters.shouldAddOtherSizes();
                        if (_.methods.json_filters.hasBraProductType()) {
                            if (!l && !m) {
                                var p = _.methods.product_page._queryStringObject().expand_filters,
                                    h = p ? _.methods.persona.getBraSize() : null,
                                    f = _.methods.product_page._queryStringObject().landing_bra_size || h || "",
                                    v = f ? [f.slice(0, 2)] : null,
                                    w = v ? [f.slice(2).replace("-5", "½")] : null,
                                    g = v || _.methods.json_filters.getStoredSelectedFilters(i),
                                    b = w || _.methods.json_filters.getStoredSelectedFilters(n),
                                    y = _.methods.json_filters.getStoredSelectedFilters(s);
                                _.methods.json_filters.initializeBandCupSizeAndColorSelectedFilters(g, b, y), v && w && (ThirdLove.methods.persona.storeBand(v[0]), ThirdLove.methods.persona.storeCup(w[0]))
                            }
                            if (t && t.bras) {
                                var z = Object.keys(t.bras).map(function(e) {
                                        return r(e, n)
                                    }).join(""),
                                    C = t.bras.C.map(function(e) {
                                        return r(e, i)
                                    }).join("");
                                u += '<div class="filter-options filter-options--sizes"><h3 class="filter-options__heading">Band Size</h2><div class="filter-options__filter-group">' + C + '</div></div><div class="filter-options filter-options--sizes filter-options--hidden" id="js-cup-size-filter-options"><h3 class="filter-options__heading">Cup Size</h3><div class="filter-options__filter-group">' + z + "</div></div>"
                            }
                        } else if (m && t && t.other) {
                            var k = _.methods.json_filters._buildSizeBubble(t, "desktop-filter-size-", "filter-option__label--other-size");
                            u += '<div class="filter-options filter-options--sizes"><div class="filter-options__filter-group">' + k + "</div></div>", e(".filter-options--sizes").addClass("filter-options--other-sizes")
                        }
                        c.html(u);
                        var S = "";
                        e.each(o, function(e) {
                            a.indexOf(e) !== -1 && (S += '<div class="filter-option"><input class="filter-option__input" data-filter-type="color" id="desktop-filter-color-' + e + '" type="checkbox" value="' + e + '"><label class="filter-option__label filter-option__label--color" for="desktop-filter-color-' + e + '" style="color: ' + o[e].hexColor + ';"></label></div>')
                        }), d.html(S)
                    },
                    _buildSizeBubble: function(e, t, o) {
                        var i = {
                                XXL: "1X"
                            },
                            n = _.methods.json_filters._productXL(),
                            a = t || "mobile-filter-size-",
                            s = o || "filter-option__label--other-size";
                        return e.other.map(function(e) {
                            var t = e,
                                o = "",
                                r = i[e],
                                d = r && n ? a + r : a + e;
                            return r ? n && (t = r, o = '<div class="filter-option"><input class="filter-option__input" data-filter-type="size" id="' + d + '" type="checkbox" value="' + t + '"><label class="filter-option__label ' + s + '" for="' + d + '">' + t + "</label></div>") : o = '<div class="filter-option"><input class="filter-option__input" data-filter-type="size" id="' + d + '" type="checkbox" value="' + t + '"><label class="filter-option__label ' + s + '" for="' + d + '">' + t + "</label></div>", o
                        }).join("")
                    },
                    renderMobileFilters: function(t, o, i) {
                        0 === colorFilters.length && 0 === sizeFilters.length && 0 !== _.elements.all_bras.length && _.methods.json_filters.capColorsUnfiltered();
                        var n = e(".mobile-filter__tab.filter-options--colors"),
                            r = "",
                            d = e(".mobile-filter__tab.filter-options--sizes"),
                            c = "",
                            u = _.methods.json_filters.shouldAddOtherSizes();
                        if (_.methods.json_filters.hasBraProductType() && t && t.bras) {
                            if (!l && !u) {
                                var m = _.methods.product_page._queryStringObject().expand_filters,
                                    p = m ? _.methods.persona.getBraSize() : null,
                                    h = _.methods.product_page._queryStringObject().landing_bra_size || p || "",
                                    f = h ? [h.replace("-5", "½")] : null,
                                    v = f || _.methods.json_filters.getStoredSelectedFilters(a),
                                    w = _.methods.json_filters.getStoredSelectedFilters(s);
                                _.methods.json_filters.initializeSizeAndColorSelectedFilters(v, w)
                            }
                            e.each(t.bras, function(e, t) {
                                var o = "";
                                t.forEach(function(t) {
                                    o += '<div class="filter-option"><input class="filter-option__input" data-filter-type="size" id="mobile-filter-size-' + t + e + '" type="checkbox" value="' + t + e + '"><label class="filter-option__label filter-option__label--size" for="mobile-filter-size-' + t + e + '">' + t + e + "</label></div>"
                                });
                                if (e >= "E") {
                                    for (var i = e.charCodeAt() - "D".charCodeAt() + 1, n = "", a = 0; a < i; a++) n += "D";
                                    c += '<div class="filter-options__filter-group"><div class="filter-option--group-heading -large">' + e + '<div class="filter-option__small-heading">(' + n + ")</div></div>" + o + "</div>"
                                } else c += '<div class="filter-options__filter-group"><div class="filter-option--group-heading">' + e + "</div>" + o + "</div>"
                            })
                        }
                        u && (c = _.methods.json_filters._buildSizeBubble(t, "mobile-filter-size-", "filter-option__label--size")), d.html(c), e.each(o, function(e) {
                            i.indexOf(e) !== -1 && (r += '<div class="filter-option"><input class="filter-option__input" data-filter-type="color" id="mobile-filter-color-' + e + '" type="checkbox" value="' + e + '"><label class="filter-option__label filter-option__label--color" for="mobile-filter-color-' + e + '" style="color: ' + o[e].hexColor + ';"></label></div>')
                        }), n.html(r)
                    },
                    shouldAddOtherSizes: function() {
                        var e = window.productTypes.some(function(e) {
                            return ["Sleepwear", "Underwear", "Panties", "Camisoles"].indexOf(e) > -1
                        });
                        return e
                    },
                    _productXL: function() {
                        return window.productTypes.some(function(e) {
                            var t = window.productTypesXL || ["Underwear", "Panties"];
                            return t.indexOf(e) > -1
                        })
                    },
                    initializeBandCupSizeAndColorSelectedFilters: function(t, o, i) {
                        var n = _.methods.product_page._queryStringObject().expand_filters;
                        t.length > 0 || o.length > 0 || i.length > 0 ? setTimeout(function() {
                            _.methods.json_filters.toggleDesktopCupSizeFilters(), o.forEach(function(t) {
                                e(".filter-option__input[value=" + t + "]").change()
                            }), i.forEach(function(t) {
                                var o = e(".filter-option__input[value=" + t + "]");
                                o.prop("checked", !0), o.change()
                            })
                        }, 0) : n && setTimeout(function() {
                            e('.product-filters__toggle--desktop[data-filter-dropdown="sizes"]').click()
                        }, 0)
                    },
                    initializeSizeAndColorSelectedFilters: function(t, o) {
                        var i = _.methods.product_page._queryStringObject().expand_filters;
                        t.length > 0 || o.length > 0 ? setTimeout(function() {
                            t.forEach(function(t) {
                                var o = e(".filter-option__input[value=" + t + "]");
                                o.prop("checked", !0), o.change()
                            }), o.forEach(function(t) {
                                var o = e(".filter-option__input[value=" + t + "]");
                                o.prop("checked", !0), o.change()
                            })
                        }, 0) : i && setTimeout(function() {
                            e(".product-filters__mobile-filter-button").click()
                        }, 0)
                    },
                    getStoredSelectedFilters: function(e) {
                        var t, o, r;
                        if (_.methods.json_filters.shouldOverrideSizeFilter()) r = [];
                        else {
                            e === a ? (t = "_tl_selected_size_filters", o = _.methods.persona.getBraSize()) : e === i ? (t = "_tl_selected_band_size_filters", o = _.methods.persona.getBand()) : e === n ? (t = "_tl_selected_cup_size_filters", o = _.methods.persona.getCup()) : e === s && (t = "_tl_selected_color_filters");
                            var d = Cookies.get(t);
                            r = d ? JSON.parse(d) : [], o && r.indexOf(o) < 0 && r.push(o)
                        }
                        return r
                    },
                    shouldOverrideSizeFilter: function() {
                        var e = "utm_collections",
                            t = "no_filter" === window.getParameterByName(e);
                        return t
                    },
                    toggleDesktopCupSizeFilters: function() {
                        var t = e('.filter-option__input[data-bra-size-type="band"]:checked').map(function() {
                            return e(this).val()
                        }).toArray();
                        e("#js-cup-size-filter-options").toggleClass("filter-options--hidden", 0 === t.length);
                        var o = [],
                            i = [];
                        t.forEach(function(e) {
                            var t = window.disabledBandAndCupPairs[parseInt(e, 10)];
                            i.push(t || [])
                        }), i.length > 0 && (o = i.shift().reduce(function(e, t) {
                            return e.indexOf(t) === -1 && i.every(function(e) {
                                return e.indexOf(t) !== -1
                            }) && e.push(t), e
                        }, [])), e('.filter-option__input[data-bra-size-type="cup"]').each(function() {
                            var t = o.indexOf(e(this).val()) !== -1;
                            e(this).prop("disabled", t), t && e(this).prop("checked", !1).change()
                        })
                    },
                    addFilter: function(t, o, i) {
                        var n = "",
                            s = "",
                            r = o === a ? window.sizeFilters : window.colorFilters;
                        r.indexOf(t) === -1 && (s = '<span class="filter-options__option pill" data-filter-type="' + o + '" data-filter-value="' + t + '">' + t + n + '<span class="pill__close"><svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g class="close-button" id="x" fill="#444444"><polygon id="Page-1" points="7.42857143 0 4.00057143 3.42857143 0.571428571 0 0 0 0 0.572 3.42914286 4 0 7.42914286 0 8 0.571428571 8 4.00057143 4.57142857 7.42857143 8 8.00057143 8 8.00057143 7.42914286 4.572 4 8.00057143 0.572 8.00057143 0"></polygon></g></g></svg></span></span>', r.push(t), e('[value="' + t + '"]').each(function() {
                            e(this).prop("checked", !0)
                        }), e(".filter-options--filters").append(s), _.methods.json_filters.filterProducts()), _.methods.json_filters.storeAllSelectedFilters(o, i)
                    },
                    removeFilter: function(t, o, i) {
                        var s = o === a ? sizeFilters : colorFilters;
                        if (s.indexOf(t) !== -1) {
                            var r = s.splice(s.indexOf(t));
                            if (r.shift(), o === a) {
                                var l = _.methods.json_filters.splitBraSize(t),
                                    c = !0,
                                    u = !0,
                                    m = 0 === e('[data-bra-size-type="cup"]:checked').length;
                                sizeFilters = s.concat(r), window.sizeFilters.forEach(function(e) {
                                    var t = _.methods.json_filters.splitBraSize(e);
                                    c && t.band === l.band && (c = !1), u && t.cup === l.cup && (u = !1)
                                }), c && !m && (e("#desktop-filter-band-size-" + l.band).prop("checked", !1), _.methods.json_filters.toggleDesktopCupSizeFilters()), !d && l && l.cup && (i = n), u && e("#desktop-filter-cup-size-" + l.cup).prop("checked", !1)
                            } else colorFilters = s.concat(r);
                            e('.filter-options__option[data-filter-value="' + t + '"]').remove(), e('[value="' + t + '"]').each(function() {
                                e(this).prop("checked", !1)
                            }), _.methods.json_filters.filterProducts()
                        }
                        _.methods.json_filters.storeAllSelectedFilters(o, i)
                    },
                    clearFilters: function() {
                        sizeFilters = [], colorFilters = [], e(".filter-options--filters").empty(), e(".filter-option__input").each(function() {
                            e(this).prop("checked", !1)
                        }), e(".filter-option__label--highlight").removeClass("filter-option__label--highlight"), _.methods.json_filters.filterProducts()
                    },
                    clearFilterValues: function() {
                        sizeFilters = [], colorFilters = []
                    },
                    carriedBraSize: function(e) {
                        var t = _.methods.json_filters.splitBraSize(e);
                        return window.availableSizes.bras[t.cup].indexOf(parseInt(t.band)) !== -1
                    },
                    addBackGridItem: function(t) {
                        var o = t.find(".collection-grid__item-tag");
                        o.length && t.attr("data-original-tag") && t.attr("data-original-tag").length > 0 ? o.first().html(t.attr("data-original-tag")) : "Sold Out" === o.first().html() && o.remove();
                        var i = t.attr("data-collection"),
                            n = t.attr("data-order") && parseInt(t.attr("data-order")) || 1,
                            a = e('.collection-grid__container[data-collection="' + i + '"]'),
                            s = a.children(':not([data-item-type="upsell"])').filter(function(t, o) {
                                return parseInt(e(o).attr("data-order")) < n
                            }).last();
                        s.length > 0 ? t.detach().insertAfter(s) : (t.detach(), a.prepend(t)), t.show()
                    },
                    productFilterCheck: function(t) {
                        var o = e(t),
                            i = o.data("filters");
                        i = i && i.split(",") || [];
                        var n = !1,
                            a = !1,
                            s = function(e) {
                                var t = "gift-card" === e || "promote" === e;
                                return a || (a = t), t
                            };
                        n = 0 === colorFilters.length ? i.some(function(e) {
                            return sizeFilters.indexOf(e) > -1 || s(e)
                        }) : 0 === sizeFilters.length ? i.some(function(e) {
                            return colorFilters.indexOf(e) > -1 || s(e)
                        }) : i.some(function(e) {
                            return sizeFilters.indexOf(e) > -1 || s(e)
                        }) && i.some(function(e) {
                            return colorFilters.indexOf(e) > -1 || s(e)
                        }), n ? (o.removeClass("filtered"), o.show(), o.removeClass("sold-out"), _.methods.json_filters.setOutOfStockNotifyMe(t, sizeFilters, i, a)) : (o.hide(), o.addClass("filtered"))
                    },
                    showNotifyMeMessage: function() {
                        _.elements.notify_me_container.show(), _.elements.notify_me_container.find(".t-heading--large, .dropdown-arrow").hide();
                        var t = "We couldn’t find what you’re looking for, but we’re working hard to expand our size range. Receive an email notification when your size becomes available.";
                        _.elements.notify_me_container.find(".collection-grid__empty-container-filter").html(t), _.elements.notify_me_container.find("#notifyme-trigger").show(), e("#notifyme").data("sizes", sizeFilters).data("colors", colorFilters), _.elements.all_bras.find(".t-heading--large.product-family__title").first().hide()
                    },
                    filterProducts: function() {
                        _.elements.notify_me_container.hide(), _.elements.collection_area.find(".product-family_collection.collection-grid").show(), _.elements.filtered_area.hide(), window.quickViewBootstrap && window.quickViewBootstrap.resetHandlers();
                        var i = 0 === sizeFilters.length ? "" : "(" + e(".mobile-filter__tab.filter-options--sizes input:checked").length + ")",
                            n = 0 === sizeFilters.length ? "" : "(" + e(".mobile-filter__tab.filter-options--bra-sizes input:checked").length + ")",
                            a = 0 === colorFilters.length ? "" : "(" + e(".mobile-filter__tab.filter-options--colors input:checked").length + ")",
                            s = _.methods.product_page._queryStringObject(),
                            r = s.landing_bra_size ? s.landing_bra_size : "",
                            l = !("" !== r || !s.expand_filters),
                            c = _.elements.collection_area.find(".collection-grid__item").not(".collection-grid__item--quote, .collection-grid__item--hero-image"),
                            u = _.elements.filtered_area.find(".collection-grid__item");
                        if ("undefined" == typeof _.properties.firstTimeFiltered ? _.properties.firstTimeFiltered = !0 : _.properties.firstTimeFiltered = !1, e("#js-size-filter-count").text(i), e("#js-color-filter-count").text(a), e("#js-bra-size-filter-count").text(n), 0 === colorFilters.length && 0 === sizeFilters.length) _.elements.recommended_area.hide(), _.elements.collection_area.find(".collection-grid").show(), _.elements.collection_area.find(".product-family").show(), _.elements.collection_area.find(".collection-grid__item:not(.sold-out, .collection-grid__item--button, .collection-grid__item--other-size)").show(), u.each(function(t, o) {
                            var i = e(o);
                            i.removeClass("filtered"), i.removeClass("sold-out"), _.methods.json_filters.addBackGridItem(i)
                        }), (r || l) && (_.methods.json_filters.resetCollectionTitle(), _.elements.all_bras.find(".t-heading--large.product-family__title").show()), _.elements.collection_area.show();
                        else {
                            c.each(function(e, t) {
                                _.methods.json_filters.productFilterCheck(t)
                            }), u.each(function(e, t) {
                                _.methods.json_filters.productFilterCheck(t)
                            }), _.elements.collection_area.find(".t-heading--large.product-family__title").filter(":not(.header-with-dropdown)").hide(), _.elements.collection_area.find(".collection-grid__item-tag--more-colors").hide(), d || _.elements.collection_area.find(".quick-view--attached").show(), _.elements.filtered_products.show();
                            var m = _.elements.recommended_area.find(".sold-out .collection-grid__item-link:after");
                            m.show();
                            var p = t.width() < o;
                            if ((r || l) && _.properties.firstTimeFiltered) {
                                if (l && _.properties.firstTimeFiltered && !p) {
                                    var h = _.elements.bras.find(".product-filters.product-filters--desktop.-showing-sizes");
                                    h.removeClass("-showing-sizes"), h.find(".-active").removeClass("-active"), h.find(".-inactive").removeClass("-inactive")
                                }
                                var f = "";
                                r ? f = "Bras in " + r.replace("-5", "½") : l && sizeFilters.length > 0 && (f = "Bras in " + sizeFilters[0]), _.methods.json_filters.setCollectionTitle(f), _.elements.collection_titles.first().show()
                            } else _.elements.collection_titles.first().hide();
                            e("#waitlist-confirm").hide(), e("#notifyme-trigger").hide(), _.elements.recommended_area.hide(), _.elements.collection_area.find('.collection-grid__item[data-item-type="upsell"]').show(), _.elements.collection_area.find(".collection-grid__container").removeClass("collection-grid__container--bottomless");
                            var v = _.elements.filtered_area.find(".collection-grid__container");
                            _.elements.collection_area.find(".collection-grid__item.sold-out").detach().appendTo(v), _.elements.collection_area.find(".collection-grid__item.filtered").detach().appendTo(v), _.elements.collection_area.show(), u.not(".filtered, .sold-out").each(function(t, o) {
                                _.methods.json_filters.addBackGridItem(e(o))
                            });
                            var w = _.elements.collection_area.find(".product-family__collection");
                            w.each(function() {
                                var t = e(this).find(".collection-grid__container").children(),
                                    o = t.not('.collection-grid__item--quote, .collection-grid__item--hero-image, [data-item-type="upsell"]');
                                0 === o.length ? e(this).hide() : e(this).show()
                            })
                        }
                        _.elements.notify_me_container.hide();
                        var g = _.elements.collection_area.find('.collection-grid__item:not([data-item-type="upsell"], .collection-grid__item--quote, .collection-grid__item--hero-image)');
                        if (0 === g.find(":not(.sold-out)").length && _.methods.json_filters.filterOthersInSize()) {
                            _.elements.recommended_area.show();
                            var b = _.elements.collection_area.find('.collection-grid__item.sold-out:not([data-item-type="Gift Card"],[data-item-type="upsell"])').length > 0;
                            _.elements.collection_area.toggle(b), _.elements.collection_area.find(".collection-grid__container").toggleClass("collection-grid__container--bottomless", b)
                        } else if (0 === g.length) {
                            var y = "";
                            colorFilters.length && sizeFilters.filter(_.methods.json_filters.carriedBraSize).length ? (y = "Sorry, we couldn’t find the color selection(s) you’re looking for.", _.elements.notify_me_container.find(".collection-grid__empty-container-filter").html(y), _.elements.notify_me_container.show()) : (y = "We couldn’t find what you’re looking for, but we’re working hard to expand our size range. Receive an email notification when your size becomes available.", _.methods.json_filters.showNotifyMeMessage())
                        }
                        var z = _.elements.all_bras.find(".collection-grid__item:visible"),
                            C = z.filter(function(t, o) {
                                var i = e(this);
                                if (i.data().hasOwnProperty("filters")) {
                                    var n = i.data("filters").split(",");
                                    return !(n.indexOf("promote") > -1)
                                }
                                return !1
                            });
                        0 === C.length && z.length > 0 && _.methods.json_filters.showNotifyMeMessage();
                        var k = _.elements.collection_area.find('[data-item-type="upsell"]').first(),
                            S = _.elements.collection_area.find(".product-family__collection").filter(":visible").first();
                        if (S.length > 0) {
                            var j = S.find('.collection-grid__item:not([data-item-type="upsell"], .collection-grid__item--hero-image)');
                            if (j.length > 0) {
                                var T = j.first();
                                k && T && k.insertAfter(T)
                            }
                        }
                        if (0 === colorFilters.length && 0 === sizeFilters.length && 0 !== _.elements.all_bras.length && _.methods.json_filters.capColorsUnfiltered(), sizeFilters.length > 0) {
                            var P = sizeFilters[0],
                                x = _.elements.collection_area.find('.collection-grid__item:not(.collection-grid__item--quote,[data-item-type="upsell"])'),
                                O = window.productTypes.indexOf("Bra") > -1,
                                B = _.methods.persona.getBraSize();
                            O && B && sizeFilters.indexOf(B) !== -1 && (P = B);
                            for (var I = _.methods.json_filters.get_filters_query_string(P, O), D = 0; D < x.length; D++) {
                                var V = e(x[D]).find("a").attr("href");
                                if (V) {
                                    var A = V.split("?")[0];
                                    e(x[D]).find("a").attr("href", A + I)
                                }
                            }
                        }
                        window.quickViewBootstrap && window.quickViewBootstrap.bootstrap(sizeFilters[0])
                    },
                    filterOthersInSize: function() {
                        var t = _.elements.other_sizes_collection_area.find(".collection-grid__item"),
                            o = !1,
                            i = !1,
                            n = !1,
                            a = !1,
                            s = [],
                            d = r,
                            l = _.elements.recommended_area.find(".collection-grid__container");
                        _.elements.recommended_area.find(".collection-grid__item").remove();
                        var c = [];
                        for (t.each(function() {
                                var t = e(this).data("filters") ? e(this).data("filters").split(",") : [],
                                    r = _.methods.json_filters.getProductOutOfStockSizes(this),
                                    u = t.filter(function(e) {
                                        return !(sizeFilters.indexOf(e) < 0 || r.indexOf(e) > -1) && (c.push(e), !0)
                                    });
                                if (0 !== u.length) {
                                    var m = e(this).attr("data-item-name"),
                                        p = e(this).clone();
                                    !o && m.indexOf("t-shirt") > -1 ? (o = !0, --d, p.appendTo(l)) : !n && m.indexOf("full coverage") > -1 ? (n = !0, --d, p.appendTo(l)) : !a && m.indexOf("strapless") > -1 ? (a = !0, --d, p.appendTo(l)) : !i && m.indexOf("plunge") > -1 ? (i = !0, --d, p.appendTo(l)) : s.push(p)
                                }
                            }); d > 0 && s.length > 0;) s.pop().appendTo(l), --d;
                        var u = _.methods.json_filters.getReadableFilterSizes(c.filter(function(e, t, o) {
                            return o.indexOf(e) === t
                        }));
                        return _.elements.recommended_area.find(".product-family__title span").html(u), d !== r
                    },
                    setCollectionTitle: function(e) {
                        _.properties.originalCollectionTitle || (_.properties.originalCollectionTitle = _.elements.collection_titles.first().text()), _.elements.collection_titles.first().text(e)
                    },
                    resetCollectionTitle: function() {
                        if (_.properties.originalCollectionTitle) {
                            var e = _.properties.originalCollectionTitle;
                            _.elements.collection_titles.first().text(e)
                        }
                    },
                    setOutOfStockNotifyMe: function(t, o, i, n) {
                        if (!n) {
                            var a = _.methods.json_filters.getProductOutOfStockSizes(t);
                            if (!(o.length < 1 || a.length < 1)) {
                                var s = o.filter(function(e) {
                                        return i.indexOf(e) > -1
                                    }),
                                    r = s.filter(function(e) {
                                        return a.indexOf(e) > -1
                                    });
                                if (!(s.length > 0 && r.length < s.length)) {
                                    var d = e(t).addClass("sold-out").find("a"),
                                        l = d.find(".collection-grid__item-tag");
                                    l.length ? ("Sold Out" !== l.first().html() && e(t).attr("data-original-tag", l.first().html()), l.first().html("Sold Out")) : (e(t).attr("data-original-tag", ""), d.prepend('<div class="collection-grid__item-tag" data-category="' + window.TLTemplateName + '" data-track="nft" data-label="' + l.find("img").data("label") + '">Sold Out</div>'))
                                }
                            }
                        }
                    },
                    getProductOutOfStockSizes: function(t) {
                        var o = e(t).data("out-of-stock-sizes") || "";
                        return o.split(",").filter(function(e) {
                            return "" !== e
                        })
                    },
                    getReadableFilterSizes: function(e) {
                        return [e.slice(0, -1).join(", "), e.slice(-1)[0]].join(e.length < 2 ? "" : " and ")
                    },
                    get_filters_query_string: function(e, t) {
                        var o = "";
                        return t && (e = e.replace("½", "-5"), o = "bra_"), "?" + o + "size=" + e
                    },
                    storeAllSelectedFilters: function(t, o) {
                        var r = 1 / 24,
                            d = function(t, o) {
                                var i, n;
                                t === a ? o ? (i = '.filter-option__input[data-filter-type="size"][data-bra-size-type="' + o + '"]:checked', n = "_tl_selected_" + o + "_size_filters") : (i = '.filter-option__input[data-filter-type="size"]:checked', n = "_tl_selected_size_filters") : t === s && (i = '.filter-option__input[data-filter-type="color"]:checked', n = "_tl_selected_" + t + "_filters");
                                var d = e(i).map(function() {
                                    return this.value
                                }).toArray();
                                d.length > 0 ? Cookies.set(n, JSON.stringify(d), {
                                    expires: r
                                }) : Cookies.remove(n)
                            };
                        !l && _.methods.json_filters.hasBraProductType() && (o ? (d(a, i), d(a, n)) : d(t))
                    },
                    hasBraProductType: function() {
                        return window.productTypes.indexOf("Bra") > -1
                    },
                    handleDomReady: function() {
                        e(document).on("click", ".pill__close", function() {
                            var t = e(this).parent(),
                                o = t.data("filter-value"),
                                i = t.data("filter-type");
                            _.methods.json_filters.removeFilter(o, i)
                        }), e(".tabs__input").change(function() {
                            var t = e(this);
                            if (t.prop("checked")) {
                                e(".product-filters__toggle").removeClass("product-filters__toggle--active"), e(".tabs__label").removeClass("tabs__label--active");
                                var o = t.prop("id");
                                e("[for=" + o + "]").each(function() {
                                    var t = e(this);
                                    t.hasClass("product-filters__toggle") ? (t.addClass("product-filters__toggle--active"), t.prop("for", "toggle-product-filters")) : t.hasClass("tabs__label") && t.addClass("tabs__label--active")
                                })
                            }
                        }), e("#js-other-sizes button").click(function(e) {
                            e.preventDefault();
                            var t = "/collections/bras";
                            window.location = t
                        }), e("#notifyme_button").on("click", function() {
                            e("#notifyme .email-submit").val(), e("#notifyme").data("sizes"), e("#notifyme").data("colors");
                            e("#waitlist-confirm").show().addClass("hover"), setTimeout(function() {
                                e("#waitlist-confirm").removeClass("hover")
                            }, 2500), e("#notifyme-trigger").hide(), e(".modal-close").click()
                        }), e(".product-filters__toggle--desktop").click(function() {
                            var t = e(this).data("filter-dropdown");
                            if ("bra-sizes" == t) var o = ["sizes", "colors"];
                            else if ("sizes" == t) var o = ["bra-sizes", "colors"];
                            else var o = ["sizes", "bra-sizes"];
                            var i = e(".product-filters--desktop");
                            e(this).hasClass("-active") ? (i.removeClass("-showing-sizes -showing-colors -showing-bra-sizes"), e(".product-filters__toggle--desktop").removeClass("-active -inactive")) : e(this).hasClass("-inactive") ? (o.forEach(function(t) {
                                i.removeClass("-showing-" + t), e(".product-filters__desktop-" + t + "-filter").hide()
                            }), e(".product-filters__desktop-" + t + "-filter").show(), e(".product-filters__toggle--desktop").removeClass("-active"), e(".product-filters__toggle--desktop").addClass("-inactive"), i.addClass("-showing-" + t), e(this).toggleClass("-active -inactive")) : (e('[class^="product-filters__desktop"]').hide(), e(".product-filters__desktop-" + t + "-filter").show(), i.addClass("-showing-" + t), e(this).addClass("-active"), e(".product-filters__toggle--desktop").not(this).addClass("-inactive"))
                        }), e(".product-filters__mobile-filter-button").click(function() {
                            document.getElementsByClassName("mobile-filter")[0].style.display = "flex", e("html").addClass("mobile-filter-overflow")
                        }), e(".js-close-mobile-filter").click(function() {
                            document.getElementsByClassName("mobile-filter")[0].style.display = "none", e("html").removeClass("mobile-filter-overflow")
                        }), e(".js-clear-filters").click(function() {
                            _.methods.json_filters.clearFilters()
                        })
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {})
        }), t.on(window.object_name + "._document_ready", function(t, o) {
            e(o.elements.collection_area) && o.methods.json_filters.handleDomReady()
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = 1024,
            i = 768,
            n = 20,
            a = 1e3,
            s = 5e3,
            r = "div-mobile-product-video",
            d = "div-desktop-product-video",
            l = "div-mobile-customer-video",
            c = "div-desktop-customer-video",
            _ = "div-pdp-video",
            u = "div-modal-pdp-video";
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                pdp_video_module: "#pdp-video-module",
                pdp_video_container: "#div-pdp-video",
                pdp_video_modal_wrapper: ".video__modal",
                pdp_video_modal: "#div-modal-pdp-video",
                pdp_video_play_icon: ".video__player .js-icon-play-video",
                pdp_video_modal_close: "#div-modal-close"
            })
        }), t.on(window.object_name + ".add_methods", function(t, m) {
            m.methods._add("methods", {
                product_page_videos: {
                    isMobileVersion: function() {
                        return window.innerWidth < o
                    },
                    initializeVideoPlayer: function(e, t, o) {
                        var i = jwplayer(e.container);
                        if (i.id) {
                            var n = {
                                autostart: !1,
                                controls: e.controls || !1,
                                mute: !1,
                                file: e.url,
                                image: e.posterImageURL,
                                title: e.title
                            };
                            i.setup(n), console.log("Initialized " + i.id + " instance"), m.methods.product_page_videos._tooglePlaybackOnClick(i, e.showPlayButton, t, o), m.methods.product_page_videos._showSpinnerWhileVideoIsBuffering(i)
                        }
                    },
                    cleanupExistingVideoPlayers: function() {
                        var e, t = m.methods.product_page_videos.isMobileVersion(),
                            o = t ? l : c;
                        e = jwplayer(o), e.id && (e.on("remove", function() {
                            console.log("Destroyed " + e.id + " instance")
                        }), e.remove());
                        var i = m.methods.product_page_videos.getVideoContainerId,
                            n = t ? r : d,
                            a = !!window.imageStyles,
                            s = a && Object.keys(window.imageStyles) || [""];
                        s.forEach(function(t) {
                            var o = i(n, t);
                            e = jwplayer(o), e.id && (e.on("remove", function() {
                                console.log("Destroyed " + e.id + " instance")
                            }), e.remove())
                        })
                    },
                    _notifySubscribersVideoInitialized: function(e) {
                        var t = new CustomEvent("videoInitialized", {
                            detail: {
                                videoContainer: e.id
                            }
                        });
                        document.dispatchEvent(t)
                    },
                    _tooglePlaybackOnClick: function(t, o, i, n) {
                        o && t.on("displayClick", function() {
                            var t = e(this).attr("id");
                            m.methods.product_page_videos._togglePlayback(t, i, n)
                        })
                    },
                    _showSpinnerWhileVideoIsBuffering: function(t) {
                        var o = e("#" + t.id);
                        o.hide();
                        var i = o.parent(),
                            n = '<img alt="Loading..." class="spinner" src="' + window.iconsURL.spinner + '">';
                        i.append(n), m.methods.product_page_videos._checkVideoBuffering(t)
                    },
                    _checkVideoBuffering: function(e) {
                        var t, o, i, r, d = e.id,
                            l = e.getBuffer();
                        this.bufferingData = this.bufferingData || {}, this.bufferingData[d] = this.bufferingData[d] || {};
                        var c = this.bufferingData[d];
                        t = c.lastKnownBuffer, o = c.timeLastKnownBuffer, o && (i = (new Date).getTime() - o.getTime(), r = l === t && (window.isMobile() || l > 0) && i >= s), l > n || r ? (m.methods.product_page_videos._hideSpinnerShowVideoPlayer(e.id), m.methods.product_page_videos._notifySubscribersVideoInitialized(e)) : (l !== t && (c.lastKnownBuffer = l, c.timeLastKnownBuffer = new Date), setTimeout(function() {
                            m.methods.product_page_videos._checkVideoBuffering(e)
                        }, a))
                    },
                    _milsecsToMinsAndSecs: function(e) {
                        var t = Math.floor(e / 6e4),
                            o = (e % 6e4 / 1e3).toFixed(0);
                        return t + ":" + (o < 10 ? "0" : "") + o
                    },
                    _hideSpinnerShowVideoPlayer: function(t) {
                        var o = e("#" + t);
                        o.show();
                        var i = o.parent().find(".spinner");
                        i.hide(), m.methods.product_page_videos.tooglePlayButton(t, !0)
                    },
                    tooglePlayButton: function(e, t) {
                        var o = m.methods.product_page_videos._getPlayButton(e),
                            i = "icon-play-video--hidden";
                        t ? o.removeClass(i) : o.addClass(i)
                    },
                    _getPlayButton: function(t) {
                        var o = e("#" + t),
                            i = o.parent().find(".js-icon-play-video");
                        return i
                    },
                    _showVideoOverlay: function() {
                        var e = m.methods.product_page_videos._getVideoOverlay();
                        e.show()
                    },
                    _hideVideoOverlay: function() {
                        var e = m.methods.product_page_videos._getVideoOverlay();
                        e.hide()
                    },
                    _getVideoOverlay: function() {
                        var t = e(".js-video-overlay");
                        return t
                    },
                    _togglePlayback: function(e, t, o) {
                        m.methods.product_page_videos._isVideoPlaying(e) ? m.methods.product_page_videos._pauseVideo(e) : m.methods.product_page_videos._playVideo(e, t, o)
                    },
                    _isVideoPlaying: function(e) {
                        var t = "playing";
                        return m.methods.product_page_videos._checkVideoPlaybackState(e, t)
                    },
                    _isVideoPausedOrIdle: function(e) {
                        var t = ["idle", "paused"];
                        return m.methods.product_page_videos._checkVideoPlaybackState(e, t)
                    },
                    _checkVideoPlaybackState: function(e, t) {
                        var o = "string" == typeof t ? [t] : t,
                            i = jwplayer(e),
                            n = i.id ? i.getState() : "";
                        return o.indexOf(n) > -1
                    },
                    _playVideo: function(e, t, o) {
                        var i = jwplayer(e);
                        i.id ? (m.methods.product_page_videos._trackVideoPlayer(e, t, o), i.play(), m.methods.product_page_videos.tooglePlayButton(e), m.methods.product_page_videos._hideVideoOverlay()) : setTimeout(function() {
                            m.methods.product_page_videos._playVideo(e, t, o)
                        }, a)
                    },
                    pauseAllVideosOnPDP: function() {
                        var e = [_],
                            t = [u],
                            o = m.methods.product_page_videos.isMobileVersion() ? t : e;
                        o.forEach(function(e) {
                            m.methods.product_page_videos._pauseVideo(e)
                        }), m.methods.product_page_videos._pauseAllVideosOnCarousell()
                    },
                    _pauseAllVideosOnCarousell: function() {
                        var e = !!window.imageStyles,
                            t = e && Object.keys(window.imageStyles) || [""],
                            o = [d, c],
                            i = [r, l],
                            n = m.methods.product_page_videos.isMobileVersion(),
                            a = n ? i : o;
                        a.forEach(function(e) {
                            var o = e.indexOf("product-video") > -1;
                            if (o) {
                                var i, a = m.methods.product_page_videos.getVideoContainerId;
                                t.forEach(function(t) {
                                    if (i = a(e, t), m.methods.product_page_videos._pauseVideo(i), !n) {
                                        var o = m.elements.desktop_product_slider.find(".owl-item.active"),
                                            s = !!o.find(".has-play").length;
                                        if (s) {
                                            var r = o.index(),
                                                d = r + 1,
                                                l = m.elements.desktop_product_slider.data("owl.carousel");
                                            l.to(d)
                                        }
                                    }
                                })
                            } else m.methods.product_page_videos._pauseVideo(e)
                        })
                    },
                    _pauseVideo: function(e) {
                        if ("undefined" != typeof jwplayer) {
                            var t = jwplayer(e);
                            t.id && m.methods.product_page_videos._isVideoPlaying(e) && (t.pause(), window.videoPlayerTracking.stopTrackingVideoMethods(t), m.methods.product_page_videos.tooglePlayButton(e, !0), e === l && m.methods.product_page_videos._showVideoOverlay())
                        }
                    },
                    initializeVideosOnOrientationChange: function() {
                        var e, t, o = "undefined" != typeof window.orientation ? window.orientation : screen.orientation.angle,
                            n = 0 === o,
                            a = n && window.innerWidth === i,
                            s = !n && window.innerHeight === i,
                            u = m.methods.product_page_videos.getVideoContainerId,
                            p = m.methods.product_page_videos._copyVideoData,
                            h = !!window.imageStyles,
                            f = h && Object.keys(window.imageStyles) || [""];
                        a ? (f.forEach(function(o) {
                            e = u(d, o), t = u(r, o), p(e, t)
                        }), p(c, l)) : s && (f.forEach(function(o) {
                            t = u(r, o), e = u(d, o), p(t, e)
                        }), p(l, c), this.pdpModuleVideoInitialized && (m.methods.product_page_videos.toogleVideoModal(!1), document.addEventListener("videoInitialized", function(e) {
                            var t = e.detail && e.detail.videoContainer;
                            t === _ && m.methods.product_page_videos.playPdpVideoModuleInline()
                        }), m.methods.product_page_videos.initPDPVideoModulePlayer())), m.methods.vendors._initialize_carousels()
                    },
                    _copyVideoData: function(t, o) {
                        var i = jwplayer(t);
                        if (i.id && 0 === e("#" + o).find("video").length) {
                            var n = {
                                container: o,
                                url: i.getConfig().file,
                                posterImageURL: i.getConfig().image,
                                title: i.getConfig().title
                            };
                            m.methods.product_page_videos.initializeVideoPlayer(n)
                        }
                    },
                    moveVideoToLastPosition: function(e, t) {
                        var o = Object.values(e),
                            i = o.splice(t, 1)[0];
                        return o.push(i), o
                    },
                    getPosterImageUrl: function(t) {
                        var o = e("#" + t).parent().css("background-image"),
                            i = /(?:\(['"]?)(.*?)(?:['"]?\))/,
                            n = i.exec(o),
                            a = n && n[1] || "";
                        return a
                    },
                    onScrollViewHandler: function(e) {
                        var t = m.methods.product_page_videos.getElementOffsetTop(e),
                            o = m.methods.product_page_videos.getScrollTop(),
                            i = 800,
                            n = o + i >= t;
                        if (n) {
                            var a = new CustomEvent("elementInViewport");
                            document.dispatchEvent(a)
                        }
                    },
                    getElementOffsetTop: function(e) {
                        var t = e.getBoundingClientRect(),
                            o = document.body,
                            i = document.documentElement,
                            n = window.pageYOffset || i.scrollTop || o.scrollTop,
                            a = i.clientTop || o.clientTop || 0;
                        return Math.round(t.top + n - a)
                    },
                    getScrollTop: function() {
                        var e = document.documentElement;
                        return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0)
                    },
                    _trackVideoPlayer: function(e, t, o) {
                        var i = {
                            listPlayer: [e],
                            isPdpVideo: t,
                            isPdpCarouselVideo: o
                        };
                        t && (i.extraData = {
                            videoSlot: !0
                        }), window.videoPlayerTracking.setupVideoStatistics(i)
                    },
                    getVideoContainerId: function(e, t) {
                        return e + (t ? "-" + t : "")
                    },
                    initTrackPDPVideoModulePosition: function() {
                        window.jwplayer && window.jQuery || setTimeout(m.methods.product_page_videos.initTrackPDPVideoModulePosition, 500);
                        var e = m.methods.product_page_videos.isMobileVersion();
                        m.elements.pdp_video_play_icon.on("click", function() {
                            m.methods.product_page_videos.pauseAllVideosOnPDP(), e = m.methods.product_page_videos.isMobileVersion(), e ? m.methods.product_page_videos.playPdpVideoModuleInModal() : m.methods.product_page_videos.playPdpVideoModuleInline()
                        }), e ? m.methods.product_page_videos.tooglePlayButton(_, !0) : (document.addEventListener("elementInViewport", function() {
                            m.methods.product_page_videos.stopTrackingPdpVideoModulePosition(), m.methods.product_page_videos.initPDPVideoModulePlayer()
                        }), m.methods.product_page_videos.startTrackingPdpVideoModulePosition())
                    },
                    playPdpVideoModuleInline: function() {
                        var e = jwplayer(_);
                        e.id && e.trigger("displayClick")
                    },
                    playPdpVideoModuleInModal: function() {
                        var e = !0,
                            t = !1;
                        this.pdpModuleVideoInitialized ? m.methods.product_page_videos._playVideo(u, e, t) : m.methods.product_page_videos.initPDPVideoModulePlayer(), m.methods.product_page_videos.toogleVideoModal(!0)
                    },
                    toogleVideoModal: function(e) {
                        m.elements.pdp_video_modal_close.one("click", function() {
                            m.methods.product_page_videos.toogleVideoModal(!1)
                        });
                        var t = "video__modal--hidden";
                        e ? m.elements.pdp_video_modal_wrapper.removeClass(t) : (m.methods.product_page_videos._pauseVideo(u), m.elements.pdp_video_modal_wrapper.addClass(t), m.methods.product_page_videos.scrollToElement(m.elements.pdp_video_module))
                    },
                    startTrackingPdpVideoModulePosition: function() {
                        document.addEventListener("scroll", m.methods.product_page_videos.onWindowScrollHandler)
                    },
                    stopTrackingPdpVideoModulePosition: function() {
                        document.removeEventListener("scroll", m.methods.product_page_videos.onWindowScrollHandler)
                    },
                    onWindowScrollHandler: function() {
                        m.methods.product_page_videos.onScrollViewHandler(m.elements.pdp_video_container[0])
                    },
                    initPDPVideoModulePlayer: function() {
                        var e, t = m.methods.product_page_videos.isMobileVersion(),
                            o = !0,
                            i = !1;
                        t ? (e = {
                            container: u,
                            url: m.elements.pdp_video_module.data("mobile-video-url"),
                            posterImageURL: m.elements.pdp_video_module.data("mobile-poster-image-url"),
                            title: m.elements.pdp_video_module.data("video-title"),
                            showPlayButton: !0
                        }, document.addEventListener("videoInitialized", function(e) {
                            var t = e.detail && e.detail.videoContainer;
                            t === u && (this.pdpModuleVideoInitialized = !0, m.methods.product_page_videos._playVideo(u, o, i))
                        }.bind(this))) : e = {
                            container: _,
                            url: m.elements.pdp_video_module.data("desktop-video-url"),
                            posterImageURL: m.elements.pdp_video_module.data("desktop-poster-image-url"),
                            title: m.elements.pdp_video_module.data("video-title"),
                            showPlayButton: !0
                        }, m.methods.product_page_videos.initializeVideoPlayer(e, o, i)
                    },
                    scrollToElement: function(t) {
                        t && t.length && e("html,body").animate({
                            scrollTop: t.offset().top - 200
                        }, 500)
                    }
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.elements.pdp_video_module.length > 0 && t.methods.product_page_videos.initTrackPDPVideoModulePosition()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                desktopImages: "#desktop-images",
                desktopImagesCache: "#image-cache-desktop",
                mobileImages: "#mobile-images",
                mobileImagesCache: "#image-cache-mobile",
                imageCache: "#image-cache-selector",
                verticalSlides: ".slideshow.vertical",
                imageCacheCustomerVideo: "#image-cache-customer-video"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                dynamic_images: {
                    _move_elements_of_dynamic_collection: function(t) {
                        var i = !1,
                            n = o.elements.desktopImages,
                            a = o.elements.mobileImages,
                            s = o.elements.imageCache,
                            r = o.elements.verticalSlides;
                        e.each(window.imageStyles, function(e, d) {
                            var l = t && d.indexOf(t) > -1;
                            if (l) {
                                i = !0;
                                var c = s.find("." + e),
                                    _ = o.elements.desktopImagesCache.find("." + e),
                                    u = o.elements.mobileImagesCache.find("." + e);
                                o.methods.dynamic_images._moveToContainer(c, r, o.methods.product_page.setImageSelectAttribute), o.methods.dynamic_images._moveToContainer(_, n), o.methods.dynamic_images._moveToContainer(u, a), r.find("." + e).each(function(e, t) {
                                    o.methods.product_page.setImageSelectAttribute(t, e)
                                })
                            } else o.methods.dynamic_images._moveElementsToCaches(e)
                        }), i || (o.elements.verticalSlides.find(".cycle-sentinel").remove(), e.each(window.imageStyles, function(t) {
                            var i = "." + t,
                                d = s.find(i),
                                l = o.elements.desktopImagesCache.find(i),
                                c = o.elements.mobileImagesCache.find(i),
                                _ = function(t) {
                                    var i = e(t).attr("data-original-image-select");
                                    o.methods.product_page.setImageSelectAttribute(t, i)
                                };
                            o.methods.dynamic_images._moveToContainer(d, r, _), o.methods.dynamic_images._moveToContainer(l, n), o.methods.dynamic_images._moveToContainer(c, a)
                        }))
                    },
                    _get_selected_size_dynamic_images: function() {
                        return o.methods.product_page.isBras() ? o.methods.product_page.getSelectedBandCupSize() : o.methods.product_page.getSizeUIChecked().val()
                    },
                    _append_video_thumb: function() {
                        var t = o.elements.imageCacheCustomerVideo;
                        o.elements.imageCacheCustomerVideo.each(function(i, n) {
                            var a = e(n),
                                s = a.find(".video-slot"),
                                r = a.find("#customer_video_thumb_img"),
                                d = (t.children().length - 1, o.elements.verticalSlides.find(".slide:not(.cycle-sentinel)").length);
                            s.length > 0 ? (o.methods.product_page.setImageSelectAttribute(r, d), e("#customer-video-thumb").empty().append(s.html())) : (r = e("#customer_video_thumb_img"), o.methods.product_page.setImageSelectAttribute(r, d))
                        })
                    },
                    update: function() {
                        var e = !!window.imageStyles,
                            t = o.methods.dynamic_images._get_selected_size_dynamic_images();
                        e && window.variant_data && (o.methods.product_page_videos.pauseAllVideosOnPDP(), o.methods.vendors._destroy_carousels(), e && o.methods.dynamic_images._move_elements_of_dynamic_collection(t), o.methods.dynamic_images._moveCustomerVideoToLast(), o.methods.product_page_videos.isMobileVersion() || o.methods.dynamic_images._append_video_thumb(), o.methods.vendors._initialize_carousels())
                    },
                    update_styles: function(e, t) {
                        e ? window.imageStyles = {
                            style1: t.data("style1").split(","),
                            style2: t.data("style2").split(",")
                        } : window.imageStyles = void 0
                    },
                    _moveCustomerVideoToLast: function() {
                        var e = o.elements.desktopImagesCache.find(".has-customer-video");
                        e.length > 0 && o.elements.desktopImages.append(e);
                        var t = o.elements.mobileImagesCache.find(".has-customer-video");
                        t.length > 0 && o.elements.mobileImages.append(t)
                    },
                    _moveElementsToCaches: function(e) {
                        var t = "." + e,
                            i = t,
                            n = o.elements.verticalSlides.find(i),
                            a = o.elements.imageCache,
                            s = o.elements.mobileImages.find(t),
                            r = o.elements.mobileImagesCache,
                            d = o.elements.desktopImages.find(t),
                            l = o.elements.desktopImagesCache;
                        o.methods.dynamic_images._moveToContainer(n, a, o.methods.product_page.setImageSelectAttribute), o.methods.dynamic_images._moveToContainer(d, l), o.methods.dynamic_images._moveToContainer(s, r);
                        var c = o.elements.desktopImages.find(".has-customer-video"),
                            _ = o.elements.mobileImages.find(".has-customer-video");
                        c.length > 0 && l.append(c), _.length > 0 && r.append(_)
                    },
                    _moveToContainer: function(e, t, o) {
                        var i = document.createDocumentFragment();
                        e.each(function(e, t) {
                            o && o(t, e), i.appendChild(t)
                        }), t.append(i)
                    }
                }
            })
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = {
                E: "DD",
                F: "DDD",
                G: "DDDD"
            };
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                form: ".product-variants",
                image_select: ".image-selector .slide",
                product_images: ".product-images .slide",
                reviews_show: '[data-action="reviews-show"] .js-review-show',
                product_fit_finder: "#product-fit-finder",
                product_fit_finder_holder: "#fit-finder",
                product_fit_finder_banner: "#product-fit-finder .fit-banner",
                product_fit_finder_banner_inner: "#product-fit-finder .start",
                gift_wizard_tooltip: ".gwbutton__tooltip",
                gift_wizard_tooltip_toggle_icon: ".gwbutton__question-mark--clickable-area",
                gift_wizard_tooltip_close_icon: ".gwbutton__tooltip__close-icon",
                product_squared_images: ".product-images.mobile",
                main_section: "#product-page-wrapper",
                dropdownContainer: ".js-dropdown",
                cupSizeBubbles: ".variant-selection.variant-cup-size",
                inventoryAlert: ".js-inventory",
                addToCart: ".add-to-cart",
                notifyMe: '[data-btn="notifyme"]',
                free_exchanges_banner: ".js-free-exchanges-banner",
                paypalContainer: ".js-paypal-container"
            })
        }), t.on(window.object_name + ".add_methods", function(i, n) {
            n.methods._add("methods", {
                product_page: {
                    _reviews_show: function() {
                        var o;
                        t.width() < 1024 ? n.methods.accordionPanel.scrollAndExpandPanel("reviews") : (o = e("#desktop-reviews").offset().top, e("html, body").animate({
                            scrollTop: o - 150
                        }, 750))
                    },
                    _mobile_banner_scroll: function() {
                        "inline-block" === n.elements.product_fit_finder_banner_inner.css("display") && (window.scrollY >= 150 ? n.elements.product_fit_finder_banner.addClass("fixed") : n.elements.product_fit_finder_banner.removeClass("fixed"))
                    },
                    _mobile_image_resize: function() {
                        n.elements.product_squared_images.each(function() {
                            e(this).height(e(this).width())
                        })
                    },
                    _disable_unavailable_bands: function() {
                        var t = e('[name="band-size"]').map(function(t, o) {
                            return e(o).parents("label").data("variant-value")
                        });
                        window.valid_variants && t && e(t).each(function(t, o) {
                            for (var i = 0; i < valid_variants.length; i++) {
                                var n = valid_variants[i];
                                if (n.indexOf(o) !== -1) return
                            }
                            var a = e('[data-action="variant-selection"] [data-variant-value="' + o + '"]'),
                                s = e('input[name="band-size"][value="' + o + '"]');
                            e(a).addClass("disabled"), e(s).prop("checked", !1)
                        })
                    },
                    _fetch_handle: function() {
                        if (window.location && window.location.pathname && window.location.pathname.indexOf("/products/") > -1) {
                            var e = window.location.pathname.split("/");
                            return e[e.length - 1]
                        }
                    },
                    _add_recently_viewed: function() {
                        var e = Cookies.get("_tl_recent_products"),
                            t = n.methods.product_page._fetch_handle();
                        if (t)
                            if (e && e.length > 0) {
                                var o = JSON.parse(e);
                                o.indexOf(t) === -1 && (o.length >= 4 && o.shift(), o.push(t)), Cookies.set("_tl_recent_products", JSON.stringify(o))
                            } else {
                                var e = [];
                                e.push(t), Cookies.set("_tl_recent_products", JSON.stringify(e))
                            }
                    },
                    _update_view_count: function() {
                        var e = Cookies.get("_tl_recommended_products"),
                            t = n.methods.product_page._fetch_handle();
                        if (t)
                            if (e && e.length > 0) {
                                var o = JSON.parse(e);
                                o[t] = o[t] ? o[t] + 1 : 1, Cookies.set("_tl_recommended_products", JSON.stringify(o))
                            } else {
                                var e = {};
                                e[t] = 1, Cookies.set("_tl_recommended_products", JSON.stringify(e))
                            }
                    },
                    _get_query_param: function() {
                        var e = n.methods.product_page._queryStringObject();
                        e.reviews && n.methods.product_page._reviews_show()
                    },
                    _toggle_gift_wizard_tooltip: function(e) {
                        const t = 992,
                            o = e && window.innerWidth < t || !e && window.innerWidth >= t;
                        o && n.elements.gift_wizard_tooltip.toggleClass("gwbutton__tooltip--hidden")
                    },
                    _hide_gift_wizard_tooltip: function() {
                        n.elements.gift_wizard_tooltip.addClass("gwbutton__tooltip--hidden")
                    },
                    _queryStringObject: function() {
                        return document.location.search.replace("?", "").split("&").map(function(e) {
                            return e = e.split("="), this[e[0]] = e[1], this
                        }.bind({}))[0]
                    },
                    _bb_init_var_select_setup: function() {
                        var t = n.methods.product_page._queryStringObject(),
                            o = window.activeProductHandle;
                        if (window.pdp || (window.pdp = {
                                product_type: window.productData.type,
                                selection: {}
                            }), window.variant_data)
                            if (n.methods.product_page._isUnderwear()) {
                                var i = !1,
                                    a = n.methods.persona.getUnderwearSize(),
                                    s = t && t.size || a;
                                s ? n.methods.product_page._selectDefaultSize(s) : (n.methods.product_page._dropDownInitClear(), Object.keys(window.variant_data[o].variants).some(function(e) {
                                    if (window.variant_data[o].variants[e] && parseInt(window.variant_data[o].variants[e].quantity, 10) > 0) return i = !0
                                }), i || n.methods.product_page._underwearOutOfStock())
                            } else if ("Bra" === window.productData.type) {
                            var r = n.methods.persona.getBand(),
                                d = n.methods.persona.getCup();
                            if (window.pdp = {
                                    selection: {
                                        handle: o,
                                        bandSize: r,
                                        cupSize: d
                                    }
                                }, t) {
                                if (t.ff_res || t.bra_size) {
                                    var l = t.ff_res || t.bra_size;
                                    l = l.replace("-5", "½"), r = l.substr(0, 2).toString(), d = l.substr(2, l.length).toString()
                                }
                                t.cup && (d = t.cup), t.band && (r = t.band)
                            }
                            if (e('select[name="cup-size"] option, select[name="cup-size"] option').not(":first-child").removeAttr("selected"), d && r) n.methods.product_page._selectDefaultBraSize(r, d);
                            else {
                                var c = !1;
                                n.methods.product_page._dropDownInitClear(), Object.keys(window.variant_data[o].variants).some(function(e) {
                                    if (window.variant_data[o].variants[e] && parseInt(window.variant_data[o].variants[e].quantity) > 0) return c = !0
                                }), c || n.methods.product_page._braOutOfStock()
                            }
                        }
                    },
                    isBras: function() {
                        var e = window.productData.type;
                        return e && "Bra" === e
                    },
                    _isUnderwear: function() {
                        var e = window.productData.type;
                        return e && "Panties" === e || "Camisoles" === e || "Sleepwear" === e || "Panty pack" === e
                    },
                    _isGiftCard: function() {
                        var e = window.productData.type;
                        return e && "Gift Card" === e
                    },
                    _selectDefaultSize: function(t) {
                        var o = n.methods.product_page._getSizeByHandle(activeProductHandle);
                        o.indexOf(t) > -1 ? (e('label[data-variant-value="' + t + '"]').trigger("click"), e('select[name="size"] option[value="' + t + '"]').prop("selected", "selected"), n.properties.currentSelectedSizes.size = t) : n.methods.product_page._dropDownInitClear()
                    },
                    _getSizeByHandle: function(e) {
                        var t = window.productData.sizeHandles;
                        return t.filter(function(t) {
                            return t.handle === e
                        }).map(function(e) {
                            return e.size
                        })
                    },
                    _selectDefaultBraSize: function(t, o) {
                        var i = e('label[data-variant-value="' + t + '"]'),
                            a = e('label[data-variant-value="' + o + '"]');
                        i.length && a.length ? (i.trigger("click"), e('select[name="band-size"] option[value="' + t + '"]').prop("selected", "selected"), n.properties.currentSelectedSizes["band-size"] = t, a.trigger("click"), e('select[name="cup-size"] option[value="' + o + '"]').prop("selected", "selected"), n.properties.currentSelectedSizes["cup-size"] = o) : n.methods.product_page._dropDownInitClear()
                    },
                    _underwearOutOfStock: function() {
                        var t = window.activeProductHandle,
                            o = Object.keys(window.variant_data[t].variants)[0].toString();
                        e('label[data-variant-value="' + o + '"]').trigger("click")
                    },
                    _braOutOfStock: function() {
                        var t = window.activeProductHandle,
                            o = Object.keys(window.variant_data[t].variants)[0].substr(2, 3).toString(),
                            i = Object.keys(window.variant_data[t].variants)[0].substr(0, 2).toString();
                        e('label[data-variant-value="' + i + '"]').trigger("click"), e('select[name="band-size"] option[value="' + i + '"]').prop("selected", "selected"), e('label[data-variant-value="' + o + '"]').trigger("click"), e('select[name="cup-size"] option[value="' + o + '"]').prop("selected", "selected")
                    },
                    _getVariantBySelection: function(e, t) {
                        var o, i;
                        return t && ("Bra" === t.product_type ? t.selection.bandSize && t.selection.cupSize && (i = t.selection.handle + "-" + t.selection.bandSize + t.selection.cupSize, o = window.productData.variantsForHandleAndSize[i]) : t.product_type && t.selection.size && (i = t.selection.handle + "-" + t.selection.size, o = window.productData.variantsForHandleAndSize[i])), o
                    },
                    _updateInventoryAlert: function() {
                        var e = {
                                higher: 25
                            },
                            t = n.elements.inventoryAlert,
                            o = "product-actions__inventory-alert--show",
                            i = n.methods.product_page._getVariantBySelection(window.productData, window.pdp);
                        i ? i.inventory_available && i.quantity <= e.higher ? (t.html('Only <span class="number"></span> left!'), t.addClass(o).find(".number").text(i.quantity).removeClass(o)) : i.inventory_available ? t.empty().removeClass(o) : t.html("<span>Out of stock</span>").addClass(o) : t.empty().removeClass(o)
                    },
                    _bb_get_variant_from_selected: function(t) {
                        var o, i, a = window.activeProductHandle;
                        if (window.pdp.product_type = window.productData.type, window.pdp.selection.handle = a, n.methods.product_page._isUnderwear() || n.methods.product_page._isGiftCard()) {
                            var s = n.methods.product_page.getSizeUIChecked().parents("label").data("variant-value");
                            if (s && (window.pdp.selection.size = s, i = a + "-" + s.toString()), !s) return window.pdp.variant = null, n.methods.product_page._paypal_button_disabled(), n.elements.addToCart.attr("disabled", "disabled").addClass("disabled"), void(n.methods.product_page._isGiftCard() || (n.methods.product_page._updateInventoryAlert(), n.elements.form.trigger("pdp_out_of_stock", !0)))
                        } else {
                            var r = window.pdp.selection.bandSize,
                                d = window.pdp.selection.cupSize;
                            if (!r || !d) return window.pdp.variant = null, n.methods.product_page._paypal_button_disabled(), n.methods.product_page._add_button_disabled(), n.elements.notifyMe.hide(), n.methods.product_page._updateInventoryAlert(), void n.elements.form.trigger("pdp_out_of_stock", !0);
                            r && d && (n.methods.product_page._showGiftWizard(), i = a + "-" + r.toString() + d.toString())
                        }
                        if (o = window.productData.variantsForHandleAndSize[i], window.pdp.variant = o, !o) return n.methods.product_page._paypal_button_disabled(), n.methods.product_page._add_button_disabled(), n.elements.notifyMe.hide(), n.methods.product_page._updateInventoryAlert(), void n.elements.form.trigger("pdp_out_of_stock", !0);
                        if (n.methods.product_page._isGiftCard()) return void n.methods.product_page._add_button_enabled();
                        e("[data-variant-id]").data("variant-id", o.id), t !== !0 && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                            event: "Product Selection",
                            product_name: window.activeProductHandle,
                            cup_size: d,
                            band_size: r
                        })), n.methods.product_page._updateInventoryAlert();
                        var l = o.inventory_available,
                            c = o.id,
                            _ = o.title,
                            u = o.product_id,
                            m = "true" === n.elements.notifyMe.attr("data-bis-hide");
                        n.methods.product_page._notify_cta(l, c, _, u, m), m && !l || n.elements.addToCart.removeAttr("disabled").removeClass("disabled").data("variant-id", o.id), n.elements.form.trigger("pdp_out_of_stock", !l)
                    },
                    _reset_pdp_size_color_styling: function() {
                        e(".filter-option__label--color").removeClass("filter-option__label--out-of-stock"), e('select[name="cup-size"] option').not(":first").removeAttr("disabled"), e("#pdp-desktop-selected-band-size").attr("data-selected-variant-detail", "").removeClass("variant-selection-detail__label--detail-visible"), e("#pdp-desktop-selected-cup-size").attr("data-selected-variant-detail", "").removeClass("variant-selection-detail__label--detail-visible"), e('label[data-variant-type="cup-size"]').removeClass("out-of-stock out-of-stock--selected disabled").parent().show(), e(".mobile-color-select").removeClass("mobile-color-select--out-of-stock")
                    },
                    _reset_pdp_underwear_size_color_styling: function() {
                        e('label[data-variant-type="size"]').removeClass("out-of-stock out-of-stock--selected disabled").parent(), e(".filter-option__label--color").removeClass("filter-option__label--out-of-stock"), e("#pdp-desktop-selected-size").attr("data-selected-variant-detail", "").removeClass("variant-selection-detail__label--detail-visible")
                    },
                    _dropDownListDecorator: function(t, o) {
                        var i = e(".js-dropdown.js-cup-size .selectize-dropdown").add(".js-dropdown.js-size .selectize-dropdown"),
                            n = i.find('.option[data-value="' + t + '"]');
                        o ? n.addClass("strikethrough") : n.removeClass("strikethrough").show()
                    },
                    _dropDownListStrike: function(t, o) {
                        var i = "cup" === t ? "js-cup-size" : "js-size",
                            n = e(".selectize-control.js-dropdown." + i).find(".item");
                        o && o.inventory_available ? (n.removeClass("strikethrough"), e(".js-dropdown." + i).removeClass("js-oos")) : (n.addClass("strikethrough"), 0 === n.length && e(".js-dropdown." + i).addClass("js-oos"))
                    },
                    _dropDownClear: function(e) {
                        var t = n.methods.product_page._getSelectizeDropDown(e);
                        t.each(function(e, t) {
                            t.selectize.clear()
                        })
                    },
                    _dropDownInitClear: function() {
                        n.elements.dropdownContainer.addClass("js-show-empty")
                    },
                    _getSelectizeDropDown: function(t) {
                        var o = "js-size";
                        return "cup" === t ? o = "js-cup-size" : "band" === t && (o = "js-band-size"), e(".js-dropdown." + o + ".selectized")
                    },
                    _getBandUIChecked: function() {
                        return e('[name="band-size"]:checked')
                    },
                    _getCupUIChecked: function() {
                        return e('[name="cup-size"]:checked')
                    },
                    getSizeUIChecked: function() {
                        return e('[name="size"]:checked')
                    },
                    _getColorUIChecked: function() {
                        var o = t.width() < 1024;
                        return e(o ? ".mobile-select-collapsed .filter-option__input:checked" : ".color-selection .filter-option__input:checked")
                    },
                    _show_pdp_cup_availability_desktop: function(t, o) {
                        var i = window.activeProductHandle,
                            a = [],
                            s = n.methods.product_page._sort_cup_sizes(window.cup_dir),
                            r = n.elements.cupSizeBubbles.find(".variant-item");
                        s.forEach(function(e) {
                            var s = r.find('[data-variant-value="' + e + '"]'),
                                d = n.methods.product_page._buildVariantKey(i, t, e),
                                l = window.productData.variantsForHandleAndSize[d],
                                c = !l || !l.inventory_available;
                            c ? (a.push(e), s.addClass("out-of-stock")) : s.removeClass("out-of-stock"), n.methods.product_page._dropDownListDecorator(e, c), e === o && s.find("input").prop("checked", !0)
                        }), e("#pdp-desktop-selected-band-size").attr("data-selected-variant-detail", t).addClass("variant-selection-detail__label--detail-visible"), e("#pdp-desktop-selected-cup-size").attr("data-selected-variant-detail", o).addClass("variant-selection-detail__label--detail-visible");
                        var d = n.methods.product_page._buildVariantKey(i, t, o),
                            l = window.productData.variantsForHandleAndSize[d];
                        n.methods.product_page._dropDownListStrike("cup", l), e(".js-dropdown.js-cup-size").data("oos", a), n.methods.product_page._updateInventoryAlert()
                    },
                    _getBubblePositions: function(t) {
                        var o = {},
                            i = e(t).find(".variant-item");
                        return i.each(function(t, i) {
                            var n = e(i).children().data("variantValue");
                            n && (o[n] = {
                                index: t
                            })
                        }), o
                    },
                    _insertBubble: function(t, o, i) {
                        var n, a, s = t.find("li"),
                            r = s.length,
                            d = o.node.children().data("variantValue");
                        r > 0 ? (i ? (e(s[i]).length > 0 && (a = e(s[i])), n = i) : s.each(function(t, i) {
                            var s = e(i).children().data("variantValue");
                            !a && (0 === o.index || s > d) && (a = e(i), n = t)
                        }), a ? 0 === n ? s.first().before(o.node) : a.before(o.node) : s.last().after(o.node)) : t.append(o.node)
                    },
                    _show_pdp_size_picker: function() {
                        var t = ".variant-size",
                            o = window.activeProductHandle,
                            i = e(".js-dropdown.js-size"),
                            a = e(t),
                            s = [];
                        window.nodeCache = window.nodeCache || n.methods.product_page._getBubblePositions(t);
                        var r = function(e, t) {
                            var o = i.find('[data-value="' + e + '"].option');
                            t ? o.show() : o.hide()
                        };
                        window.productData.sizes.forEach(function(e, t) {
                            var i, d = n.methods.product_page._buildVariantKey(o, e),
                                l = window.productData.variantsForHandleAndSize[d],
                                c = a.find('[data-variant-value="' + e + '"]');
                            if (l) 0 === c.length && (i = window.nodeCache[e] && window.nodeCache[e], i && n.methods.product_page._insertBubble(a, i, t)), s.push(e), r(e, !0);
                            else {
                                var _ = c.parent().detach();
                                _.length && (_.find('input[name="size"]:checked').prop("checked", !1), window.nodeCache[e].node = _), r(e, !1)
                            }
                        });
                        var d = n.methods.product_page.getSizeUIChecked().val();
                        d && s.indexOf(d) === -1 && n.methods.product_page._addButtonDisabledAndAlert("size")
                    },
                    _show_pdp_cups_picker: function(t) {
                        var o = ".variant-cup-size",
                            i = window.activeProductHandle,
                            a = e(".js-dropdown.js-cup-size"),
                            s = e(".variant-cup-size");
                        window.nodeCache = window.nodeCache || n.methods.product_page._getBubblePositions(o);
                        var r = function(e, t) {
                                var o = a.find('[data-value="' + e + '"].option');
                                t ? o.show() : o.hide()
                            },
                            d = n.methods.product_page._sort_cup_sizes(window.cup_dir);
                        d.forEach(function(e) {
                            var o, a = n.methods.product_page._buildVariantKey(i, t, e),
                                d = window.productData.variantsForHandleAndSize[a],
                                l = s.find('[data-variant-value="' + e + '"]');
                            if (d) 0 === l.length && (o = window.nodeCache[e] && window.nodeCache[e], n.methods.product_page._insertBubble(s, o)), r(e, !0);
                            else {
                                var c = l.parent().detach();
                                c.length && (window.nodeCache[e] || (window.nodeCache[e] = {}), window.nodeCache[e].node = c), r(e, !1)
                            }
                        })
                    },
                    _show_pdp_cup_availability_mobile: function(t, o) {
                        var i = ".variant-cup-size",
                            a = window.activeProductHandle,
                            s = [],
                            r = e(".js-dropdown.js-cup-size"),
                            d = e(".variant-cup-size");
                        window.nodeCache = window.nodeCache || n.methods.product_page._getBubblePositions(i);
                        var l = function(e, t) {
                                var o = r.find('[data-value="' + e + '"].option');
                                t ? o.show() : o.hide()
                            },
                            c = n.methods.product_page._sort_cup_sizes(window.cup_dir);
                        c.forEach(function(e) {
                            var o, i = n.methods.product_page._buildVariantKey(a, t, e),
                                r = window.productData.variantsForHandleAndSize[i],
                                c = d.find('[data-variant-value="' + e + '"]');
                            if (r) s.push(e), 0 === c.length && (o = window.nodeCache[e] && window.nodeCache[e], n.methods.product_page._insertBubble(d, o)), l(e, !0);
                            else {
                                var _ = c.parent().detach();
                                _.length && (_.find('input[name="cup-size"]:checked').prop("checked", !1), window.nodeCache[e].node = _), l(e, !1)
                            }
                        });
                        var _ = r.data("oos") || [],
                            u = _.map(function(e) {
                                return {
                                    size: e,
                                    show: s.indexOf(e) > -1
                                }
                            });
                        r.data("oos", u), o && s.indexOf(o) === -1 && n.methods.product_page._addButtonDisabledAndAlert("cup")
                    },
                    _addButtonDisabledAndAlert: function(t) {
                        window.pdp.selection.cupSize = null, window.pdp.selection.size = null;
                        var o = e("cup" === t ? "#pdp-desktop-selected-cup-size" : "#pdp-desktop-selected-size");
                        o.attr("data-selected-variant-detail", "").data("selectedVariantDetail", ""), n.methods.product_page._dropDownClear(t), n.methods.product_page._updateInventoryAlert(), n.methods.product_page._add_button_disabled(), n.methods.product_page._paypal_button_disabled(), n.elements.notifyMe.hide()
                    },
                    _buildVariantKey: function(e, t, o) {
                        var i, a = t && t.toString();
                        return i = o ? a + n.methods.product_page._halfSizeDotNotation(o) : n.methods.product_page._halfSizeDotNotation(a), e + "-" + i
                    },
                    _halfSizeDotNotation: function(e) {
                        return e && e.replace("½", ".5")
                    },
                    _show_pdp_underwear_availability_desktop: function(t) {
                        var o = window.activeProductHandle,
                            i = [],
                            a = window.productData.sizes,
                            s = e(".variant-size");
                        a.forEach(function(e) {
                            var t = n.methods.product_page._buildVariantKey(o, e),
                                a = window.productData.variantsForHandleAndSize[t],
                                r = !a || !a.inventory_available,
                                d = s.find('[data-variant-value="' + e + '"]');
                            r ? (i.push({
                                show: !!a,
                                size: e
                            }), d.addClass("out-of-stock")) : d.removeClass("out-of-stock"), n.methods.product_page._dropDownListDecorator(e, r)
                        });
                        var r = n.methods.product_page._buildVariantKey(o, t),
                            d = window.productData.variantsForHandleAndSize[r];
                        d ? n.methods.product_page._dropDownListStrike("size", d) : n.methods.product_page._dropDownClear("size"), e(".js-dropdown.js-size").data("oos", i), n.methods.product_page._updateInventoryAlert()
                    },
                    _show_pdp_underwear_availability_mobile: function(t) {
                        var o = window.activeProductHandle;
                        e('select[name="size"] option').not(":first").each(function(t, i) {
                            var n = e(i).val().toString(),
                                a = window.variant_data[o].variants[n],
                                s = a ? a.quantity <= 0 : null;
                            s && e(i).addClass("out-of-stock")
                        }), n.methods.product_page._updateInventoryAlert()
                    },
                    _show_pdp_color_availability_desktop: function(t, o, i) {
                        var n = t + o || i,
                            a = window.activeProductHandle,
                            s = window.variant_data[a].variants[n],
                            r = t && o || i;
                        if (s) e(".filter-option__label--color").each(function(t, o) {
                            var i = e(o).siblings(".filter-option__input").val(),
                                n = s.colorsInStock.indexOf(i) > -1;
                            n || e(o).addClass("filter-option__label--out-of-stock")
                        });
                        else if (r) {
                            var d = window.productData.handles,
                                l = [];
                            d.forEach(function(e) {
                                var t = window.productData.variantsForHandleAndSize[e + "-" + n];
                                t && t.inventory_available && l.push(e)
                            })
                        }
                    },
                    _show_pdp_color_availability_mobile: function(t, o, i) {
                        var n = window.activeProductHandle,
                            a = window.variant_data[n].variants[t + o] || window.variant_data[n].variants[i];
                        a && e(".mobile-color-select").each(function(t, o) {
                            var i = e(o).data("color-name"),
                                n = a.colorsInStock.indexOf(i) > -1;
                            n || e(o).addClass("mobile-color-select--out-of-stock")
                        })
                    },
                    _bb_update_options_from_selected: function(t) {
                        var o = t || n.methods.product_page._getColorUIChecked().val();
                        if (window.pdp.selection.colorName = o, window.variant_data) {
                            if (n.methods.product_page._isUnderwear()) {
                                n.methods.product_page._show_pdp_size_picker(), n.methods.product_page._reset_pdp_underwear_size_color_styling();
                                var i = n.methods.product_page.getSizeUIChecked().val();
                                n.methods.product_page._show_pdp_underwear_availability_desktop(i), i && (n.methods.product_page._show_pdp_color_availability_desktop(null, null, i), n.methods.product_page._show_pdp_color_availability_mobile(null, null, i), e("#pdp-desktop-selected-size").attr("data-selected-variant-detail", i).addClass("variant-selection-detail__label--detail-visible"))
                            } else {
                                var a = n.methods.product_page._getBandUIChecked().parents("label").data("variant-value"),
                                    s = n.methods.product_page._getCupUIChecked().parents("label").data("variant-value");
                                a && (n.methods.product_page._reset_pdp_size_color_styling(), n.methods.product_page._show_pdp_cups_picker(a), n.methods.product_page._show_pdp_cup_availability_desktop(a, s), n.methods.product_page._show_pdp_cup_availability_mobile(a, s), n.methods.product_page._show_pdp_color_availability_desktop(a, s))
                            }
                            n.methods.product_page._updateColorLabel(o)
                        }
                    },
                    _updateColorLabel: function(t) {
                        var o = t ? t.replace("-", " ") : "";
                        o && e(".js-pdp-selected-color").attr("data-selected-variant-detail", o).addClass("variant-selection-detail__label--detail-visible")
                    },
                    _hideGiftWizard: function() {
                        e(".gwbutton__container").hide()
                    },
                    _showGiftWizard: function() {
                        e(".gwbutton__container").show()
                    },
                    _notify_cta: function(t, o, i, a, s) {
                        var r = n.elements.addToCart,
                            d = n.elements.notifyMe;
                        t || s ? !t && s ? (n.methods.product_page._add_button_disabled(), n.methods.product_page._hideGiftWizard(), n.methods.product_page._paypal_button_disabled()) : (n.methods.product_page._add_button_enabled(), n.methods.product_page._paypal_button_enabled(), n.methods.product_page._showGiftWizard(), d.hide()) : (r.hide(), n.methods.product_page._paypal_button_disabled(), n.methods.product_page._hideGiftWizard(), d.removeClass("disabled").removeAttr("disabled").show(), e("#notify.modal").attr("data-variant-id", o), e("#notify.modal").attr("data-product-id", a), e("#notify .sold-out__variant").text(i))
                    },
                    _add_button_disabled: function() {
                        var e = n.elements.addToCart;
                        e.addClass("disabled").attr("disabled", "disabled").show()
                    },
                    _add_button_enabled: function() {
                        var e = n.elements.addToCart;
                        e.show().removeClass("disabled").removeAttr("disabled")
                    },
                    _paypal_button_enabled: function() {
                        n.methods.product_page._show_paypal_button() && CartJS.cart.item_count < 1 && !n.methods.product_page._isGiftCard() && n.elements.paypalContainer.show()
                    },
                    _paypal_button_disabled: function() {
                        n.elements.paypalContainer.hide()
                    },
                    _show_paypal_button: function() {
                        var e = !1;
                        return (window.pdp.selection.bandSize && window.pdp.selection.cupSize || window.pdp.selection.size) && window.pdp.variant && window.pdp.variant.inventory_available && (window.showPaypalButtonDesktop && !window.isMobile() || window.showPaypalButtonMobile && window.isMobile()) && (e = !0, window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                            event: "viewPaypalPdp"
                        })), e
                    },
                    _add_notify_me_handler: function() {
                        var t = function(t) {
                            var o = "";
                            if ("OK" === t.status) e(".success").removeClass("hidden"), e("#notify h2.sold-out__title").addClass("hidden"), e("#notify .form-field").addClass("hidden"), e("#notify #notify_button").addClass("hidden"), e("#notify #notify_close").removeClass("hidden"), e(".error").addClass("hidden");
                            else {
                                o = [];
                                for (var i in t.errors) o.push(t.errors[i]);
                                o.join(", "), e(".error").removeClass("hidden"), e(".error h2").text(o)
                            }
                        };
                        e("#notify_button").click(function(o) {
                            var i = e(".email-submit").val(),
                                n = e("#notify").attr("data-variant-id"),
                                a = e("#notify").attr("data-product-id");
                            BIS.create(i, n, a).then(t)
                        })
                    },
                    getSelectedBandCupSize: function() {
                        var t = e('[name="band-size"]:checked').parents("label").data("variant-value"),
                            o = e('[name="cup-size"]:checked').parents("label").data("variant-value"),
                            i = t && o ? t + o : void 0;
                        return i
                    },
                    _is_size_included_in_image_styles: function(t, o) {
                        var i = !1;
                        return t && o && window.imageStyles && e.each(window.imageStyles, function(e, t) {
                            t.indexOf(o) > -1 && (i = !0)
                        }), i
                    },
                    generateTile: function(e) {
                        var t = e.label ? e.label : "",
                            o = "",
                            i = "";
                        "" !== t && "__label:" === t.substring(0, 8) && ("Best Sell" === t.substring(9, 18) ? o = "Best Seller!" : "for" === t.substring(11, 14) ? o = t.substring(9, 18) : "New" === t.substring(9, 12) && (o = "New!"), i = '<div class="collection-grid__item-tag" data-category="' + window.TLTemplateName + '" data-track="nft" data-label="Product Panel ' + e.title + '">' + o + "</div>");
                        var n = "(max-width: 320px) 150px, (max-width: 600px) 250px,(max-width: 768px) 300px,(max-width: 1024px) 250px, (max-width: 1440px) 315px, 400px";
                        return '<div class="collection-grid__item">           <span class="tl-quick-view collection-grid__item-tag--quick-view"             data-category="' + window.TLTemplateName + '"             data-track="nft"             data-label="Quick View ' + e.title + '"             data-product-id="' + e.id + '"             data-product-handle="' + e.handle + '"></span>          <a class="t-link collection-grid__item-link" href="' + e.url + '">' + i + '<img class="collection-grid__product-image lazyload "               src="' + e.image_150x + '" data-src="' + e.image_300x + '"               data-srcset="' + e.image_data_srcset + '" data-sizes="' + n + '"               data-category="' + window.TLTemplateName + '"              data-track="nft"               data-label="Product Panel ' + e.title + '"              alt="' + e.title + '">              <div class="collection-grid__product-details">              <p class="collection-grid__product-title t-heading--small"                 data-category="' + window.TLTemplateName + '"                 data-track="nft"                 data-label="Product Panel ' + e.title + '">' + e.title + "</p>            </div>            </a>          </div>"
                    },
                    _get_product: function(t) {
                        return e.get("/products/" + t + "?view=json").done(function(e) {
                            return e
                        }).fail(function(e) {
                            console.log("error", e)
                        })
                    },
                    _generate_grid_items: function(e) {
                        var t = "",
                            o = 0;
                        e.forEach(function(e) {
                            o < 3 && e.available && (t += n.methods.product_page.generateTile(e), ++o)
                        });
                        var i = '<div class="collection-grid"><div class="collection-grid__container">' + t + "</div></div>";
                        if (n.elements.pdp_recommendations.is(":hidden") || n.elements.pdp_recommendations.find(".collection-grid__item").length < 2) n.elements.pdp_recommendations.is(":hidden") ? (n.elements.pdp_recommendations.show(), n.elements.complete_look_header.show(), n.elements.pdp_recommendations.find(".collection-grid__item").remove(), n.elements.pdp_recommendations.append(i)) : n.elements.main_section.after('<h3>Complete your look</h3><div class="pdp__recommendations">' + i + "</div>");
                        else {
                            var a = n.elements.pdp_recommendations.find(".collection-grid");
                            a.remove(), n.elements.pdp_recommendations.append(i)
                        }
                    },
                    _hide_complete_look_section: function() {
                        n.elements.pdp_recommendations.hide(), n.elements.complete_look_header.hide()
                    },
                    _update_complete_look_colors: function() {
                        window.quickViewBootstrap && window.quickViewBootstrap.resetHandlers();
                        var t = window.variant_data[window.activeProductHandle].relatedProducts;
                        if ("" === t) n.methods.product_page._hide_complete_look_section();
                        else {
                            n.elements.pdp_recommendations.show(), n.elements.complete_look_header.show();
                            var o = t.split(","),
                                i = n.methods.product_page._generate_grid_items,
                                a = -1,
                                s = [];
                            [0, 1, 2].forEach(function(t) {
                                e.get("/products/" + o[t] + "?view=json").done(function(e) {
                                    e && s.push(JSON.parse(e)), s.length >= 2 && (a > 2 ? n.methods.product_page._hide_complete_look_section() : i(s))
                                }).fail(function(t) {
                                    ++a, e.get("/products/" + window.promote_handles[a] + "?view=json").then(function(e) {
                                        e && s.push(JSON.parse(e)), s.length >= 2 && (a > 2 ? n.methods.product_page._hide_complete_look_section() : i(s))
                                    }).fail(function(e) {
                                        console.log("error", e)
                                    })
                                }).always(function() {
                                    window.quickViewBootstrap && window.quickViewBootstrap.bootstrap()
                                })
                            })
                        }
                    },
                    debounceChangeColorCompleteLook: function() {
                        window.pdpChangeColorDebounce || (window.pdpChangeColorDebounce = !0, setTimeout(function() {
                            n.methods.product_page._update_complete_look_colors(), window.pdpChangeColorDebounce = !1
                        }, 1e3))
                    },
                    _change_product_color: function(t) {
                        var o, i = t.colorHex,
                            a = t.useDynamicImages,
                            s = n.methods.product_page.isBras() ? n.methods.product_page.getSelectedBandCupSize() : n.methods.product_page.getSizeUIChecked().val(),
                            r = e(".slideshow.vertical"),
                            d = e("#customer-video-thumb"),
                            l = e("#desktop-images"),
                            c = e("#mobile-images"),
                            _ = e("#image-cache-selector"),
                            u = e("#image-cache-customer-video"),
                            m = e("#image-cache-desktop"),
                            p = e("#image-cache-mobile"),
                            h = r.add(l).add(c),
                            f = [],
                            v = n.methods.product_page_videos.isMobileVersion(),
                            w = n.methods.product_page._is_size_included_in_image_styles(a, s);
                        i && e(".color-select-circle--selected").css("background-color", i), n.methods.vendors._destroy_carousels(h), n.methods.product_page_videos.cleanupExistingVideoPlayers();
                        var g = u.add(_).add(m).add(p);
                        g.children().length > 0 && g.empty();
                        var b, y, z, C, k, S, j, T, P, x = !!window.variant_data[window.activeProductHandle].images.find(function(e) {
                                return e.customerVideo
                            }),
                            O = window.variant_data[window.activeProductHandle].images;
                        if (O.forEach(function(t, i) {
                                if (y = !0, z = "", k = "", S = "", j = t.dynamicStyleGroup || "", b = window.imageStyles && window.imageStyles[j] || [], o = a && b.indexOf(s) > -1, t.productVideo) {
                                    T = "div-desktop-product-video" + (j ? "-" + j : ""), P = "div-mobile-product-video" + (j ? "-" + j : ""), z = '<div class="slide has-play ' + j + '"                                              data-video-container="' + T + '">                                            <div class="video" style="background: url(' + t.srcMaster + ') ">                                              <img class="video-slot__icon video-slot__icon--play" src="' + window.iconsURL.playIconV2 + '" alt="Play" />                                            </div>                                          </div>', k = '<div class="slide has-play ' + j + '" style="background-image:url(' + t.srcMaster + ')">                                              <div id="' + T + '" style="display: none"></div>                                            </div>', S = '<div class="slide has-play ' + j + '" style="background-image:url(' + t.srcGrande + ')">                                            <div id="' + P + '"></div>                                            <img class="icon-play icon-play-video icon-play-video--hidden js-icon-play-video" src="' + window.iconsURL.playIconMobile + '" alt="Play" />                                          </div>';
                                    var d = v ? P : T;
                                    f.push({
                                        container: d,
                                        url: t.productVideo,
                                        posterImageURL: t.srcGrande,
                                        title: t.productVideoTitle,
                                        showPlayButton: v
                                    })
                                } else if (t.src360) z = '<div class="slide has-360 ' + j + '">' + window.imajizeThumbnailSvgDesktop + "</div>", k = '<div class="slide is-360 ' + j + '">                                              <iframe src="' + t.src360 + '" frameborder="0" scrolling="no"></iframe>                                            </div>', S = '<div class="slide--mobile-parent ' + j + '">                                            <a class="zoom-product-trigger view-360" href="' + t.src360 + '?fullscreen=false">                                              <div class="slide has-360">' + window.imajizeThumbnailSvgMobile + "</div>                                            </a>                                          </div>";
                                else if (t.customerVideo) {
                                    x = !0, C = '<div class="video-slot">                                             <div class="video-slot__title">' + t.customerVideoText + '</div>                                             <div class="video-slot__thumbnail">                                               <img id="customer_video_thumb_img"                                                 class="video-slot__thumbnail-img lazyload"                                                 src="' + t.src150 + '"                                                 data-src="' + t.srcMaster + '"                                                 data-video-container="div-desktop-customer-video"                                                alt="Customer video thumbnail">                                             </div>                                             <img class="video-slot__icon video-slot__icon--play" src="' + window.iconsURL.playIconV2 + '" alt="Play" />                                          </div>', k = '<div class="slide has-play has-customer-video" style="background-image:url(' + t.srcMaster + ')">                                               <div id="div-desktop-customer-video" style="display: none"></div>                                             </div>', S = '<div class="slide has-play has-customer-video" style="background-image:url(' + t.srcGrande + ')">                                             <div id="div-mobile-customer-video"></div>                                               <img class="icon-play icon-play-video icon-play-video--hidden js-icon-play-video" src="' + window.iconsURL.playIconMobile + '" />                                           </div>';
                                    var u = v ? "div-mobile-customer-video" : "div-desktop-customer-video";
                                    f.push({
                                        container: u,
                                        url: t.customerVideo,
                                        posterImageURL: t.srcGrande,
                                        title: t.customerVideoTitle,
                                        showPlayButton: v
                                    })
                                } else z = '<img class="slide lazyload ' + j + '" name="img-select-' + (i + 1) + '" src="' + t.src150 + '" data-src="' + t.src1130 + '" alt="' + t.alt + '">', k = '<div class="slide ' + j + '" style="background-image: url(' + t.srcMaster + ')" data-zoom="' + t.srcMaster + '"></div>', S = '<div class="slide--mobile-parent ' + j + '">                                            <a class="zoom-product-trigger" href="' + t.srcMaster + '">                                              <img class="slide owl-lazy" src="' + t.src150 + '" data-src="' + t.srcGrande + '" data-srcset="' + t.srcset + '" data-sizes="' + t.sizes + '" alt="' + t.alt + '" />                                            </a>                                          </div>';
                                if (a && (y = o || !w || !s || t.customerVideo, y || (_.append(z), m.append(k), p.append(S))), y) {
                                    var h = r.children().length,
                                        g = e(z);
                                    z && n.methods.product_page.setImageSelectAttribute(g, h), r.append(g), l.append(k), c.append(S)
                                }
                            }), x) {
                            var B = e(C),
                                I = B.find("#customer_video_thumb_img"),
                                D = r.children().length;
                            n.methods.product_page.setImageSelectAttribute(I, D), d.html(B), d.show()
                        } else d.hide();
                        n.methods.vendors._initialize_carousels();
                        var V = !0,
                            A = !0;
                        f.forEach(function(e) {
                            n.methods.product_page_videos.initializeVideoPlayer(e, V, A)
                        }), n.methods.slidersRecommendations.fetchRecommendations()
                    },
                    _add_initial_state_to_history: function() {
                        var e = 992,
                            t = {
                                page: window.activeProductHandle
                            },
                            o = window.pageTitle,
                            i = window.location.pathname + window.location.search;
                        window.innerWidth <= e && (t.activeProductColorHex = window.activeProductColorHex), window.history.replaceState(t, o, i)
                    },
                    _change_url_without_reloading: function(e) {
                        if (window.history && window.history.pushState) {
                            var t = {
                                    page: window.activeProductHandle,
                                    newActiveProductColorHex: e
                                },
                                o = window.pageTitle,
                                i = "/products/" + window.activeProductHandle;
                            window.history.replaceState(t, o, i)
                        }
                    },
                    _update_dynamic_image_styles: function(e, t) {
                        e ? window.imageStyles = {
                            style1: t.data("style1").split(","),
                            style2: t.data("style2").split(",")
                        } : window.imageStyles = void 0
                    },
                    _update_price: function() {
                        var t = e(".js-header-price"),
                            o = "",
                            i = window.variant_data[window.activeProductHandle],
                            a = i.variants,
                            s = i.isWardrobe,
                            r = n.properties.currentSelectedSizes["band-size"] + n.properties.currentSelectedSizes["cup-size"] || n.properties.currentSelectedSizes.size,
                            d = r && a[r] ? a[r] : a[Object.keys(a)[0]],
                            l = Number(d.price),
                            c = Number(d.compare_at_price),
                            _ = d.price_html,
                            u = d.compare_at_price_html,
                            m = i.quantityDiscountPhrase ? ' or <span class="product-header__price--sale">' + i.quantityDiscountPhrase + "</span>" : "";
                        s || (o = c && c > l ? '<div class="mark-down">              <s class="strike"><em class="product-header__price--strikethrough">' + u + '</em></s>              <em class="product-header__price--sale">' + _ + "</em>            </div>" : _ + m, t.html().trim() !== o.trim() && t.html(o))
                    },
                    _refresh_band_data: function() {
                        var t = window.variant_data[window.activeProductHandle].variants,
                            o = window.outOfStockThreshold;
                        window.valid_variants = [], window.band_dir = {}, window.cup_dir = {}, e.each(t, function(e, t) {
                            var i = t.title.slice(0, 2),
                                n = t.title.slice(2);
                            t.quantity > o && window.valid_variants.push(t.title), window.band_dir[i] || (window.band_dir[i] = []), window.band_dir[i].push(n), window.cup_dir[n] || (window.cup_dir[n] = []), window.cup_dir[n].push(i)
                        }), n.methods.product_page._rerender_bands(window.band_dir, window.cup_dir)
                    },
                    _sort_cup_sizes: function(e) {
                        var t = Object.keys(e),
                            o = t.sort(),
                            i = o.indexOf("AA"),
                            n = i > -1 ? o.splice(i, 1) : null;
                        return n = n ? n.concat(o) : o
                    },
                    _rerender_bands: function(t, o) {
                        var i = Object.keys(t).sort(),
                            a = n.methods.product_page._sort_cup_sizes(o),
                            s = n.methods.product_page._getSelectizeDropDown("band"),
                            r = n.methods.product_page._getSelectizeDropDown("cup"),
                            d = n.methods.product_page._normalizeDropDownOptions(i),
                            l = n.methods.product_page._normalizeDropDownOptions(a),
                            c = n.methods.product_page._getBandUIChecked().val() || n.properties.currentSelectedSizes["band-size"],
                            _ = n.methods.product_page._getCupUIChecked().val(),
                            u = e(".variant-selection.variant-band-size"),
                            m = e(".variant-selection.variant-cup-size"),
                            p = !1;
                        n.methods.product_page._buildSizeBubble(i, u), c && e('input[name="band-size"][value="' + c + '"]').click(), n.methods.product_page._buildCupBubble(a, m), _ && e('input[name="cup-size"][value="' + _ + '"]').click(), s.each(function(e, t) {
                            var o = window.pdp.selection && window.pdp.selection.bandSize ? window.pdp.selection.bandSize.toString() : "";
                            t.selectize.setValue("", !0), t.selectize.clearOptions(), t.selectize.addOption(d), o && i.indexOf(o) > -1 && (p = !0, t.selectize.setValue(o, !0))
                        }), r.each(function(e, t) {
                            var o = window.pdp.selection && window.pdp.selection.cupSize ? window.pdp.selection.cupSize.toString() : "";
                            o = o.replace(".5", "½"), t.selectize.setValue("", !0), t.selectize.clearOptions(), t.selectize.addOption(l), p && o && a.indexOf(o) > -1 && t.selectize.setValue(o, !0)
                        }), n.methods.product_page._add_size_bubble_event_handlers()
                    },
                    _buildSizeBubble: function(e, t) {
                        var o = [];
                        e.forEach(function(e) {
                            o.push('<li class="variant-item" data-action="variant-selection">                   <label class="variant-item__label" data-variant-type="band-size" data-variant-value="' + e + '">                     <input class="variant-item__input" type="radio" name="band-size" value="' + e + '" />                     <span class="variant-item__text">' + e + "</span>                   </label>                 </li>")
                        }), t.children().remove(), t.append(o)
                    },
                    _buildCupBubble: function(e, t) {
                        var i = [];
                        e.forEach(function(e) {
                            var t = "";
                            o[e] && (t = '<br><p class="variant-item__text--d">' + o[e] + "</p>"), i.push('<li class="variant-item" data-action="variant-selection">                   <label class="variant-item__label" data-variant-type="cup-size" data-variant-value="' + e + '">                     <input class="variant-item__input" type="radio" name="cup-size" value="' + e + '" />                     <span class="variant-item__text">' + e + t + "</span>                   </label>                 </li>")
                        }), t.children().remove(), t.append(i)
                    },
                    _normalizeDropDownOptions: function(e) {
                        var t = e.map(function(e) {
                            return {
                                value: e,
                                text: e
                            }
                        });
                        return t
                    },
                    _handle_click_on_product_color: function(t) {
                        var o = e(t.target),
                            i = {
                                handler: o.data("product-handle"),
                                colorHex: o.data("color-hex"),
                                useDynamicImages: o.data("use-dynamic-images"),
                                colorName: o.val()
                            };
                        window.pdp.selection.colorName = i.colorName, window.activeProductHandle = i.handler, n.methods.product_page.isBras() && n.methods.product_page._refresh_band_data(), n.methods.product_page._bb_update_options_from_selected(i.colorName), n.methods.product_page._bb_get_variant_from_selected(!1), n.methods.product_page._update_price(), n.methods.dynamic_images.update_styles(i.useDynamicImages, o), n.elements.form.trigger("pdp_on_color_change", i), window.setTimeout(function() {
                            n.methods.product_page._change_product_color(i)
                        }, 30), window.isBackevent ? window.isBackevent = !1 : window.setTimeout(n.methods.product_page._change_url_without_reloading.bind(this, i.colorHex), 100)
                    },
                    _handle_add_to_cart_click: function(t) {
                        t.preventDefault(), t.stopPropagation();
                        var o = e(t.currentTarget),
                            i = o.data("variant-id"),
                            a = {},
                            s = 1,
                            r = e("#pre-order-message");
                        currentCartTotal = CartJS.cart.total_price, latestAddedProduct = "{{ product.title | strip_html | escape }}", latestAddedVariant = i, e("#skt_gc_line_items") && (a.Customization = e("#skt_gc_slug").val(), a.To = e("#skt_gc_to").val()), r.length > 0 && "" !== r.text() && (a["Pre-order"] = r.text()), window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                            event: "Add To Cart",
                            product_name: latestAddedVariant,
                            current_location: "PDP"
                        });
                      //Bold:RO - Get properties to work with CartJS
                      props = t.currentTarget.form.querySelectorAll('[name*="properties["]');
                      props.forEach(function(prop){
                        a[prop.name.replace("properties[", "").replace("]", "")] = prop.value;
                      });
                      CartJS.addItem(i, s, a), n.methods.product_page._paypal_button_disabled()
                    },
                    _handle_size_bubble_click: function(t) {
                        var o = e(t.target),
                            i = o.parents("label").data("variant-type");
                        n.elements.notifyMe.removeAttr("disabled").removeClass("disabled"), n.properties.currentSelectedSizes[i] && n.properties.currentSelectedSizes[i] === o.val() ? (o.prop("checked", !1).change(), n.elements.notifyMe.attr("disabled", "disabled").addClass("disabled"), o.is('[name="band-size"]') ? (e('input[name="cup-size"]').prop("checked", !1).change(), e("#pdp-desktop-selected-band-size").attr("data-selected-variant-detail", "").removeClass("variant-selection-detail__label--detail-visible"), e("#pdp-desktop-selected-cup-size").attr("data-selected-variant-detail", "").removeClass("variant-selection-detail__label--detail-visible"), n.properties.currentSelectedSizes["band-size"] = null, n.properties.currentSelectedSizes["cup-size"] = null) : (n.properties.currentSelectedSizes[i] = null, e('label[data-variant-type="cup-size"]').removeClass("out-of-stock--selected"))) : n.properties.currentSelectedSizes[i] = o.val()
                    },
                    _handle_variant_change: function(t) {
                        var o = e(t.target),
                            i = o.parents("label").data(),
                            a = i.variantId;
                        if (o.is("select") && e('input[name="' + o.attr("name") + '"][value="' + o.val() + '"]').trigger("click"), n.methods.product_page._isUnderwear()) {
                            var s = e('[name="size"]:checked').parents("label").data("variant-value");
                            e('select[name="size"] option[value="' + o.val() + '"]').prop("selected", "selected"), n.methods.persona.storeUnderwearSize(s)
                        }
                        if (a && "none" !== n.elements.addToCart.css("display")) return n.elements.addToCart.data("variant-id", a), n.methods.product_page._bb_update_options_from_selected(), n.methods.product_page._bb_get_variant_from_selected(!1), void(window.pdp.selection = {
                            size: i.variantValue,
                            handle: window.activeProductHandle
                        });
                        o.is('[name="band-size"]') && (n.methods.product_page._getCupUIChecked().prop("checked", !1), n.methods.product_page._dropDownClear("cup"), n.properties.currentSelectedSizes["cup-size"] = null);
                        var r = n.methods.product_page._getBandUIChecked().parents("label").data("variant-value"),
                            d = n.methods.product_page._getCupUIChecked().parents("label").data("variant-value");
                        window.pdp.selection = {
                            bandSize: r,
                            cupSize: d ? d.replace("½", ".5") : "",
                            handle: window.activeProductHandle
                        }, r && d && (n.methods.persona.storeBand(r), n.methods.persona.storeCup(d), n.methods.product_page._paypal_button_enabled()), n.methods.product_page._bb_update_options_from_selected(), n.methods.product_page._bb_get_variant_from_selected(!1), n.methods.dynamic_images.update()
                    },
                    _update_gift_card_price: function(t) {
                        e(".product-price").html(e(t.target).val())
                    },
                    _update_mobile_bubble_inputs: function(t) {
                        var o = e(t.target);
                        o.is("select") && e('input[name="' + o.attr("name") + '"][value="' + o.val() + '"]').trigger("click")
                    },
                    _remove_disabled_attribute: function(e) {
                        e.removeAttr("disabled")
                    },
                    _add_size_bubble_event_handlers: function() {
                        var t = e('[data-action="variant-selection"] label input');
                        1 !== t.length && (t.off("click").on("click", n.methods.product_page._handle_size_bubble_click), t.off("change._variant_selection").on("change._variant_selection", n.methods.product_page._handle_variant_change), e('[data-action="variant-selection"]').off("change._variant_selection").on("change._variant_selection", n.methods.product_page._update_mobile_bubble_inputs))
                    },
                    _update_style_wardrobes: function() {
                        var t = window.activeProductHandle,
                            o = window.variant_data && window.variant_data[t] || {},
                            i = o.isWardrobe;
                        i && (e(".product-header__price").addClass("product-header__price__wardrobe"), e(".product-header__price--sale").addClass("product-header__price--sale__wardrobe"), e(".product-review--divider").addClass("product-review--divider__wardrobe"), e(".product-header__description").addClass("product-header__description__wardrobe"))
                    },
                    _hide_free_exchanges_wording: function() {
                        n.elements.free_exchanges_banner.html(""), n.elements.free_exchanges_banner.removeClass("soft-banner--spaced"), n.methods.accordionPanel._hideFreeExchangesTab()
                    },
                    setImageSelectAttribute: function(t, o) {
                        var i = e(t);
                        return i.attr("data-image-select", o), i.data("image-select", o), i
                    }
                }
            })
        }), t.on(window.object_name + "._setup_events", function(t, o) {
            var i = e('input[data-action="change-active-product"]');
            o.methods.product_page._add_size_bubble_event_handlers(), e("body").on("click._image_select", ".image-selector .slide", o.methods.vendors._image_select), o.elements.addToCart.click(function(e) {
                o.elements.form.trigger("pdp_add_to_cart"), o.methods.product_page._handle_add_to_cart_click(e)
            }), i.change(o.methods.product_page._handle_click_on_product_color), o.methods.product_page._remove_disabled_attribute(i), window.addEventListener("popstate", function(t) {
                var o;
                t.state && t.state.page && (o = t.state.page, window.isBackevent = !0, e('.filter-option__input[data-product-handle="' + o + '"]').click())
            });
            var n = {
                "click._reviews_show": {
                    element: o.elements.reviews_show,
                    action: o.methods.product_page._reviews_show
                },
                "click._gift_wizard_tooltip_toggle_icon": {
                    element: o.elements.gift_wizard_tooltip_toggle_icon,
                    action: o.methods.product_page._toggle_gift_wizard_tooltip.bind(this, !0)
                },
                "click._gift_wizard_tooltip_close_icon": {
                    element: o.elements.gift_wizard_tooltip_close_icon,
                    action: o.methods.product_page._hide_gift_wizard_tooltip
                },
                "mouseenter._gift_wizard_tooltip_toggle_icon": {
                    element: o.elements.gift_wizard_tooltip_toggle_icon,
                    action: o.methods.product_page._toggle_gift_wizard_tooltip.bind(this, !1)
                },
                "mouseleave._gift_wizard_tooltip_toggle_icon": {
                    element: o.elements.gift_wizard_tooltip_toggle_icon,
                    action: o.methods.product_page._toggle_gift_wizard_tooltip.bind(this, !1)
                }
            };
            o.elements.product_fit_finder.length && !o.methods.fit_finder._has_completed() && (n["product_fit_finder._scroll"] = {
                event: "scroll._product_fit_finder._scroll",
                element: o.elements.window,
                action: o.methods.product_page._mobile_banner_scroll
            }, n["product_fit_finder._scroll_resize"] = {
                event: "resize._product_fit_finder._scroll",
                element: o.elements.window,
                action: o.methods.product_page._mobile_banner_scroll
            }), o.methods._add("events", n)
        }), t.on(window.object_name + "._document_ready", function(t, o) {
            o.elements.main_section && o.elements.main_section.length > 0 && (o.properties.currentSelectedSizes = {}, o.methods.product_page._disable_unavailable_bands(), o.methods.product_page._bb_init_var_select_setup(), window.setTimeout(function() {
                o.methods.dynamic_images.update()
            }, 20), window.setTimeout(function() {
                o.methods.product_page._update_style_wardrobes(), o.methods.product_page._bb_get_variant_from_selected(!0), o.methods.product_page._bb_update_options_from_selected()
            }, 40), window.setTimeout(function() {
                o.methods.product_page._get_query_param(), o.methods.vendors._image_zoom()
            }, 60), window.setTimeout(function() {
                o.methods.product_page._add_notify_me_handler()
            }, 80), window.setTimeout(function() {
                o.methods.product_page._update_view_count(), o.methods.product_page._add_recently_viewed(), o.methods.product_page._add_initial_state_to_history()
            }, 100)), e('[data-variant-value="AA"]').parent().prependTo("ul.variant-cup-size"), e("body").on("dynamicImagesUpdated", function(e) {
                var t = Array.prototype.slice.call(arguments).slice(1);
                o.methods.vendors._image_zoom(t)
            }), e("body").on("tbb_ff_results_images_loaded", function() {
                var t = e(".tbb-hero-image, .tbb-product-image");
                o.methods.vendors._image_zoom(t)
            }), e(document).on("bagQuantityUpdated", function(e, t) {
                window.variant && o.methods.product_page && (CartJS.cart.item_count <= 1 && t.quantity < 1 && !o.methods.product_page._isGiftCard() ? o.methods.product_page._show_paypal_button() && o.elements.paypalContainer.show() : o.methods.product_page._paypal_button_disabled())
            }), window.shop && "product" === window.shop.template && (window.addEventListener("orientationchange", function() {
                setTimeout(function() {
                    var e;
                    if (o.methods.mobile._is_mobile()) {
                        e = window.innerWidth;
                        var t = e > 767 && e <= 1024;
                        t && o.methods.dynamic_images.update()
                    }
                    o.methods.product_page_videos.initializeVideosOnOrientationChange()
                }, 100)
            }), window.onCountryInfoAvailable(function(e, t) {
                return e ? console.error("Unable to update product page. Reason: ", e) : void(t.isFromUS || t.isFromCA || o.methods.product_page._hide_free_exchanges_wording())
            }))
        })
    }(jQuery),
    function(e) {
        var t, o = e(window),
            i = "showcase-recommendations",
            n = 9,
            a = [],
            s = 0,
            r = [];
        o.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                hero: "#hero-container",
                favorite_items: "body section.showcase.favorite-items",
                recent_items: "body section.showcase.recently-viewed",
                second_hero_section: "body div.hero-module--homepage-2",
                hero_video_container: ".hero-module__play-container",
                hero_video_modal_container: ".front-page__header .modals",
                hero_video_modal: ".front-page__header .hero-video-modal.modal",
                hero_video_modal_overlay: ".front-page__header .overlay",
                hero_video_modal_close: ".js-hero-video-close"
            })
        }), o.on(window.object_name + ".add_methods", function(o, d) {
            var l = "playing";
            d.methods._add("methods", {
                front_page: {
                    detect_ff_completion: function() {
                        var e = Cookies.get("_tl_ff_my_fit");
                        return e
                    },
                    template_showcase_products: function(t, o) {
                        window.quickViewBootstrap && window.quickViewBootstrap.resetHandlers(), e.each(t.find(".showcase__item--product"), function(t, i) {
                            var n = o.shift();
                            if (n) {
                                e(i).find("a").attr("href", "/products/" + n.handle), e(i).find("a").attr("data-label", n.title), e(i).find("img").attr("src", n.image_src), e(i).find("img").attr("data-src", n.image_src), e(i).find("img").attr("srcset", n.image_srcset), e(i).find("img").attr("data-srcset", n.image_srcset), e(i).find(".showcase__item__name").html(n.title);
                                var a = e(i).find(".tl-quick-view");
                                a.attr("data-label", "Quick View " + n.title + " - Showcase"), a.attr("data-product-id", n.id), a.attr("data-product-handle", n.handle)
                            }
                        }), window.quickViewBootstrap && window.quickViewBootstrap.bootstrap(null, "index")
                    },
                    recent_products: function() {
                        var e = Cookies.get("_tl_recent_products");
                        e && e.length > 0 ? (e = JSON.parse(e), d.methods._get_products(e, d.methods.front_page.showcase_recent_products)) : d.elements.recent_items.hide()
                    },
                    favorite_items: function() {
                        var t = Cookies.get("_tl_recommended_products");
                        if (t && t.length > 0) {
                            var o = [];
                            t = JSON.parse(t), e.each(t, function(e, i) {
                                if (o.length >= 0 && o.length < 4 && o.push(e), o.length >= 4)
                                    for (var n = 0; n < o.length; n++)
                                        if (t[o[n]] < i && o.indexOf(e) === -1) {
                                            o[n] = e;
                                            break
                                        }
                            }), d.methods._get_products(o, d.methods.front_page.showcase_favorite_items)
                        } else d.elements.favorite_items.hide()
                    },
                    showcase_favorite_items: function(e) {
                        d.methods.front_page.template_showcase_products(d.elements.favorite_items, e)
                    },
                    verifyRecommendationAvailability: function(e) {
                        if (e && e.SC && e.render) {
                            var o = e.SC,
                                i = d.methods.persona.getBraSize(),
                                n = o.page.products.reduce(function(e, t) {
                                    var o = t.link.split("/"),
                                        i = o[o.length - 1];
                                    return t.handle = i, e.indexOf(i) === -1 && r.indexOf(i) === -1 && (e.push(i), r.push(i)), e
                                }, []);
                            0 !== n.length && d.methods._get_products(n, function(n) {
                                i && (n = n.filter(function(e) {
                                    for (var o = 0; o < e.variants.length; o++)
                                        if (e.variants[o].option2 === i && e.variants[o].inventory_quantity > t) return !0;
                                    return !1
                                }));
                                var r = n.map(function(e) {
                                    return e.id.toString()
                                }).slice(0, s);
                                r.length > 0 && (a = o.page.products.reduce(function(e, t) {
                                    return r.indexOf(t.id) > -1 && e.push(t), e
                                }, a).slice(0, s)), a.length === s ? d.methods.front_page.display_recommendations(e) : o.recommender.f === ThirdLove.methods.emarsys.logicTypes.PERSONAL && d.methods.front_page.showcase_recommendations()
                            }, d.methods.productInfoType.REGULAR)
                        }
                    },
                    display_recommendations: function(t) {
                        t.SC.template = window.TLTemplateName || "", t.SC.page.products = a, d.methods.front_page.renderEmarsysTemplate(t.SC), t.render(t.SC), d.elements.recent_items.find("ul .showcase__item--product:lt(" + s + ")").remove(), e("#" + i + " li").clone().prependTo(d.elements.recent_items.find("ul")), d.elements.recent_items.removeClass("showcase--hidden"), d.elements.favorite_items.hide(), window.quickViewBootstrap && window.quickViewBootstrap.bootstrap(null, "index")
                    },
                    showcase_recommendations: function(t) {
                        if (0 !== e("#" + i).length) {
                            var o = {
                                containerId: i,
                                templateId: i + "-template",
                                renderResults: !1,
                                limit: n,
                                success: d.methods.front_page.verifyRecommendationAvailability,
                                filters: [
                                    ["include", "category", "is", "Bra"]
                                ]
                            };
                            if (t) {
                                var a = window.ThirdLove.methods.recommendations.create(window._pickedForYouRecommendationsConfig),
                                    r = a.getStylesByBraSize(t);
                                r && r.length > 0 && o.filters.push(["include", "title", "in", r]), o.logic = ThirdLove.methods.emarsys.logicTypes.PERSONAL
                            } else o.logic = ThirdLove.methods.emarsys.logicTypes.HOME;
                            s = d.elements.recent_items.find("ul .showcase__item--product").length, d.methods.emarsys.getRecommendations(o)
                        }
                    },
                    fetchShopifyProducts: function(t) {
                        var o = t[0],
                            i = "/products/" + o + "?view=recommendations-json";
                        return t && (i += "&cache=false&handlers=" + t), e.get(i).done(function(e) {
                            return e.text
                        })
                    },
                    renderEmarsysTemplate: function(e) {
                        var t = e.page.products,
                            o = t.map(function(e) {
                                return d.methods.front_page.getHandleFromURL(e.link)
                            });
                        d.methods.front_page.fetchShopifyProducts(o).then(function(e) {
                            var t = JSON.parse(e),
                                o = d.methods.front_page.formatDataBeforeRendering(t);
                            d.methods.front_page.renderRecommendations(o)
                        })
                    },
                    formatDataBeforeRendering: function(e) {
                        return {
                            images: e.images,
                            hasSingleTypeImagesForHandle: e.hasSingleTypeImagesForHandle
                        }
                    },
                    renderRecommendations: function(t) {
                        var o = t.images,
                            i = t.hasSingleTypeImagesForHandle;
                        e.each(o, function(t, o) {
                            i[t] ? e('.showcase__list .showcase__item--product[data-handle="' + t + '"] .showcase__link .showcase__image').removeClass("showcase__image--bra") : e('.showcase__list .showcase__item--product[data-handle="' + t + '"] .showcase__link').append('<img class="showcase__image showcase__image--model lazyload"src="' + o[1].src_100 + '"data-src="' + o[1].src_300 + '"data-srcset="' + o[1].src_300 + " 1x," + o[1].src_600 + ' 2x"role="presentation" />')
                        })
                    },
                    getHandleFromURL: function(e) {
                        return e && e.substring(e.lastIndexOf("/") + 1, e.length) || ""
                    },
                    initCta: function() {
                        d.methods.front_page._isHeroVideoEnabled() || (d.elements.hero.addClass("hero-module--clickable"), d.elements.hero.on("click", function(e) {
                            var t = d.elements.hero.data();
                            window.location.href = t.action
                        }));
                        var t = e(".hero-multimedia-module__button");
                        t.each(function(t, o) {
                            var i = e(o);
                            i.on("click", function(e) {
                                e.stopPropagation();
                                var t = i.data();
                                window.location.href = t.action
                            })
                        });
                        var o = ThirdLove.methods.persona.getFFResultsId();
                        if (o) {
                            t.each(function(t, o) {
                                var i = e(o),
                                    n = i.data();
                                n && n.cta_url_returning && (i.data("action", n.cta_url_returning), i.text(n.cta_returning))
                            });
                            var i = d.elements.hero.data();
                            i && i.cta_url_returning && d.elements.hero.data("action", i.cta_url_returning)
                        }
                    },
                    _isHeroVideoEnabled: function() {
                        var e = window.TL && window.TL.heroHeaderVideoEnabled,
                            t = window.VWOHeroVideo;
                        return !!t && !!e
                    },
                    _pauseVideo: function() {
                        var t = {
                            overflow: "auto",
                            position: "static"
                        };
                        e("body").css(t);
                        var o = d.methods.front_page._getHeroVideo();
                        o.getState() === l && o.pause()
                    },
                    _getHeroVideo: function() {
                        return d.elements.hero_video_player || (d.elements.hero_video_player = jwplayer("hero-video-modal__target")), d.elements.hero_video_player
                    },
                    initHeroVideo: function() {
                        if (d.methods.front_page._isHeroVideoEnabled()) {
                            d.elements.hero.addClass("hero-module--with_video");
                            var t = window.TL && window.TL.heroVideoURL,
                                o = d.methods.front_page._getHeroVideo(),
                                i = 27;
                            d.elements.hero_video_modal_overlay.on("click", d.methods.front_page._pauseVideo), d.elements.hero_video_modal_close.on("click", d.methods.front_page._pauseVideo), e(document).on("keyup", function(e) {
                                e.keyCode === i && d.methods.front_page._pauseVideo()
                            }), d.methods.front_page._videoSetup(t, o)
                        }
                    },
                    _videoSetup: function(t, o) {
                        var i = window.isMobile();
                        if (t) {
                            d.elements.hero_video_container.click(function(t) {
                                t.stopPropagation(), d.elements.hero_video_modal_container.addClass("modal-open").show(), d.elements.hero_video_modal.addClass("open");
                                var n = {
                                    overflow: "hidden",
                                    position: "fixed",
                                    width: "100%"
                                };
                                e("body").css(n), i && o.getState() !== l && o.play()
                            });
                            var o = d.methods.front_page._getHeroVideo();
                            o && o.setup && (o.setup({
                                file: t,
                                autostart: "viewable",
                                repeat: !1,
                                volume: 75,
                                mute: !1,
                                controls: !0
                            }), o.on("complete", function() {
                                d.elements.hero_video_modal_container.addClass("modal-open").hide()
                            }))
                        }
                    }
                }
            })
        }), o.on(window.object_name + "._document_ready", function(e, o) {
            o.methods.front_page.detect_ff_completion(), t = window.outOfStockThreshold;
            var i = ThirdLove.methods.persona.getBraSize();
            o.methods.front_page.showcase_recommendations(i), o.methods.front_page.initCta(), window.addEventListener("load", o.methods.front_page.initHeroVideo)
        })
    }(jQuery),
    function(e) {
        var t, o, i = e(window),
            n = 500,
            a = 4,
            s = 768,
            r = "band",
            d = "cup",
            l = new RegExp("\\((DD|DDD|DDDD)\\)"),
            c = i.width() < s;
        i.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                collection_area: "#js-collections",
                all_products: "#js-collections .collection-grid__item",
                other_sizes_collection_area: "#other-sizes-products"
            })
        }), i.on(window.object_name + ".add_methods", function(i, s) {
            s.methods._add("methods", {
                json_collection: {
                    fetchCollections: function(t, o) {
                        var i = [],
                            n = 1,
                            a = window.collectionURL;
                        t.forEach(function(t) {
                            t.collections.forEach(function(t) {
                                var o;
                                t.url && (o = e.get(a + n, function(e) {
                                    t.data = JSON.parse(e)
                                })), n++, i.push(o)
                            })
                        }), i.push(s.methods.json_collection.fetchOthersInSizeCollection()), e.when.apply(e, i.filter(function(e) {
                            return void 0 != e
                        })).done(function() {
                            s.elements.collection_area.trigger(o)
                        }).fail(function(e) {
                            console.log("error", e)
                        })
                    },
                    fetchOthersInSizeCollection: function() {
                        return window.TLOtherInSizeCollection ? e.ajax("/collections/custom/collection=" + window.TLOtherInSizeCollection + "?view=json-dynamic").then(function(t) {
                            try {
                                var t = JSON.parse(t);
                                s.methods.json_collection.generateOthersInSizeHTML(t)
                            } catch (o) {
                                console.log("error", o), e.Deferred().reject()
                            }
                        }).fail(function() {
                            e.Deferred().resolve()
                        }) : e.Deferred().resolve()
                    },
                    generateOthersInSizeHTML: function(e) {
                        var t = "",
                            o = "";
                        e.products.forEach(function(e) {
                            if (e.variants) {
                                var t = s.methods.json_collection.getProductOutOfStockSizes(e),
                                    i = "",
                                    n = "collection-grid__item--other-size",
                                    a = s.methods.json_collection.getProductSizes(e);
                                o += s.methods.json_collection.generateTile(e, a, t, i, n)
                            }
                        });
                        var i = '<div class="product-family__collection collection-grid"><div class="collection-grid__container">' + o + "</div></div>";
                        t = '<div class="product-family">' + i + "</div>", s.elements.other_sizes_collection_area.append(t)
                    },
                    generateProductsHTML: function(e) {
                        var t = "",
                            o = "collection-grid__item collection-grid__item--hero-image";
                        if (e.products.length <= a && (o += " collection-grid__item--hero-image-less-items"), "true" !== e.hideHeader && e.heroImageSmall && e.products && e.products[0]) {
                            var i = e.heroImage_300x + " 300w, " + e.heroImage_400x + " 400w, " + e.heroImage_476x + " 476w, " + e.heroImage_652x + " 652w, " + e.heroImage_700x + " 700w, " + e.heroImage_1000x + " 1000w ",
                                n = "(max-width: 320px) 300px, (max-width: 415px) 300px,(max-width: 768px) 400px,(max-width: 1024px) 476px,(max-width: 1440px) 652px, (min-width: 1440px) 652px, 400px";
                            t += '<div class="' + o + '" data-order="0">              <a class="t-link" href="' + e.products[0].url + '">                <img class="collection-grid__hero-image"                  srcset="' + i + '"                  sizes="' + n + '"                   data-category="' + window.TLTemplateName + '"                  data-track="nft"                  data-label="Hero Image ' + e.title + '"                  alt="' + e.title + '">              </a>            </div>'
                        }
                        if (e.products.forEach(function(o, i) {
                                t += s.methods.json_collection.generateProductTile(o, e.handle, i + 1)
                            }), e.quote) {
                            var r = "" !== e.quote.author_title ? " &ndash; " + e.quote.author_title : "";
                            t += '              <div class="collection-grid__item collection-grid__item--quote">                <blockquote class="quotation">                  <p class="quotation__text t-heading--medium">“' + e.quote.text + '”</p>                  <cite class="quotation__citation t-heading--small author-heading--no-decoration">                    <strong>' + e.quote.author + "</strong>" + r + "</cite>                </blockquote>              </div>"
                        }
                        return t
                    },
                    generateCollectionHTML: function(e, t) {
                        var i = s.methods.json_collection.generateProductsHTML(e),
                            n = "",
                            a = "",
                            r = "",
                            d = "";
                        return t || (a = s.methods.json_collection.generateReviewHTML(e)), o && e.products.length > 4 && (r = "collection-grid--capped", d = '<div class="collection-grid__item collection-grid__item--button"><a href="' + e.products[0].url + '" class="tl-button tl-button--centered tl-button--label">See more colors</a></div>'), e.heroImageSmall && "true" !== e.hideHeader && (n = '<div class="collection-grid__title"><h3 class="t-heading--medium">' + e.title + "</h3>" + a + "</div>"), '<div class="product-family__collection collection-grid ' + r + '">' + n + '<div class="collection-grid__container" data-collection="' + e.handle + '">' + i + d + "</div></div>"
                    },
                    renderProductFamily: function(t, o) {
                        var i = "",
                            n = "";
                        if (t.collections.forEach(function(e) {
                                e.data && (n += s.methods.json_collection.generateCollectionHTML(e.data))
                            }), t.name && t.name.length > 0) {
                            var a = t.name.toLowerCase().replace(" ", "-");
                            i = '<div class="product-family" id="' + a + '"><h3 class="t-heading--large product-family__title">' + t.name + "</h3>" + n + "</div>"
                        }
                        $family = e(i), s.methods.json_collection.sortByTopColor($family), e(o).append($family)
                    },
                    renderFirstFamily: function(t, o) {
                        var i = "";
                        t.collections.forEach(function(e, t) {
                            e.data && t > 0 && (i += s.methods.json_collection.generateCollectionHTML(e.data))
                        }), $family = e(i), s.methods.json_collection.sortByTopColor($family), e(o).append($family)
                    },
                    renderLastFamily: function(t, o) {
                        var i = "",
                            n = "",
                            a = !0;
                        t.collections.forEach(function(e, t) {
                            e.data && (n += s.methods.json_collection.generateCollectionHTML(e.data, a))
                        }), t.name && t.name.length > 0 && (i = '<div class="product-family"><h3 class="t-heading--large product-family__title header-with-dropdown">' + t.name + '</h3><div class="dropdown-arrow dropdown-breaker"></div>' + n + "</div>"), $family = e(i), s.methods.json_collection.sortByTopColor($family), e(o).append($family)
                    },
                    generateProductTile: function(e, t, o) {
                        var i = "promote",
                            n = "topColor",
                            a = e.tags && e.tags.indexOf(i) >= 0,
                            r = e.tags && e.tags.indexOf(n) >= 0,
                            d = s.methods.json_collection.getProductSizes(e);
                        "Gift Card" === e.type && d.push("gift-card"), a && d.push(i), a || "Gift Card" === e.type || window.productTypes.indexOf(e.type) !== -1 || window.productTypes.push(e.type);
                        var l = "",
                            c = "";
                        r && (c = "collection-grid__item--top-color");
                        var _ = s.methods.json_collection.getProductOutOfStockSizes(e);
                        if (s.methods.json_collection.getProductColors(e).map(function(e) {
                                d.push(e), window.usedColorBuckets.indexOf(e) == -1 && window.usedColorBuckets.push(e)
                            }), e.available) {
                            if (e.tags.length > 0) {
                                var u = e.tags.filter(function(e) {
                                    return e.indexOf("__label: ") != -1
                                });
                                u.length > 0 && (l = u.pop().replace("__label: ", ""))
                            }
                        } else l = "Sold Out";
                        return s.methods.json_collection.generateTile(e, d, _, l, c, t, o)
                    },
                    generateTile: function(e, t, i, n, a, s, r) {
                        var d = "";
                        o && (d = '<span class="collection-grid__item-tag--more-colors" data-category="' + window.TLTemplateName + '" data-track="nft" data-label="Product Panel ' + e.title + '"><span class="tl-button tl-button--centered tl-button--label">See more colors</span></span>');
                        var l = 'data-srcset="' + e.image_150x + " 150w, " + e.image_250x + " 250w, " + e.image_300x + " 300w, " + e.image_400x + " 400w, " + e.image_500x + " 500w, " + e.image_600x + ' 600w"';
                        a = a || "";
                        var c = ' data-sizes="(max-width: 320px) 150px, (max-width: 600px) 250px,(max-width: 768px) 300px,(max-width: 1024px) 250px, (max-width: 1440px) 315px, 400px"';
                        return '<div class="collection-grid__item ' + a + '" data-filters="' + t.toString() + '" data-item-type="' + e.type + '" data-out-of-stock-sizes="' + i.toString() + '" data-item-name="' + e.title.toLowerCase() + '" data-collection="' + s + '" data-order="' + r + '">            <a class="t-link collection-grid__item-link" href="' + e.url + '">' + ("" !== n ? '<div class="collection-grid__item-tag" data-category="' + window.TLTemplateName + '" data-track="nft" data-label="Product Panel ' + e.title + '">' + n + "</div>" : "") + d + '              <img class="collection-grid__product-image lazyload "                 src="' + e.image_150x + '"                 data-src="' + e.image + '" ' + l + c + '" data-category="' + window.TLTemplateName + '"                data-track="nft"                 data-label="Product Panel ' + e.title + '"                alt="' + e.title + '">              <button class="tl-quick-view quick-view-large"                data-category="' + window.TLTemplateName + '"                data-track="nft"                data-label="Quick View ' + e.title + '"                data-product-id="' + e.id + '"                data-product-handle="' + e.handle + '"><span class="quick-view-large__icon"></span>Quick View</button>               <span class="tl-quick-view collection-grid__item-tag--quick-view"                data-category="' + window.TLTemplateName + '"                data-track="nft"                data-label="Quick View ' + e.title + '"                data-product-id="' + e.id + '"                data-product-handle="' + e.handle + '"></span>              <div class="collection-grid__product-details">                <p class="collection-grid__product-title collection-grid__product-title--no-deco t-heading--small"                   data-category="' + window.TLTemplateName + '"                   data-track="nft"                   data-label="Product Panel ' + e.title + '">' + e.title + "</p>              </div>            </a>          </div>"
                    },
                    getProductSizes: function(e) {
                        return e.variants.map(function(e) {
                            return e.option2.replace(l, "").trim()
                        })
                    },
                    getProductOutOfStockSizes: function(e) {
                        return e.variants.filter(function(e) {
                            return e.inventory_quantity <= t
                        }).map(function(e) {
                            return e.option2.replace(l, "").trim()
                        })
                    },
                    getProductColors: function(t) {
                        var o = colorToHexMap[t.color],
                            i = [];
                        return e.each(colorBucketMap, function(e) {
                            colorBucketMap[e].relatedColors.indexOf(o) !== -1 && i.push(e)
                        }), i
                    },
                    generateProductPrice: function(e) {
                        if (e.compare_at_price.length > 0) {
                            var t = parseInt(e.compare_at_price.slice(1), 10),
                                o = parseInt(e.price.slice(1), 10),
                                i = t > o ? ' <span class="discount-phrase">(Save $' + (t - o) + ")</span>" : "";
                            return "true" === e.wardrobe ? '<p class="t-price">' + e.price + " for 3 bras" + i + "</p>" : '<p class="t-price"><span class="strike">' + e.compare_at_price + '</span><span class="sale">' + e.price + "</span></p>"
                        }
                        return e.discount_phrase && e.discount_phrase.length > 0 && e.tags.indexOf("quantity-discount") != -1 ? '<p class="t-price"> ' + e.price + ' or <span class="discount-phrase">' + e.discount_phrase + "</span></p>" : '<p class="t-price">' + e.price + "</p>"
                    },
                    generateReviewHTML: function(e) {
                        var t = [],
                            o = e.review_average.split("."),
                            i = e.review_count,
                            n = '<span class="review-stars__star"></span>',
                            a = '<span class="review-stars__star review-stars__star--half-star"></span>',
                            s = parseInt(o.shift()),
                            r = parseInt(o.shift());
                        if (i.length > 0) {
                            t.push('<p class="t-heading--small reviews-count">'), t.push('<span class="review-stars">');
                            for (var d = 0; d < s; d++) t.push(n);
                            r > 0 && t.push(a), t.push("</span>"), t.push(" " + i + " reviews</p>")
                        }
                        return t.join("\n")
                    },
                    handle_load: function() {
                        window.collectionDataPrefetched ? s.methods.json_collection.fetchOthersInSizeCollection().then(function() {
                            s.methods.json_collection.handle_render()
                        }) : s.methods.json_collection.fetchCollections(window.TLProductData, "collection.loaded_all_collections")
                    },
                    setup_filter_option_change: function() {
                        e(".filter-option__input").change(function() {
                            var t = e(this),
                                o = t.data("filter-type"),
                                i = t.val(),
                                n = t.data("bra-size-type");
                            n === r && s.methods.json_filters.toggleDesktopCupSizeFilters();
                            var a = t.prop("checked");
                            if (n) {
                                var l = n === r ? d : r,
                                    c = e('.filter-option__input[data-bra-size-type="' + l + '"]:checked').map(function() {
                                        var t = e(this).val();
                                        return n === r ? i + t : t + i
                                    }).toArray();
                                a ? c.forEach(function(e) {
                                    s.methods.json_filters.addFilter(e, o, n)
                                }) : c.forEach(function(e) {
                                    s.methods.json_filters.removeFilter(e, o, n)
                                })
                            } else a ? s.methods.json_filters.addFilter(i, o) : s.methods.json_filters.removeFilter(i, o);
                            if (a) {
                                var _ = "";
                                n ? _ = n.charAt(0).toUpperCase() + n.slice(1) + " Size" : "size" === o ? _ = "Bra Size" : "color" === o && (_ = "Color"), window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                                    event: "Product Filter Selected",
                                    label: _ + " Filter Selected",
                                    "event_data.category": "Product Filters",
                                    "event_data.value": i
                                })
                            } else s.methods.json_filters.storeAllSelectedFilters(o, n)
                        })
                    },
                    sortByTopColor: function(t) {
                        o && t.each(function() {
                            e(this).find(".collection-grid__item").not(".collection-grid__item--top-color, .collection-grid__item--hero-image").detach().appendTo(e(this).find(".collection-grid__container"))
                        })
                    },
                    handle_render: function() {
                        window.TLProductData = window.TLProductData.filter(function(e) {
                            if (!e.skip) return e
                        }), e("#collection-loader").hide(), window.quickViewBootstrap && window.quickViewBootstrap.resetHandlers(), window.TLProductData.forEach(function(e, t) {
                            0 === t ? s.methods.json_collection.renderFirstFamily(e, ".collections > .product-family:first-child") : t !== window.TLProductData.length - 1 ? s.methods.json_collection.renderProductFamily(e, "#js-collections") : t === window.TLProductData.length - 1 && s.methods.json_collection.renderLastFamily(e, "#js-collections")
                        }), window.quickViewBootstrap && window.quickViewBootstrap.bootstrap(), c ? s.methods.json_filters.renderMobileFilters(window.availableSizes, window.colorBucketMap, window.usedColorBuckets) : s.methods.json_filters.renderDesktopFilters(window.availableSizes, window.colorBucketMap, window.usedColorBuckets), e(".collection-grid__item-tag--more-colors").hover(function(t) {
                            e(this).parent().find(".collection-grid__product-title").addClass("collection-grid__product-title--no-deco")
                        }, function(t) {
                            e(this).parent().find(".collection-grid__product-title").removeClass("collection-grid__product-title--no-deco")
                        }), setTimeout(lazySizes.init, n), s.methods.json_collection.setup_filter_option_change(), e(s.methods.json_collection).trigger("json-collections-initialized")
                    }
                }
            })
        }), i.on(window.object_name + "._setup_events", function(e, t) {
            t.methods._add("events", {
                "collection.load_product_families": {
                    element: t.elements.collection_area,
                    action: t.methods.json_collection.handle_load
                },
                "collection.loaded_all_collections": {
                    element: t.elements.collection_area,
                    action: t.methods.json_collection.handle_render
                }
            })
        }), i.on(window.object_name + "._document_ready", function(i, n) {
            e(n.elements.collection_area) && window.TLProductData && !window.TLCollectionsManualLoad && n.methods.json_collection.handle_load(), t = window.outOfStockThreshold, o = "collection.bra" === window.TLTemplateName
        })
    }(jQuery),
    function(e) {
        var t = e(window),
            o = t.width() < 1024;
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                yotpo_info: "#yotpo-product-info .yotpo",
                seo_anchor: "#yotpo-product-info",
                reviews_desktop: "#desktop-reviews #review-product-data",
                reviews_mobile: ".js-accordion-reviews #review-product-data"
            })
        }), t.on(window.object_name + ".add_methods", function(t, i) {
            i.methods._add("methods", {
                reviews: {
                    initialize: function() {
                        var e = i.elements.yotpo_info.attr("data-product-id");
                        i.methods.reviews.fetch(e)
                    },
                    fetch: function(t) {
                        var o = "https://api.yotpo.com/v1/widget/KVdCnHjAoKYyjVdydhWLY0pFs7KtrDWoZZinXuvY",
                            n = "/products/" + t + "/reviews.json",
                            a = {
                                per_page: 10,
                                sort: ["date", "votes_up"]
                            };
                        e.get(o + n, a).done(function(e) {
                            e && e.status && 200 == e.status.code && i.methods.reviews.template(t, e.response)
                        })
                    },
                    template: function(e, t) {
                        var o = t.reviews,
                            n = i.elements.yotpo_info.data(),
                            a = o.map(function(e) {
                                return i.methods.reviews.template_seo_reviews(e, n)
                            });
                        window.ProductSEOValues && (window.ProductSEOValues.reviews = a, i.elements.seo_anchor.append('<script type="application/ld+json">' + JSON.stringify(window.ProductSEOValues) + "</script>"))
                    },
                    template_seo_reviews: function(e, t) {
                        var o = {
                            "@context": "http://schema.org/",
                            "@type": "Review",
                            itemReviewed: {
                                url: t.url,
                                image: t.imageUrl,
                                name: t.name
                            },
                            reviewRating: {
                                "@type": "Rating",
                                bestRating: "5",
                                ratingValue: e.score,
                                worstRating: "1"
                            },
                            name: e.title,
                            author: e.user.display_name,
                            reviewBody: e.content
                        };
                        return o
                    },
                    detectYotpoReviewsPluginIsLoaded: function() {
                        var e = o ? i.elements.reviews_mobile : i.elements.reviews_desktop;
                        if (e.length > 0) {
                            var t = 5e3;
                            i.methods.reviews.observeDomMutation(e[0], i.methods.reviews.detectYotpoReviewsPageIsReload, t)
                        }
                    },
                    detectYotpoReviewsPageIsReload: function() {
                        var t;
                        if (t = o ? e(".js-accordion-reviews .yotpo-pager").length > 0 : e("#desktop-reviews .yotpo-pager").length > 0) {
                            var n;
                            n = o ? e(".js-accordion-reviews .yotpo-reviews")[0] : e("#desktop-reviews .yotpo-reviews")[0];
                            var a = 1500;
                            i.methods.reviews.observeDomMutation(n, i.methods.reviews.scrollToFirstReview, a)
                        }
                    },
                    observeDomMutation: function(e, t, o) {
                        var i = {
                                childList: !0
                            },
                            n = function(e) {
                                e.forEach(function(e) {
                                    "childList" == e.type && setTimeout(t, o)
                                })
                            },
                            a = new MutationObserver(n);
                        a.observe(e, i)
                    },
                    scrollToFirstReview: function() {
                        var t;
                        t = o ? i.elements.reviews_mobile.offset().top - 100 : i.elements.reviews_desktop.offset().top - 100, e("html, body").animate({
                            scrollTop: t
                        }, 500)
                    }
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.elements.yotpo_info.length > 0 && window.setTimeout(t.methods.reviews.initialize, 300), t.elements.reviews_desktop.length > 0 && t.methods.reviews.detectYotpoReviewsPluginIsLoaded()
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + "._cache_elements", function(e, t) {
            t.methods._add("elements", {
                _pdp_more_to_see_container: "#more-to-see",
                _pdp_more_to_see: ".more-to-see__carousel"
            })
        }), t.on(window.object_name + ".add_methods", function(t, o) {
            o.methods._add("methods", {
                _pdp_more_to_see: {
                    init: function() {
                        var e = window.TL_MORE_TO_SEE.currentProductType,
                            t = window.TL_MORE_TO_SEE[e] || window.TL_MORE_TO_SEE["default"];
                        o.methods._pdp_more_to_see.fetchProducts(t)
                    },
                    fetchProducts: function(t) {
                        e.get("/collections/" + t + "?view=product-builder-json").then(function(e) {
                            try {
                                var t = JSON.parse(e);
                                o.methods._pdp_more_to_see.handleResults(t.products)
                            } catch (i) {
                                console.error("More-To-See parsing error", i)
                            }
                        }).fail(function(e) {
                            o.elements._pdp_more_to_see_container.hide(), console.error("More-To-See Network error", e)
                        })
                    },
                    selectWhichProduct: function(e) {
                        return e.handles[0]
                    },
                    selectCorrectImage: function(e) {
                        return e[1]
                    },
                    handleResults: function(t) {
                        var i = t.slice(0, 6),
                            n = e.map(i, function(e) {
                                var t = o.methods._pdp_more_to_see.selectWhichProduct(e),
                                    i = o.methods._pdp_more_to_see.selectCorrectImage(e.images[t]),
                                    n = {
                                        id: e.id,
                                        title: e.title,
                                        images: i,
                                        reviewStarsHtml: o.methods._pdp_more_to_see._getReviewStars(e.review_stars),
                                        reviewCount: o.methods._pdp_more_to_see._formattedCount(e.review_count),
                                        handle: t
                                    };
                                return window.TL_MORE_TO_SEE && window.TL_MORE_TO_SEE.showPrices && (n.price = e.price, n.compareAtPrice = e.compare_at_price), o.methods._pdp_more_to_see._sliderItemBuilder(n)
                            });
                        o.elements._pdp_more_to_see.html(n.join("")), window.quickViewBootstrap && window.quickViewBootstrap.reInitialize(), o.elements._pdp_more_to_see.owlCarousel({
                            items: 2,
                            navText: ["R", "r"],
                            mouseDrag: !1,
                            smartSpeed: 300,
                            rewind: !1,
                            responsiveRefreshRate: 1,
                            dots: !0,
                            loadedClass: "owl-carousel owl-theme owl-loaded",
                            stageOuterClass: "owl-stage-outer",
                            stageClass: "owl-stage",
                            lazyLoad: !0,
                            navigation: !0,
                            responsive: {
                                0: {
                                    margin: 12,
                                    slideBy: 2,
                                    nav: !1
                                },
                                768: {
                                    margin: 16,
                                    nav: !0,
                                    dots: !1
                                },
                                1024: {
                                    items: 3,
                                    margin: 16,
                                    nav: !0,
                                    dots: !1
                                }
                            }
                        })
                    },
                    _getReviewStars: function(e) {
                        for (var t = "", o = 1; o < 6; o++) t += e >= o ? '<div class="review-stars__icon review-stars__icon--full"></div>' : e > o - 1 && e < o ? '<div class="review-stars__icon review-stars__icon--half"></div>' : '<div class="review-stars__icon review-stars__icon--empty"></div>';
                        return t
                    },
                    _formattedCount: function(e) {
                        return e.toLocaleString("en")
                    },
                    _sliderItemBuilder: function(e) {
                        var t = window.shop.template,
                            o = "";
                        return e.price && (o = '<div class="more-to-see__price-container">                      <div class="more-to-see__price">' + e.price + "</div>                    </div>"), e.compareAtPrice && e.compareAtPrice.length > 1 && (o = '<div class="more-to-see__price-container">                      <div class="more-to-see__price--compare-at">' + e.compareAtPrice + '</div>                      <div class="more-to-see__price--sale">' + e.price + "</div>                    </div>"), '          <div>          <a class="more-to-see__card"             href="/products/' + e.handle + '"             data-category="' + t + '"             data-track="nft"             data-label="' + e.title + '">             <div class="more-to-see__poster">              <img class="more-to-see__poster lazyload"                 src="' + e.images.src_100 + '"                 data-src="' + e.images.src_300 + '"                 data-srcset="' + e.images.src_300 + " 1x, " + e.images.src_600 + ' 2x "                 alt="' + e.title + '">               <button class="tl-quick-view more-to-see__quick-view-large"                data-category="' + t + '"                data-track="nft"                data-label="Quick View ' + e.title + '"                data-product-id="' + e.id + '"                data-product-handle="' + e.handle + '"><span class="quick-view-large__icon"></span>Quick View</button>              <span class="tl-quick-view more-to-see__quick-view"                 data-category="' + t + '"                 data-track="nft"                 data-label="Quick View ' + e.title + '"                 data-product-id="' + e.id + '"                   data-product-handle="' + e.handle + '"></span>             </div>            <div class="more-to-see__info">              <div class="more-to-see__product">' + e.title + '</div>              <div class="more-to-see__price-review-container">                ' + o + '                <div class="more-to-see__stars">' + e.reviewStarsHtml + '</div>                <div class="more-to-see__count">(' + e.reviewCount + ")</div>              </div>            </div>            </a>        </div>";
                    }
                }
            })
        }), t.on(window.object_name + "._document_ready", function(e, t) {
            t.elements._pdp_more_to_see_container && t.elements._pdp_more_to_see_container.length > 0 && window.setTimeout(function() {
                t.methods._pdp_more_to_see.init()
            }, 1e3)
        })
    }(jQuery),
    function(e) {
        var t = e(window);
        t.on(window.object_name + ".add_methods", function(o, i) {
            i.methods._add("methods", {
                scrollTo: function(o, n, a) {
                    function s(t, o) {
                        e("html, body").animate({
                            scrollTop: t.offset().top - e(".nav-holder .contain").height()
                        }, o, "swing")
                    }

                    function r(t, o, i) {
                        e(t).click(function(t) {
                            t.stopPropagation(), s(e(o), i)
                        })
                    }
                    a = a || 0, i.properties.document_ready_already_called ? r(o, n, a) : t.on(window.object_name + "._document_ready", function() {
                        r(o, n, a)
                    })
                }
            })
        })
    }(jQuery),
    function(e) {
        window[window.object_name] = {
            initialize: function() {
                o.trigger(window.object_name + "._initialize", t), o.trigger(window.object_name + ".add_methods", t), window.addEventListener("DOMContentLoaded", function() {
                    t.document_ready()
                }), document && ["complete", "interactive", "loaded"].indexOf(document.readyState) > -1 && t.document_ready()
            },
            elements: {},
            properties: {},
            methods: {
                _add: function(e, o) {
                    jQuery.extend(!0, t[e], o)
                },
                _setup_events: function(e) {
                    for (var t in e)
                        if (e.hasOwnProperty(t)) {
                            var o = "undefined" != typeof e[t].event ? e[t].event : t;
                            e[t].data ? e[t].element.on(o, e[t].data, e[t].action) : e[t].element.on(o, e[t].action)
                        }
                },
                _remove_events: function(e) {
                    for (var t in e)
                        if (e.hasOwnProperty(t)) {
                            var o = "undefined" != typeof e[t].event ? e[t].event : t;
                            e[t].element.off(o)
                        }
                },
                _cache_elements: function(t) {
                    for (var o in t) t[o] = e(t[o])
                },
                vendors: {}
            },
            events: {},
            document_ready: function() {
                t.properties.document_ready_already_called || (t.properties.document_ready_already_called = !0, window.setTimeout(function() {
                    o.trigger(window.object_name + "._cache_elements", t), t.methods._cache_elements(t.elements)
                }, 20), window.setTimeout(function() {
                    o.trigger(window.object_name + "._setup_events", t), t.methods._setup_events(t.events)
                }, 40), window.setTimeout(function() {
                    t.elements.window.trigger(window.object_name + "._document_ready", t)
                }, 60))
            }
        };
        var t = window[window.object_name],
            o = e(window);
        t.initialize()
    }(jQuery);